/**
 * Every printed attack in the paper and pocket catalogs, and the hit animation it plays.
 * Lookup folds case, accents, and punctuation, so "Double-Edge" and "double edge" match.
 */

export type AttackHitStyle =
	| 'impact' | 'slash' | 'barrage' | 'beam' | 'flame' | 'torrent'
	| 'bolt' | 'zap' | 'bloom' | 'pulse' | 'quake' | 'veil' | 'shard'
	| 'sparkle' | 'roar' | 'whirl' | 'drain'
	| 'frost' | 'stream' | 'sting' | 'powder' | 'wave' | 'petal' | 'bite'
	| 'bubble' | 'sonic' | 'mud' | 'wrap' | 'note' | 'aura' | 'drill'
	| 'acid' | 'wisp' | 'meteor' | 'wing'
	| 'swift' | 'gold' | 'daze' | 'sand' | 'lick' | 'bone' | 'ink' | 'tri' | 'fist' | 'shade'
	| 'kick' | 'chop' | 'rage' | 'shell' | 'kiss' | 'gyro' | 'breath' | 'cannon' | 'fall' | 'iron'
	| 'boom' | 'web' | 'tail' | 'arrow' | 'sleep' | 'shield';

export const ATTACK_HIT: { [name: string]: AttackHitStyle } = {
	"2-Step": "veil",
	"3-D Attack": "impact",
	"3-Pronged Tail": "tail",
	"A Cappella": "note",
	"Abnormal Overheating": "stream",
	"Abrupt Flash": "sparkle",
	"Absolute Snow": "frost",
	"Absorb": "drain",
	"Absorb Life": "drain",
	"Absorb Vitality": "drain",
	"Absorption-GX": "drain",
	"Abundant Harvest": "quake",
	"Abyss Eye": "daze",
	"Abyss Seeking": "roar",
	"Abyssal Drop": "quake",
	"Abyssal Flames": "flame",
	"Abyssal Sleep": "sleep",
	"Accelerate": "shard",
	"Accelerating Spin": "whirl",
	"Accelerating Stab": "slash",
	"Acceleration Bolt": "bolt",
	"Acceleration Drive": "roar",
	"Accelerative Dive": "torrent",
	"Accelerator Flash": "sparkle",
	"Accelerock": "meteor",
	"Ace Spark": "bolt",
	"Acid": "acid",
	"Acid Spray": "acid",
	"Acidic Drain": "acid",
	"Acidic Mucus": "acid",
	"Acidic Poison": "acid",
	"Acidic Spit": "acid",
	"Acme of Heroism-GX": "quake",
	"Acrobatics": "whirl",
	"Act Cute": "impact",
	"Act Tough": "impact",
	"Acu-Punch-Ture": "fist",
	"Adamantine Press": "impact",
	"Adamantine Rolling": "gyro",
	"Add-a-Dash": "impact",
	"Add On": "impact",
	"Addictive Pollen": "powder",
	"Adjusted Horn": "drill",
	"Adornment": "pulse",
	"Adrena-Tackle": "impact",
	"Adrenalash": "impact",
	"Adrenaline Hammer": "fist",
	"Advanced Armor": "shield",
	"Adventuring Together": "bolt",
	"Adversity Jaws": "bite",
	"Aerial Ace": "wing",
	"Aerial Maneuvers": "whirl",
	"Aero Ball": "aura",
	"Aero Blitz": "impact",
	"Aero Chase": "impact",
	"Aero Dive": "torrent",
	"Aero Fall": "impact",
	"Aero Force": "impact",
	"Aero Turn": "quake",
	"Aero Unit-GX": "roar",
	"Aeroblast": "boom",
	"Aeroscream": "impact",
	"Aerowing": "wing",
	"Afterimage Assault": "bloom",
	"Afterimage Strike": "impact",
	"Aftermath": "pulse",
	"Afternoon Nap": "sleep",
	"Agility": "whirl",
	"Aimed Cut": "slash",
	"Air Crash": "impact",
	"Air Cutter": "slash",
	"Air Scroll": "impact",
	"Air Slash": "slash",
	"Alert": "bloom",
	"Alert Headbutt": "impact",
	"Algorithm-GX": "shard",
	"All Cells Burn": "flame",
	"All Out": "pulse",
	"All-Out Attack": "quake",
	"All-out Blast": "boom",
	"All-Out Shot": "cannon",
	"All the Presents": "torrent",
	"All You Can Eat": "bolt",
	"All-You-Can-Grab": "shard",
	"All-You-Can-Yeet": "pulse",
	"Allergic Explosion-GX": "boom",
	"Allergic Shock": "bolt",
	"Allergy Storm": "whirl",
	"Allotment": "quake",
	"Alloy Aswing": "pulse",
	"Alloyed Hammer": "fist",
	"Allure": "pulse",
	"Alluring Dance": "whirl",
	"Alluring Fireball": "flame",
	"Alluring Kiss": "kiss",
	"Alluring Smile": "pulse",
	"Almost Flight": "whirl",
	"Alolan Club": "pulse",
	"Altered Creation-GX": "roar",
	"Amass": "roar",
	"Amazez": "pulse",
	"Amazing Blaze": "flame",
	"Amazing Bloom": "bloom",
	"Amazing Burst": "boom",
	"Amazing Destruction": "boom",
	"Amazing Plea": "impact",
	"Amazing Shield": "shield",
	"Amazing Shot": "cannon",
	"Amazing Star": "swift",
	"Amazing Surge": "torrent",
	"Amazing Sword": "slash",
	"Ambient Noise": "daze",
	"Ambush": "veil",
	"Ambush Bite": "bite",
	"Ambushing Spark": "bolt",
	"Amnesia": "torrent",
	"Amp You Very Much": "bolt",
	"Amping Up": "bolt",
	"Anachronism Repulsor": "flame",
	"Ancestral Memory": "torrent",
	"Anchor Anger": "bloom",
	"Anchor Shot": "cannon",
	"Anchor Smash": "quake",
	"Ancient Blast": "boom",
	"Ancient Freeze": "frost",
	"Ancient Imprint": "drain",
	"Ancient Mantra": "quake",
	"Ancient Power": "meteor",
	"Ancient Seaweed": "torrent",
	"Ancient Star": "swift",
	"Ancient Whirlpool": "torrent",
	"Angelite": "pulse",
	"Anger": "quake",
	"Anger Revenge": "shard",
	"Angry Fang": "bite",
	"Angry Grudge": "quake",
	"Angry Horn": "drill",
	"Angry Slam": "impact",
	"Angry Whack": "impact",
	"Anguish Cry": "veil",
	"Annihilating Anchor": "bloom",
	"Antigravity": "shard",
	"Antique Collecting": "pulse",
	"Antique Magic": "drain",
	"Antler Swipe": "impact",
	"Apex Dragon": "roar",
	"Apply Gel": "torrent",
	"Apply Oil": "bloom",
	"Aqua Beam": "beam",
	"Aqua Blade": "slash",
	"Aqua Blast": "torrent",
	"Aqua Bolt": "torrent",
	"Aqua Bomb": "torrent",
	"Aqua Boomerang": "torrent",
	"Aqua Bullet": "torrent",
	"Aqua Burst": "torrent",
	"Aqua Call": "torrent",
	"Aqua Cannon": "torrent",
	"Aqua Crush": "torrent",
	"Aqua Diffuser": "torrent",
	"Aqua Dive": "torrent",
	"Aqua Edge": "torrent",
	"Aqua Flower": "torrent",
	"Aqua Horn": "torrent",
	"Aqua Impact": "torrent",
	"Aqua Jet": "torrent",
	"Aqua Launcher": "torrent",
	"Aqua Liner": "torrent",
	"Aqua Press": "torrent",
	"Aqua Pump": "torrent",
	"Aqua Reflect": "torrent",
	"Aqua Report": "torrent",
	"Aqua Return": "torrent",
	"Aqua Reverse": "torrent",
	"Aqua Ring": "torrent",
	"Aqua Shock": "torrent",
	"Aqua Shower": "torrent",
	"Aqua Slash": "slash",
	"Aqua Smash": "torrent",
	"Aqua Sonic": "sonic",
	"Aqua Spark": "torrent",
	"Aqua Split": "torrent",
	"Aqua Storm": "torrent",
	"Aqua Stream": "stream",
	"Aqua Supply": "torrent",
	"Aqua Swirl": "torrent",
	"Aqua Tail": "wave",
	"Aqua Trance": "torrent",
	"Aqua Trick": "torrent",
	"Aqua Trip": "torrent",
	"Aqua Turbo": "torrent",
	"Aqua Typhoon": "torrent",
	"Aqua Wash": "torrent",
	"Aqua Wave": "torrent",
	"Aquabomb": "impact",
	"Aquafall": "torrent",
	"Aquamarine": "torrent",
	"Aquatic Rescue": "torrent",
	"Argent Wing": "wing",
	"Arm Charge": "impact",
	"Arm Press": "impact",
	"Arm Thrust": "barrage",
	"Arm Thrust Needle": "barrage",
	"Armor Cannon": "cannon",
	"Armor Press": "shield",
	"Armor Up": "shield",
	"Aroma Shot": "powder",
	"Aromatherapy": "drain",
	"Aromatic Stomps": "impact",
	"Aromax": "drain",
	"Arrogant Impact": "impact",
	"Ascension": "veil",
	"Assassin Flight": "whirl",
	"Assassin's Magic": "pulse",
	"Assassin's Return": "veil",
	"Assassin's Rose": "bloom",
	"Assault Boom": "boom",
	"Assault Gate": "veil",
	"Assault Landing": "impact",
	"Assault Laser": "beam",
	"Assault Sword": "slash",
	"Assault Tackle": "impact",
	"Assaulting Kick": "kick",
	"Assembly-GX": "shard",
	"Assist": "veil",
	"Assisting Flame": "flame",
	"Assisting Heater": "flame",
	"Assisting Spark": "bolt",
	"Assurance": "quake",
	"Astonish": "pulse",
	"Astral Barrage": "barrage",
	"Astral Misfortune": "shard",
	"Attach": "bloom",
	"Attach Leaves": "bloom",
	"Attack and Hide": "drain",
	"Attack Command": "torrent",
	"Attack from Behind": "veil",
	"Attack Operation": "flame",
	"Attack Order": "bloom",
	"Attack the Wound": "bolt",
	"Attract": "kiss",
	"Attract Current": "kiss",
	"Attract Smack": "kiss",
	"Attraction Wave": "torrent",
	"Aura Break": "quake",
	"Aura Burn": "flame",
	"Aura Jab": "quake",
	"Aura Knuckle": "fist",
	"Aura of the Land": "shard",
	"Aura Sphere": "aura",
	"Aura Sphere Volley": "aura",
	"Aura Star": "swift",
	"Aura Strike": "impact",
	"Aura Uppercut": "fist",
	"Aurora Beam": "beam",
	"Aurora Gain": "frost",
	"Aurora Horns": "frost",
	"Aurora Loop": "frost",
	"Aurora Wave": "frost",
	"Auspicious Tone": "pulse",
	"Auto Fire": "flame",
	"Avalanche": "fall",
	"Avenge": "drain",
	"Avenging Billow": "torrent",
	"Avenging Edge": "slash",
	"Avenging Heart": "impact",
	"Avenging Knuckle": "fist",
	"Axe Blast": "slash",
	"Axe Break": "slash",
	"Axe Slash": "slash",
	"Axe Slugger": "slash",
	"B Cancel": "veil",
	"Baby-Doll Eyes": "daze",
	"Baby Outing": "impact",
	"Baby Steps": "bolt",
	"Back Burner": "flame",
	"Back Draft": "flame",
	"Backfire": "flame",
	"Backflip": "quake",
	"Backspin": "shard",
	"Backward Belt Throw": "quake",
	"Bad Brawl": "veil",
	"Bad Dream": "pulse",
	"Bad Fangs": "bite",
	"Bad-Influence Evolution": "quake",
	"Bad News": "veil",
	"Bad Temper": "impact",
	"Bag Slash": "slash",
	"Bail Out": "bloom",
	"Balance Bind": "wrap",
	"Baleful Night": "veil",
	"Baleful Wind": "whirl",
	"Ball Juggling": "aura",
	"Ball of Flame": "flame",
	"Ball Roll": "gyro",
	"Ballistic Beak": "impact",
	"Ballon Attack": "impact",
	"Balloon Barrage": "barrage",
	"Balloon Blast": "boom",
	"Balloon Bomb": "boom",
	"Balloon Burst": "boom",
	"Balloon Strike": "impact",
	"Balloon Tackle": "impact",
	"Band Attack": "bloom",
	"Bandit's Fist": "fist",
	"Baneful Boom": "boom",
	"Bang Boom Chain": "boom",
	"Bang Heads": "torrent",
	"Bared Fangs": "bite",
	"Barite Jail": "drain",
	"Barrage O'Clock": "barrage",
	"Barreling Blitz-GX": "impact",
	"Barrier": "shield",
	"Barrier Attack": "shield",
	"Barrier Break": "shield",
	"Barrier Shove": "shield",
	"Baryon Beam": "beam",
	"Bash In": "impact",
	"Basket Crash": "impact",
	"Bass Control": "impact",
	"Baton Pass": "bloom",
	"Battle Blast": "boom",
	"Battle Claw": "slash",
	"Battle Frenzy": "impact",
	"Battle Legion": "shard",
	"Battle Step": "quake",
	"Bawl": "impact",
	"Bay Dance": "whirl",
	"Be Prepared": "impact",
	"Beacon": "torrent",
	"Beak Blast": "boom",
	"Beak Catch": "impact",
	"Beam": "beam",
	"Bear Hug": "impact",
	"Beast Game-GX": "bloom",
	"Beast Raid": "pulse",
	"Beastly Fang": "bite",
	"Beat": "impact",
	"Beat Punk": "impact",
	"Beat Slider": "impact",
	"Beat Up": "impact",
	"Beatdown": "impact",
	"Beatdown Smash": "quake",
	"Beauty-GX": "bloom",
	"Bebop Punch": "fist",
	"Beckon": "torrent",
	"Bedrock Breaker": "meteor",
	"Bedrock Press": "meteor",
	"Bedrock Shake": "meteor",
	"Bee Drain": "drain",
	"Bee March": "bloom",
	"Bee Powder": "powder",
	"Bee Revenge": "bloom",
	"Beginning Bolt": "bolt",
	"Behemoth Blade": "slash",
	"Bell of Silence": "pulse",
	"Bellow": "bolt",
	"Bellowing Thunder": "bolt",
	"Belly Drum": "drain",
	"Bellyful of Milk": "drain",
	"Beloved Pulse": "pulse",
	"Below Zero": "torrent",
	"Belt": "torrent",
	"Bemusing Aroma": "powder",
	"Bench Manipulation": "pulse",
	"Bend": "pulse",
	"Berry Picking": "bloom",
	"Berry Scent": "powder",
	"Berry Search": "veil",
	"Berserk": "impact",
	"Berserker Blade": "slash",
	"Berserker Splash": "torrent",
	"Berserker Tackle": "impact",
	"Beset": "torrent",
	"Best Dance": "whirl",
	"Best Dash": "impact",
	"Best Punch": "fist",
	"Bewitching Eyes": "daze",
	"Bi-Blast": "boom",
	"Bide": "bloom",
	"Big Bang Arm": "veil",
	"Big Bang Horn": "drill",
	"Big Beat": "impact",
	"Big Bite": "bite",
	"Big Charge": "impact",
	"Big Chorus": "torrent",
	"Big Counter": "impact",
	"Big Cut": "slash",
	"Big Eater-GX": "bite",
	"Big Eggsplosion": "bloom",
	"Big Explosion": "boom",
	"Big Growth": "bloom",
	"Big Hammer": "fist",
	"Big Hand": "quake",
	"Big Mouth": "torrent",
	"Big Ol' Bite": "bite",
	"Big Sand Cannon": "sand",
	"Big Sparking": "bolt",
	"Big Storm": "whirl",
	"Big Swing": "impact",
	"Big Throw": "quake",
	"Big Throw-GX": "quake",
	"Big Tusk": "torrent",
	"Big Wheel-GX": "impact",
	"Big Yawn": "sleep",
	"BikaBika": "bolt",
	"Billowing Heat Wave": "stream",
	"Binary Thunder": "bolt",
	"Bind": "wrap",
	"Bind Down": "wrap",
	"Bind Pulse": "wrap",
	"Bind Wound": "wrap",
	"Binding Greed": "bloom",
	"Binding Snow": "frost",
	"Biosmog": "pulse",
	"Birthday Surprise": "bolt",
	"Bite": "bite",
	"Bite and Crush": "bite",
	"Bite and Escape": "bite",
	"Bite and Run": "bite",
	"Bite Away": "bite",
	"Bite Off": "bite",
	"Bite On": "bite",
	"Bite Together": "bite",
	"Biting Fang": "bite",
	"Black Ballista": "roar",
	"Black Blaze Slash": "slash",
	"Black Cry": "veil",
	"Black Fang": "bite",
	"Black Fire": "flame",
	"Black Flame": "flame",
	"Black Frost": "frost",
	"Black Lance": "veil",
	"Black Magic": "pulse",
	"Black Metal": "shard",
	"Black Ray-GX": "beam",
	"Black Soot": "flame",
	"Black Suction Cups": "bolt",
	"Blade Arms": "slash",
	"Blade-GX": "slash",
	"Blast Burn": "flame",
	"Blast Geyser": "boom",
	"Blaster-GX": "boom",
	"Blasting Hammer": "fist",
	"Blasting Tackle": "impact",
	"Blasting Wind": "whirl",
	"Blaze": "flame",
	"Blaze Ball": "flame",
	"Blaze Blast": "flame",
	"Blaze Blitz": "flame",
	"Blaze Dash": "flame",
	"Blaze Kick": "kick",
	"Blaze Out-GX": "flame",
	"Blaze Roar": "sonic",
	"Blaze Tackle": "flame",
	"Blaze Up": "flame",
	"Blazer": "flame",
	"Blazing Beatdown": "impact",
	"Blazing Burst": "boom",
	"Blazing Charge": "impact",
	"Blazing Claws": "slash",
	"Blazing Destruction": "boom",
	"Blazing Flight": "whirl",
	"Blazing Shout": "flame",
	"Bleh": "pulse",
	"Blend Pollen": "powder",
	"Blessed Burn": "flame",
	"Blessed Fruit": "drain",
	"Blessed Wings": "wing",
	"Blessing of Fluff": "bloom",
	"Blind": "veil",
	"Blind Scratch": "slash",
	"Blinding Beam": "beam",
	"Blinding Ink": "torrent",
	"Blinding Light": "sparkle",
	"Blinding Scythe": "bloom",
	"Blindside": "drain",
	"Blissful Blast": "boom",
	"Blizzard": "frost",
	"Blizzard Bind": "frost",
	"Blizzard Burn": "flame",
	"Blizzard Burst": "frost",
	"Blizzard Edge": "frost",
	"Blizzard Loop": "frost",
	"Blizzard Rondo": "frost",
	"Blizzlock": "torrent",
	"Block": "impact",
	"Block Hammer": "fist",
	"Block Signal": "shard",
	"Block Slider": "torrent",
	"Blockade": "bloom",
	"Blockface": "torrent",
	"Blocking Punch": "fist",
	"Blocking Shell": "shell",
	"Blocking Stomp": "impact",
	"Blood Fang": "bite",
	"Blood Moon": "sparkle",
	"Bloom Buster": "bloom",
	"Bloom Powder": "powder",
	"Bloomshine": "bloom",
	"Blossom Tail": "tail",
	"Blot": "bloom",
	"Blow Through": "impact",
	"Blowing Wind": "wing",
	"Blown Kiss": "kiss",
	"Blubbering": "quake",
	"Blue Fire": "flame",
	"Blue Flare": "breath",
	"Blue Surge-GX": "torrent",
	"Blustery Wind": "whirl",
	"Body Bolt": "bolt",
	"Body Press": "impact",
	"Body Slam": "impact",
	"Body Splash": "torrent",
	"Body Surf": "wave",
	"Boiled Press": "impact",
	"Boiling Impact": "impact",
	"Boing Boing Tail": "tail",
	"Bolt Storm": "bolt",
	"Bolt Strike": "bolt",
	"Boltsplosion": "flame",
	"Bomb Risk": "boom",
	"Bombast": "veil",
	"Bone Attack": "bone",
	"Bone Beatdown": "bone",
	"Bone Block": "bone",
	"Bone Drop": "bone",
	"Bone Impact": "bone",
	"Bone Lock": "bone",
	"Bone Revenge": "bone",
	"Bone Rush": "bone",
	"Bone Shot": "bone",
	"Bone Smash": "bone",
	"Bone Sniper": "bone",
	"Bone Throw": "bone",
	"Bone Vengeance": "bone",
	"Bone Windmill": "bone",
	"Bonemerang": "bone",
	"Bonfire": "flame",
	"Bonus Leaf": "bloom",
	"Boo-Hoo": "bloom",
	"Boomburst": "sonic",
	"Boomburst-GX": "sonic",
	"Boomerang Lariat": "impact",
	"Booming Roar": "sonic",
	"Booming Thunder": "bolt",
	"– Boost": "bolt",
	"Boost Claw": "slash",
	"Boost Dash": "impact",
	"Boost Fang": "bite",
	"Boosted Voltage": "bolt",
	"Bop ’n’ Burrow": "impact",
	"Borne Ashore": "torrent",
	"Boss Headbutt": "impact",
	"Bother": "pulse",
	"Bothering Wave": "torrent",
	"Bouffant Head": "impact",
	"Boulder Crush": "impact",
	"Boulder Storm": "whirl",
	"Bounce": "torrent",
	"Bounce Back": "shard",
	"Bounce Off": "shard",
	"Bouncing Ball": "aura",
	"Bouncy Move": "bloom",
	"Bound Crush": "impact",
	"Bounding Bite": "bite",
	"Boundless Power": "impact",
	"Bowed Whip": "slash",
	"Box of Surprises": "drain",
	"Boyfriends": "bloom",
	"Brain Control": "pulse",
	"Brain Crush": "impact",
	"Brain Shake": "pulse",
	"Brainwave": "bloom",
	"Branch Calculation": "impact",
	"Branch Poke": "bloom",
	"Brass Rock": "meteor",
	"Brat Snack": "roar",
	"Brave Bird": "wing",
	"Brave Blade": "slash",
	"Brave Buddies": "impact",
	"Brave Burn-GX": "flame",
	"Brave Fire": "flame",
	"Brave Heart": "impact",
	"Brave Slash": "slash",
	"Brave Wing": "wing",
	"Brawny Knuckle": "fist",
	"Breaching Lariat": "impact",
	"Break Beam": "beam",
	"Break Burn": "flame",
	"Break Buster-GX": "shard",
	"Break Edge": "slash",
	"Break Ground": "quake",
	"Break Open": "torrent",
	"Break Powder": "powder",
	"Break Star": "swift",
	"Break Through": "sparkle",
	"Breakcore": "veil",
	"Breakdown": "drain",
	"Breaker Bazooka": "impact",
	"Breaking Impact": "impact",
	"Breaking Sound": "impact",
	"Breaking Swipe": "roar",
	"Breaking Tail": "tail",
	"Breakthrough Assault": "roar",
	"Breath of Life": "breath",
	"Breeze Away-GX": "bloom",
	"Breeze-By Attack": "bloom",
	"Breezy Gift": "bloom",
	"Brick Break": "chop",
	"Brick Smash": "quake",
	"Bright Beam": "beam",
	"Bright Flame": "flame",
	"Bright Garden": "sparkle",
	"Bright Horns": "drill",
	"Bright Tone": "roar",
	"Bright Wing": "wing",
	"Brighten and Burn": "flame",
	"Brilliant Arrow": "arrow",
	"Brilliant Deduction": "bolt",
	"Brilliant Flare": "flame",
	"Brilliant Search": "sparkle",
	"Brilliant Storm": "whirl",
	"Brilliant Voice": "pulse",
	"Brine": "wave",
	"Bring Down": "torrent",
	"Bring Down the Axe": "slash",
	"Brinicles-GX": "torrent",
	"Bristling Spikes": "shard",
	"Broken-space Blow": "impact",
	"Brush Aside": "quake",
	"Brush Off": "quake",
	"Brushfire": "flame",
	"Brutal Bash": "impact",
	"Brutal Edge": "slash",
	"Brutal Swing": "impact",
	"Bubble": "bubble",
	"Bubble Beam": "bubble",
	"Bubble Beat": "bubble",
	"Bubble Bomb": "bubble",
	"Bubble Drain": "bubble",
	"Bubble Hold": "bubble",
	"Bubble Jump": "bubble",
	"Bubble Jutsu": "bubble",
	"Bubble Launch": "bubble",
	"Bubble Launcher-GX": "bubble",
	"Bubble Net": "bubble",
	"Bubble Pod": "bubble",
	"Bubble Pump": "bubble",
	"Bubble Shoot": "bubble",
	"Bubble Shower": "bubble",
	"Bubble Trap": "bubble",
	"Bubblebeam": "beam",
	"Bubbles": "torrent",
	"Bubbles Galore": "torrent",
	"Buddy Attack": "pulse",
	"Buddy Blast": "boom",
	"Buddy Bolt": "bolt",
	"Buddy-buddy": "pulse",
	"Buddy Spark": "bolt",
	"Bug Bite": "bite",
	"Bug Buzz": "bloom",
	"Bug Hunch": "bloom",
	"Bug Out": "flame",
	"Bug's Cannon": "cannon",
	"Bug Search": "impact",
	"Buggy Beam": "beam",
	"Bulk Up": "quake",
	"Bulky Bump": "impact",
	"Bull Dash": "impact",
	"Bullet Breakthrough": "cannon",
	"Bullet Punch": "fist",
	"Bullet Seed": "bloom",
	"Bullet Slugger": "cannon",
	"Bullet Straight Punch": "cannon",
	"Bullet Uppercut": "fist",
	"Bundled Pump": "torrent",
	"Bunny Hop": "drain",
	"Buoyant Healing": "drain",
	"Burdensome Bone": "bone",
	"Buried Treasure Hunt": "impact",
	"Burn Away": "flame",
	"Burn Booster": "flame",
	"Burn Down": "flame",
	"Burn It All Up": "flame",
	"Burn Off": "flame",
	"Burn Out": "flame",
	"Burn Up": "flame",
	"Burning Ball": "flame",
	"Burning Bonemerang": "bone",
	"Burning Breath": "flame",
	"Burning Charge": "flame",
	"Burning Claw": "slash",
	"Burning Darkness": "flame",
	"Burning Fang": "flame",
	"Burning Fire": "flame",
	"Burning Flame": "flame",
	"Burning Flare": "flame",
	"Burning Icicles": "flame",
	"Burning Kick": "kick",
	"Burning Licks": "flame",
	"Burning Magma-GX": "flame",
	"Burning Poison": "flame",
	"Burning Roar": "sonic",
	"Burning Rondo": "flame",
	"Burning Run": "flame",
	"Burning Scales": "flame",
	"Burning Scent": "flame",
	"Burning Sensation": "flame",
	"Burning Shot": "flame",
	"Burning Slam-GX": "flame",
	"Burning Sludge": "flame",
	"Burning Tail": "flame",
	"Burning Train": "flame",
	"Burning Turbulence": "flame",
	"Burning Turn": "flame",
	"Burning Venom": "flame",
	"Burning Voice": "flame",
	"Burning Wind": "flame",
	"Burrow": "impact",
	"Burst": "boom",
	"Burst Ball": "boom",
	"Burst Curse": "boom",
	"Burst-GX": "boom",
	"Burst of Braying": "boom",
	"Burst Punch": "boom",
	"Burst Roar": "sonic",
	"Burst Shot": "boom",
	"Burst Wheel": "boom",
	"Bursting Bubble": "bubble",
	"Bursting Burn": "flame",
	"Bursting Hand": "pulse",
	"Bursting Inferno": "flame",
	"Bursting Power": "flame",
	"Bursting Tail": "tail",
	"Buster Purge": "roar",
	"Buster Swing": "impact",
	"Buster Tail": "tail",
	"Bustle": "bolt",
	"But First, Food": "drain",
	"Butterfly Edge": "slash",
	"Buzz Flip": "bolt",
	"Bye-Bye Flight": "whirl",
	"Bye-Bye Heal": "drain",
	"Bye-Bye Throw": "quake",
	"C.O.D.E.: Protect": "shield",
	"Cablegram": "bolt",
	"Cacophony": "impact",
	"Calamitous Slash": "slash",
	"Calamity Blast": "boom",
	"Calamity Storm": "whirl",
	"Calculate": "impact",
	"Calculation": "pulse",
	"Call Back": "drain",
	"Call for Backup": "shard",
	"Call for Family": "impact",
	"Call for Friend": "quake",
	"Call for Friends": "torrent",
	"Call for Goons": "roar",
	"Call for Greatness": "pulse",
	"Call for Pals": "impact",
	"Call for Support": "torrent",
	"Call for the Boss": "veil",
	"Call Forth Cold": "torrent",
	"Call In": "pulse",
	"Call of the Night": "veil",
	"Call Sign": "torrent",
	"Call to Muster": "shard",
	"Call Will-o'-the-wisp": "wisp",
	"Called Shot": "cannon",
	"Calling Wave": "torrent",
	"Callous Wings": "wing",
	"Calm Mind": "pulse",
	"Calm Strike": "impact",
	"Calming Hurricane": "whirl",
	"Calming Wind": "whirl",
	"Cannonball": "impact",
	"Cantankerous Beatdown-GX": "impact",
	"Canyon Axe": "slash",
	"Captivate": "torrent",
	"Captivating Salsa": "flame",
	"Captivating Tail": "tail",
	"Carefree Press": "impact",
	"Careless Head": "impact",
	"Careless Tackle": "impact",
	"Cargo Jet": "impact",
	"Carnelian": "flame",
	"Carry In": "torrent",
	"Carry Off": "impact",
	"Casual Slap": "impact",
	"Cat Fleas": "daze",
	"Cat Kick": "kick",
	"Cat Punch": "fist",
	"Catharsis Roar": "sonic",
	"Caturday": "sleep",
	"Cauterize": "flame",
	"Cavalry Lance": "shard",
	"Cavern Counter": "quake",
	"Cavern Tackle": "impact",
	"Cavernous Chomp": "bite",
	"Ceaseless Spitting": "impact",
	"Celestial Roar": "sonic",
	"Cell Connector": "quake",
	"Cell Culture": "pulse",
	"Cell Fork": "pulse",
	"Cell Spear": "pulse",
	"Cell Storm": "whirl",
	"Cellular Ascension": "pulse",
	"Cellular Evolution": "pulse",
	"Centrifugal Force": "bloom",
	"Chain-Crazed": "veil",
	"Chain Lightning": "bolt",
	"Chain of Spirits": "veil",
	"Chakra Fist": "fist",
	"Chakra Points": "pulse",
	"Challenging Delivery": "impact",
	"Champ Buster": "quake",
	"Champignon's Swing": "impact",
	"Channeling": "pulse",
	"Chaos Crush": "impact",
	"Chaos Wheel": "roar",
	"Chaotic Impact": "impact",
	"Chaotic Noise": "sleep",
	"Chaotic Order-GX": "roar",
	"Char": "flame",
	"Charge": "impact",
	"Charge Beam": "beam",
	"Charge Dash": "impact",
	"Charge Energy": "impact",
	"Charge Order": "impact",
	"Charge Through": "impact",
	"Charge Up": "impact",
	"Charged Web": "web",
	"Charging Horn": "drill",
	"Charismatic Drill": "drill",
	"Charity Tail": "tail",
	"Charm": "sparkle",
	"Charmed Slap": "sparkle",
	"Charming Stamp": "sparkle",
	"Charring Breath": "breath",
	"Chase Order": "bloom",
	"Chase Up": "impact",
	"Chatter": "impact",
	"Cheer On": "drain",
	"Cheer Up": "impact",
	"Cheerful Charge": "impact",
	"Cheerful Singing": "flame",
	"Chemical Breath": "breath",
	"Chemical Panic": "veil",
	"Chemical Scale": "pulse",
	"Chest-ouflage": "pulse",
	"Chew Off": "torrent",
	"Chew Up": "quake",
	"Chi-Atsu": "drain",
	"Child's Punch": "fist",
	"Chili Snapper Bind": "wrap",
	"Chilling Sigh": "sleep",
	"Chilling Wings": "wing",
	"ChillMAX": "torrent",
	"Chilly": "torrent",
	"Chime": "pulse",
	"Chiming Commotion": "pulse",
	"Chip Away": "quake",
	"Chip Off": "shard",
	"Chirp": "impact",
	"Chloroscythe-GX": "bloom",
	"Chlorowhip": "bloom",
	"Chomp": "bite",
	"Chomp Chomp": "bite",
	"Chomp Chomp Bite": "bite",
	"Chomp Chomp Hold": "bite",
	"Chomp Chomp Panic": "bite",
	"Chomp Down": "bite",
	"Chomp Whole": "bite",
	"Chop": "chop",
	"Chop Up": "chop",
	"Chrono Burst": "boom",
	"Chrono Wind": "whirl",
	"Chubby Cheer": "impact",
	"Chuck": "veil",
	"Chuck Away": "veil",
	"Chupi": "bolt",
	"Cinder Cannon": "cannon",
	"Cinnabar Lure": "roar",
	"Circle Circuit": "bolt",
	"Circle Throw": "quake",
	"Circling Dive": "torrent",
	"Circuit Cannon": "cannon",
	"Circular Steps": "torrent",
	"Circus Soaking": "torrent",
	"Clairvoyance": "pulse",
	"Clairvoyant Eye": "daze",
	"Clamp": "torrent",
	"Clamp Crush": "impact",
	"Clamp Splash": "torrent",
	"Clamping Fangs": "bite",
	"Clamping Jaw": "bite",
	"Clanging Scales": "roar",
	"Claw": "slash",
	"Claw Dagger": "slash",
	"Claw of Darkness": "slash",
	"Claw Rend": "slash",
	"Claw Slash": "slash",
	"Claw Swipe": "slash",
	"Clay Blast": "boom",
	"Clay Curse": "veil",
	"Clay Pulse": "pulse",
	"Clean Hit": "impact",
	"Cleaning Up": "impact",
	"Cleanse Away": "drain",
	"Cleansing Ring": "torrent",
	"Clear Search": "torrent",
	"Clear the Room": "bloom",
	"Clear Tone": "pulse",
	"Clear Vision-GX": "pulse",
	"Cleave": "roar",
	"Cliff Crumbler": "quake",
	"Cliff Edge Formation": "slash",
	"Cling": "bloom",
	"Clinging Spore": "powder",
	"Cloak Headbutt": "impact",
	"Cloak in Shadows": "veil",
	"Cloak Party": "bloom",
	"Cloak Scale": "bloom",
	"Cloak Shard": "shard",
	"Clobber": "veil",
	"Clockwork": "shard",
	"Clomp Clomp Clobber": "impact",
	"Close Combat": "fist",
	"Close Encounter": "pulse",
	"Close-Quarters Shooting": "quake",
	"Cluster Bolt": "bolt",
	"Clutch": "impact",
	"Coal Cannon": "cannon",
	"Coal Drop": "quake",
	"Coated Attack": "shard",
	"Coating": "pulse",
	"Coax": "bloom",
	"Cobweb Trip": "web",
	"Cocky Claw": "slash",
	"Cocoon Collector": "bloom",
	"Code Check": "impact",
	"Coffee Break": "drain",
	"Coil": "wrap",
	"Coiling Crush": "impact",
	"Coin Hurl": "gold",
	"Coinciding Figures": "pulse",
	"Cold Breath": "breath",
	"Cold Crush": "impact",
	"Cold Crush-GX": "impact",
	"Cold Cyclone": "whirl",
	"Cold Fire": "flame",
	"Cold Snap": "torrent",
	"Cold Start": "torrent",
	"Cold Tea": "pulse",
	"Collapse": "impact",
	"Collateral Bolts": "drain",
	"Collect": "impact",
	"Collect Fire": "flame",
	"Collude": "veil",
	"Colluding Tentacles": "wrap",
	"Colony Rush": "impact",
	"Color Coordination": "flame",
	"Color Pick": "impact",
	"Color Tag": "drain",
	"Colorful Attack": "veil",
	"Colorful Catch": "impact",
	"Colorful Confection": "pulse",
	"Colorful Friends": "impact",
	"Colorful Graffiti": "veil",
	"Colorful Palette": "impact",
	"Colorful Powder": "powder",
	"Colorful Spores": "powder",
	"Colorful Wind": "whirl",
	"Combat Beak": "quake",
	"Combat Blaze": "flame",
	"Combat Tackle": "impact",
	"Combat Thunder": "bolt",
	"Combo Throw": "barrage",
	"Combustion": "flame",
	"Combustion Blast": "boom",
	"Combustion Chain": "flame",
	"Combustion Impact": "impact",
	"Combustion Pillar": "flame",
	"Come Along": "pulse",
	"Come and Get You": "pulse",
	"Come Here Right Meow": "impact",
	"Comet Punch": "fist",
	"Comet Slap": "impact",
	"Comeuppance": "veil",
	"Command the Grass": "bloom",
	"Commanding Queen": "bloom",
	"Commanding Tail": "tail",
	"Compound Pain": "drain",
	"Concentrated Fire": "flame",
	"Concerto": "bloom",
	"Concoction": "veil",
	"Conduction": "torrent",
	"Conform": "veil",
	"Confounding Cologne": "impact",
	"Confounding Pulse": "pulse",
	"Confront": "shard",
	"Confuse Ray": "daze",
	"Confusion Gas": "powder",
	"Confusion Pulse": "pulse",
	"Confusion Wave": "torrent",
	"Conjoined Beams": "pulse",
	"Constant Rattle": "bloom",
	"Constrict": "wrap",
	"Consume": "roar",
	"Continuous Bite": "bite",
	"Continuous Blaze Ball": "flame",
	"Continuous Charge": "impact",
	"Continuous Coin Toss": "gold",
	"Continuous Crush": "impact",
	"Continuous Eggsplosion": "pulse",
	"Continuous Fireball": "flame",
	"Continuous Gulp Missile": "torrent",
	"Continuous Headbutt": "impact",
	"Continuous Lick": "lick",
	"Continuous Scratch": "slash",
	"Continuous Slap": "impact",
	"Continuous Slash": "slash",
	"Continuous Spin": "whirl",
	"Continuous Steps": "impact",
	"Continuous Tumble": "impact",
	"Controlled Burn": "flame",
	"Conversion 1": "impact",
	"Conversion 2": "impact",
	"Conversion 3": "impact",
	"Conversion 4": "impact",
	"Conversion Powder": "powder",
	"Convert Blow": "impact",
	"Coordinate": "bloom",
	"Coordinated Beatdown": "impact",
	"Coordinated Bolt": "bolt",
	"Coordinated One-Two Punch": "fist",
	"Coordinated Pack": "veil",
	"Coordinated Shuriken": "torrent",
	"Coordinated Strike": "impact",
	"Coordinated Throwing": "wing",
	"Copy": "quake",
	"Copy a Friend": "impact",
	"Copy Anything": "impact",
	"Copycat": "pulse",
	"Coral Glow": "torrent",
	"Core Avenger": "quake",
	"Core Beam": "beam",
	"Core Blast": "boom",
	"Core Cannon": "cannon",
	"Core Enforcer": "roar",
	"Core Flash": "sparkle",
	"Core Heal": "drain",
	"Core Splash": "torrent",
	"Core Stream": "stream",
	"Corkscrew Dive": "torrent",
	"Corkscrew Punch": "fist",
	"Corkscrew Smash": "quake",
	"Corner": "veil",
	"Cornerstone Dance": "whirl",
	"Corona Impact": "impact",
	"Corrode Target": "bloom",
	"Corrosive Acid": "acid",
	"Corrosive Liquid": "torrent",
	"Corrosive Shards": "quake",
	"Corrosive Sludge": "acid",
	"Corrosive Winds": "drain",
	"Coruscating Quartz": "impact",
	"Cosmic Beam": "beam",
	"Cosmic Beatdown": "impact",
	"Cosmic Burn": "flame",
	"Cosmic Circle": "pulse",
	"Cosmic Cyclone": "whirl",
	"Cosmic Draw": "pulse",
	"Cosmic Spin": "whirl",
	"Cosmic Tackle": "impact",
	"Cosmicsplosion": "quake",
	"Cotton Bed": "sparkle",
	"Cotton Cloud": "impact",
	"Cotton Guard": "shield",
	"Cotton Punch": "fist",
	"Cotton Ride": "bloom",
	"Cotton Wings": "wing",
	"Cottonweed Punch": "fist",
	"Count and Draw": "torrent",
	"Counter": "flame",
	"Counter Head": "impact",
	"Counter Jewel": "quake",
	"Counter Press": "impact",
	"Counter Punch": "fist",
	"Countercharge": "drain",
	"Counterturn": "bloom",
	"Counting Song": "note",
	"Courier": "torrent",
	"Covert Flight": "whirl",
	"Covet": "impact",
	"Covetous Ivy": "bloom",
	"Crab Impact": "impact",
	"Crabhammer": "shell",
	"Cracking Stomp": "impact",
	"Cracking Voice": "impact",
	"Crackling Charge": "impact",
	"Crackling Ribbon": "flame",
	"Crackling Shot": "cannon",
	"Crackling Snap": "bolt",
	"Crackly Toss": "quake",
	"Crag Bash": "impact",
	"Cragalanche": "veil",
	"Crane Neck": "impact",
	"Crash Bomber": "impact",
	"Crash Chant": "impact",
	"Crash Impact": "impact",
	"Crashing Bolt": "bolt",
	"Crashing Bullet": "cannon",
	"Crashing Fangs": "bite",
	"Crashing Headbutt": "impact",
	"Crazy Blast": "boom",
	"Crazy Claws": "slash",
	"Crazy Hammer": "fist",
	"Crazy Headbutt": "impact",
	"Crazy Knuckle": "fist",
	"Crazy Slap": "impact",
	"Crazy Spore": "powder",
	"Creep Show": "drain",
	"Creepy-Crawly Congregation": "bloom",
	"Creepy Wind": "whirl",
	"Crescendo Wave": "torrent",
	"Crescent Glow": "pulse",
	"Crescent Purge": "pulse",
	"Crimson Blast": "boom",
	"Crimson Blaster": "boom",
	"Crimson Bull": "impact",
	"Crimson Dive": "torrent",
	"Crimson Edge": "slash",
	"Crimson Flame Pillar-GX": "flame",
	"Crimson Legs": "flame",
	"Crimson Storm": "whirl",
	"Crisis Dive": "torrent",
	"Crisis Punch": "fist",
	"Crisis Vine": "bloom",
	"Critical Bite": "bite",
	"Critical Bloom": "bloom",
	"Critical Collection": "quake",
	"Critical Crush": "impact",
	"Critical Error-GX": "impact",
	"Critical Move": "impact",
	"Critical Scissors": "slash",
	"Critical Slash": "slash",
	"Cross Attack": "bloom",
	"Cross Break-GX": "roar",
	"Cross Breaker": "impact",
	"Cross Chop": "chop",
	"Cross-Cut": "slash",
	"Cross-Cut-GX": "slash",
	"Cross Division-GX": "drain",
	"Cross Fist": "fist",
	"Cross Fusion Strike": "impact",
	"Cross Poison": "veil",
	"Cross Slash": "slash",
	"Cross Slicer": "torrent",
	"Cross Wind": "whirl",
	"Crosscounter": "quake",
	"Crossing Cut-GX": "slash",
	"Crossing Flights": "pulse",
	"Crosswise Whip": "slash",
	"Crown Opal": "impact",
	"Cruel Arrow": "arrow",
	"Cruel Coal": "flame",
	"Cruel Fang": "bite",
	"Cruel Slash": "slash",
	"Cruel Spike": "sting",
	"Crunch": "bite",
	"Crunch-Time Rush": "bite",
	"Crush": "impact",
	"Crush and Burn": "flame",
	"Crush and Burn-GX": "flame",
	"Crush Claw": "slash",
	"Crush Grip": "impact",
	"Crush the Weak": "impact",
	"Crush Volt": "bolt",
	"Crushing Arrow": "arrow",
	"Crushing Beat": "impact",
	"Crushing Blow": "impact",
	"Crushing Claw": "slash",
	"Crushing Earth": "quake",
	"Crushing Flames": "flame",
	"Crushing Headbutt": "impact",
	"Crushing Ice": "frost",
	"Crushing Lava": "flame",
	"Crushing Magma": "flame",
	"Crushing Mantle": "quake",
	"Crushing Press": "impact",
	"Crushing Pulse": "pulse",
	"Crushing Punch": "fist",
	"Crushing Short": "bolt",
	"Crushing Spear": "bloom",
	"Crushing Step": "quake",
	"Crushing Wave": "torrent",
	"Cry for Help": "bloom",
	"Cry of Destruction": "boom",
	"Cryo Mouth": "torrent",
	"Cryofreeze": "frost",
	"Crystal Barrier": "shield",
	"Crystal Beam": "beam",
	"Crystal Breath": "breath",
	"Crystal Fall": "torrent",
	"Crystal Laser": "beam",
	"Crystal Ray": "beam",
	"Crystal Star": "swift",
	"Crystal Waltz": "torrent",
	"Crystal Wave": "torrent",
	"Cure Kernels": "drain",
	"Cure Powder": "powder",
	"Cure Shower-GX": "drain",
	"Cure Stream": "stream",
	"Curiosity": "bolt",
	"Curl Up": "torrent",
	"Curly Ribbon": "sparkle",
	"Curse and Deceive": "veil",
	"Curse Deeply": "veil",
	"Curse of the Blade": "slash",
	"Curse Spreading": "veil",
	"Cursed Drop": "veil",
	"Cursed Edge": "slash",
	"Cursed Jewel": "veil",
	"Cursed Prose": "veil",
	"Cursed Rain": "veil",
	"Cursed Reaction": "veil",
	"Cursed Roots": "veil",
	"Cursed Slug": "veil",
	"Cursed Words": "veil",
	"Cursed Wrath": "veil",
	"Curve Attack": "impact",
	"Curve Strike": "impact",
	"Customized Cane": "torrent",
	"Cut": "slash",
	"Cut Down": "slash",
	"Cut Up": "slash",
	"Cutting Arm": "slash",
	"Cutting Claw": "slash",
	"Cutting Riposte": "slash",
	"Cutting Turn": "slash",
	"Cutting Wind": "slash",
	"Cyber Crush": "impact",
	"Cyber Drive": "roar",
	"Cyber Shock": "bolt",
	"Cyberjack": "impact",
	"Cybernetic Wheels": "shard",
	"Cycle Draw": "pulse",
	"Cyclone Kick": "kick",
	"Cyclone Pincers": "whirl",
	"Cyclone Slash": "slash",
	"Damage Aid": "bloom",
	"Damage Beat": "impact",
	"Damage Blast": "boom",
	"Damage Breakdown": "daze",
	"Damage Burn": "flame",
	"Damage Change": "drain",
	"Damage Collection": "drain",
	"Damage Counterpunch": "flame",
	"Damage Curse": "veil",
	"Damage Even": "drain",
	"Damage Play": "drain",
	"Damage Porter": "drain",
	"Damage Roller": "gyro",
	"Damage Rush": "impact",
	"Damage Shift": "drain",
	"Damage Transport": "drain",
	"Damaging Spark": "bolt",
	"Damagriiigus": "drain",
	"Damakinesis": "drain",
	"Dance Gracefully": "whirl",
	"Dance of Flames": "flame",
	"Dance of the Crowned Sword": "slash",
	"Dance 'til Dawn": "whirl",
	"Dancing Shuriken": "torrent",
	"Dancing Tentacles": "wrap",
	"Dangerous Bite": "bite",
	"Dangerous Blow": "impact",
	"Dangerous Claw": "slash",
	"Dangerous Claws": "slash",
	"Dangerous Concert": "impact",
	"Dangerous Evolution": "acid",
	"Dangerous Head": "impact",
	"Dangerous Incisors": "impact",
	"Dangerous Lick": "lick",
	"Dangerous Mouth": "torrent",
	"Dangerous Nose": "shard",
	"Dangerous Poison": "veil",
	"Dangerous Reaction": "bloom",
	"Dangerous Rogue": "quake",
	"Dangerous Rogue-GX": "quake",
	"Dangerous Spores": "powder",
	"Dangerous Stinger": "pulse",
	"Dangerous Suspicion": "impact",
	"Dangerous Toxwhip": "bloom",
	"Dangerous Wave": "torrent",
	"Dangle Tail": "tail",
	"Daring Strike": "impact",
	"Dark Aid": "veil",
	"Dark Arts": "veil",
	"Dark Awakening": "veil",
	"Dark Bind": "wrap",
	"Dark Binding": "veil",
	"Dark Bite": "bite",
	"Dark Burn": "flame",
	"Dark Burst": "boom",
	"Dark Call-GX": "veil",
	"Dark Clamp": "veil",
	"Dark Cleave": "veil",
	"Dark Corridor": "veil",
	"Dark Cutter": "slash",
	"Dark Destruction": "boom",
	"Dark Drain": "drain",
	"Dark Edge": "slash",
	"Dark Fang": "bite",
	"Dark Feather": "veil",
	"Dark Fire": "flame",
	"Dark Flame": "flame",
	"Dark Flash": "veil",
	"Dark Forest": "veil",
	"Dark Frost": "frost",
	"Dark Guidance": "veil",
	"Dark Hand": "veil",
	"Dark Head": "veil",
	"Dark Hole": "veil",
	"Dark Horn": "drill",
	"Dark Impact": "veil",
	"Dark Link": "veil",
	"Dark Mastery": "veil",
	"Dark Mind": "pulse",
	"Dark Mist-GX": "veil",
	"Dark Moon-GX": "veil",
	"Dark Mountain": "meteor",
	"Dark One-eye": "daze",
	"Dark Penalty": "veil",
	"Dark Poison": "veil",
	"Dark Pressure": "veil",
	"Dark Prism": "veil",
	"Dark Provide": "veil",
	"Dark Pulse": "pulse",
	"Dark Raid": "veil",
	"Dark Resolve": "veil",
	"Dark Ring": "veil",
	"Dark Roar": "sonic",
	"Dark Rush": "veil",
	"Dark Seed": "bloom",
	"Dark Shock": "bolt",
	"Dark Slash": "slash",
	"Dark Slumber": "sleep",
	"Dark Song": "note",
	"Dark Splash": "torrent",
	"Dark Streak": "veil",
	"Dark Strike": "veil",
	"Dark Swirl": "veil",
	"Dark Tentacle": "wrap",
	"Dark Union-GX": "veil",
	"Dark Vengeance": "veil",
	"Dark Void": "veil",
	"Dark Wave": "torrent",
	"Dark Wing Flaps": "veil",
	"Darkest Lariat": "impact",
	"Darkest Tornado-GX": "veil",
	"Darkfall": "veil",
	"Darkness Blade": "slash",
	"Darkness Blast": "boom",
	"Darkness Call": "veil",
	"Darkness Chant": "veil",
	"Darkness Charge": "veil",
	"Darkness Claw": "slash",
	"Darkness Fang": "bite",
	"Darkness Grace": "veil",
	"Darkness Howl": "sonic",
	"Darkness Lost": "veil",
	"Darkness Magic": "veil",
	"Darkness Mist": "veil",
	"Darkness Pursuit": "veil",
	"Darkness Roar": "sonic",
	"Darkness Shield": "shield",
	"Darkness Sleep": "sleep",
	"Darkness Slugger": "veil",
	"Darkness Switch": "veil",
	"Darkness Wing": "veil",
	"Darmani-Hands": "flame",
	"DarMAXitan": "pulse",
	"Daruma Headbutt": "impact",
	"Dash Attack": "impact",
	"Dash Off": "impact",
	"Dashing Kick": "kick",
	"Dashing Punch": "fist",
	"Dastardly Jab": "drain",
	"Data Check": "impact",
	"Data Displacement": "impact",
	"Data Retrieval": "impact",
	"Data Sort": "impact",
	"Daunt": "impact",
	"Daunting Eyes": "daze",
	"Daydream": "pulse",
	"Dazzle Blast": "boom",
	"Dazzle Dance": "sparkle",
	"Dazzling Blizzard": "frost",
	"Dazzling Gleam": "sparkle",
	"Dazzling Pollen": "powder",
	"Dead End-GX": "veil",
	"Dead Wood Detention": "bloom",
	"Deadly Poison": "veil",
	"Deafen": "shard",
	"Deceit": "veil",
	"Deceive": "drain",
	"Deck and Cover": "bloom",
	"Deck Distiller": "quake",
	"Decorate": "pulse",
	"Dede-Circuit": "bolt",
	"Dede-Flash": "sparkle",
	"Dede-Short": "pulse",
	"Deep Balance": "drain",
	"Deep Crush": "impact",
	"Deep Currents": "torrent",
	"Deep Dive": "torrent",
	"Deep Freeze": "frost",
	"Deep Growl": "sonic",
	"Deep Hurricane": "whirl",
	"Deep Impact": "impact",
	"Deep Poison": "veil",
	"Deep Scrap": "quake",
	"Deep Sea Boring": "quake",
	"Deep Sea Pressure": "quake",
	"Deep Sea Search": "torrent",
	"Deep Sea Swirl": "torrent",
	"Deep Squall": "torrent",
	"Deep Wind": "whirl",
	"Defense Curl": "torrent",
	"Defensive Claw": "slash",
	"Defensive Posture": "bloom",
	"Defensive Stance": "drain",
	"Defensive Unit": "shard",
	"Defiant Spark": "bolt",
	"Deflecting Splash": "torrent",
	"Deflector": "bloom",
	"Defog": "torrent",
	"Deleting Glare": "daze",
	"Deleting Slash": "slash",
	"Delicious Egg": "drain",
	"Delightful Kiss": "kiss",
	"Delivery": "pulse",
	"Delivery Dash": "impact",
	"Delivery Pocket": "veil",
	"Delta Beam": "beam",
	"Delta Blast": "boom",
	"Delta Call": "quake",
	"Delta Circle": "impact",
	"Delta Copy": "torrent",
	"Delta Crush": "impact",
	"Delta Draw": "impact",
	"Delta Edge": "slash",
	"Delta Fang": "bite",
	"Delta Mind": "pulse",
	"Delta Reduction": "quake",
	"Delta Search": "torrent",
	"Delusion": "daze",
	"Delve": "pulse",
	"Demolish": "quake",
	"Demolition Tackle": "impact",
	"Den of Iniquity-GX": "bloom",
	"Derail": "veil",
	"Deranged Dance": "whirl",
	"Derisive Roasting": "flame",
	"Desert Burn": "flame",
	"Desert Geyser": "quake",
	"Desert Hurricane": "whirl",
	"Desert Pillar": "quake",
	"Despair Ray": "beam",
	"Desperate Attack": "veil",
	"Desperate Pollen": "powder",
	"Desperate Punch": "fist",
	"Desperate Slap": "impact",
	"Destined Fight": "quake",
	"Destiny Bond": "pulse",
	"Destiny Stinger": "drain",
	"Destroyer King": "veil",
	"Destroyer Punch": "fist",
	"Destructive Beam": "beam",
	"Destructive Cyclone-GX": "boom",
	"Destructive Drake-GX": "boom",
	"Destructive Drill": "drill",
	"Destructive Finish": "boom",
	"Destructive Fire": "flame",
	"Destructive Flame": "flame",
	"Destructive Horn": "drill",
	"Destructive Inferno": "flame",
	"Destructive Jaw": "boom",
	"Destructive Roar": "sonic",
	"Destructive Sound": "boom",
	"Destructive Tsunami": "boom",
	"Destructive Whirlpool": "torrent",
	"Destructo-Press": "boom",
	"Destructor Beam": "beam",
	"Detect": "shield",
	"Detonate": "boom",
	"Detonation": "flame",
	"Detonation Spin": "whirl",
	"Detour": "flame",
	"Devastate": "torrent",
	"Devastating Wind": "whirl",
	"Devilish Hands-GX": "veil",
	"Devo Crush": "impact",
	"Devoluter": "impact",
	"Devolution": "impact",
	"Devolution Beam": "beam",
	"Devolution Punch": "fist",
	"Devolution Ray": "beam",
	"Devolution Wave": "torrent",
	"Devour": "bloom",
	"Devour Soul": "pulse",
	"Devouring Mouth": "veil",
	"Diabolical Claws": "slash",
	"Diamond Blast": "boom",
	"Diamond Blow": "impact",
	"Diamond Dust": "torrent",
	"Diamond Force": "sparkle",
	"Diamond Gate": "quake",
	"Diamond Gift": "quake",
	"Diamond Rain": "quake",
	"Diamond Storm": "whirl",
	"Diffuse Reflection": "quake",
	"Dig": "quake",
	"Dig a Little": "quake",
	"Dig Away Flash": "quake",
	"Dig Claws": "slash",
	"Dig Deep": "quake",
	"Dig Drain": "drain",
	"Dig It Up": "quake",
	"Dig Out": "quake",
	"Dig Through": "quake",
	"Dig Trap": "quake",
	"Dig Under": "quake",
	"Dig Uppercut": "fist",
	"Digging Claw": "slash",
	"Digging Dash": "impact",
	"Digicharge": "impact",
	"Digital Reboot": "impact",
	"Dimension Heal": "drain",
	"Dimension Sphere": "quake",
	"Dimensional Hand": "pulse",
	"Dimensional Storm": "whirl",
	"Diminutive Desire": "shard",
	"Dire Claw": "slash",
	"Dire Nails": "flame",
	"Direct Arrow": "arrow",
	"Direct Dive": "torrent",
	"Direct Hit": "impact",
	"Direct-hit Bomb": "boom",
	"Directing Traffic": "quake",
	"Dirge": "veil",
	"Dirty Beam": "beam",
	"Dirty Headbutt": "impact",
	"Dirty Press": "impact",
	"Dirty Shock": "bolt",
	"Dirty Throw": "quake",
	"Dirty Trick": "veil",
	"Dirty Work": "quake",
	"Disable": "pulse",
	"Disarming Voice": "torrent",
	"Disaster Shock": "bolt",
	"Disaster Volt": "bolt",
	"Disaster Wing": "wing",
	"Discerning Spear": "shard",
	"Discharge": "bolt",
	"Disconnect": "bolt",
	"Discovery-GX": "impact",
	"Dish Out": "impact",
	"Dishonest Swap": "drain",
	"Disorder": "pulse",
	"Disorderly Flip": "shard",
	"Disorienting Flash": "sparkle",
	"Disperse Drool": "bloom",
	"Disruptive Radar": "pulse",
	"Distilled Blast": "boom",
	"Distored Wave": "torrent",
	"Distort": "roar",
	"Distorted Wave": "torrent",
	"Distortion Beam": "beam",
	"Disturbance Dive": "torrent",
	"Disturbing Pollen": "powder",
	"Ditch and Draw": "bolt",
	"Ditch and Shake": "bloom",
	"Ditch and Splash": "torrent",
	"Dive": "torrent",
	"Dive and Rescue": "torrent",
	"Dive Bomb": "torrent",
	"Divide-GX": "drain",
	"Divine Paper": "shard",
	"Diving Icicles": "frost",
	"Diving Swipe": "veil",
	"Diving Uppercut": "fist",
	"Division": "pulse",
	"Dizziness": "torrent",
	"Dizzy Punch": "fist",
	"Dizzying Cologne": "sparkle",
	"Dizzying Flower": "petal",
	"Dizzying Headbutt": "impact",
	"Dizzying Poison": "veil",
	"Dizzying Spin": "whirl",
	"Dizzying Wind": "whirl",
	"Do the Wave": "torrent",
	"Dodge": "quake",
	"Doduo Delivery": "impact",
	"Dogpile": "impact",
	"Doll Swap": "sparkle",
	"Dominating Echo": "roar",
	"Dominating Fangs": "bite",
	"Doom Count-GX": "drain",
	"Doom Crush": "impact",
	"Doom Curse": "veil",
	"Doom Decree": "pulse",
	"Doom Desire": "shard",
	"Doom News": "veil",
	"Double Assist": "barrage",
	"Double Attack": "barrage",
	"Double Blaze-GX": "barrage",
	"Double Bubble": "barrage",
	"Double Cannon": "barrage",
	"Double Charge": "barrage",
	"Double Chop": "chop",
	"Double Claw": "slash",
	"Double Claws": "slash",
	"Double Cross": "barrage",
	"Double Damage": "barrage",
	"Double Dip Fangs": "barrage",
	"Double Draw": "barrage",
	"Double Ducts": "barrage",
	"Double Eater": "barrage",
	"Double-Edge": "impact",
	"Double-edge Claw": "impact",
	"Double-Edged Slash": "slash",
	"Double Fire": "barrage",
	"Double Freeze": "barrage",
	"Double Headbutt": "barrage",
	"Double Headstrike": "barrage",
	"Double Hit": "barrage",
	"Double Horn": "barrage",
	"Double Impact": "barrage",
	"Double Jet": "barrage",
	"Double Kick": "kick",
	"Double KO": "barrage",
	"Double Lariat": "barrage",
	"Double Launcher": "barrage",
	"Double Leg Hammer": "barrage",
	"Double Link": "barrage",
	"Double Metal Ball": "barrage",
	"Double Peck": "barrage",
	"Double Pincers": "barrage",
	"Double Pinchers": "barrage",
	"Double-Punching Family": "barrage",
	"Double Razor Leaf": "barrage",
	"Double Return": "barrage",
	"Double Scrapper": "barrage",
	"Double Scratch": "slash",
	"Double Shock": "barrage",
	"Double Shoot": "barrage",
	"Double Shot": "barrage",
	"Double Slap": "barrage",
	"Double Slash": "slash",
	"Double Smash": "barrage",
	"Double Spin": "barrage",
	"Double Splash": "barrage",
	"Double Stab": "slash",
	"Double Stomp": "barrage",
	"Double Swing": "barrage",
	"Double Tack": "barrage",
	"Double Tackle": "barrage",
	"Double Thread": "barrage",
	"Double Throw": "barrage",
	"Double Trick": "barrage",
	"Double Voltage": "barrage",
	"Double Whip": "barrage",
	"Double Wing Attack": "barrage",
	"Doubleslap": "torrent",
	"Doublslap": "impact",
	"Down Draw": "pulse",
	"Downburst": "impact",
	"Downer Shock": "bolt",
	"Downgrading Beam": "beam",
	"Dozing Draw": "sleep",
	"Dozing Scales": "bloom",
	"Draco Melody": "roar",
	"Draco Meteor": "meteor",
	"Draco Meteor Barrage": "barrage",
	"Draconic Buster": "roar",
	"Draconic Disaster": "roar",
	"Draconic Impulse": "roar",
	"Draconic Slam": "roar",
	"Draconic Star": "swift",
	"Draconic Whip": "roar",
	"Drag Down": "bolt",
	"Drag Off": "impact",
	"Dragon Arcana": "roar",
	"Dragon Ascent": "roar",
	"Dragon Beat": "impact",
	"Dragon Bind": "wrap",
	"Dragon Blast": "boom",
	"Dragon Bond": "roar",
	"Dragon Break": "roar",
	"Dragon Breath": "breath",
	"Dragon Bump": "roar",
	"Dragon Burst": "boom",
	"Dragon Claw": "slash",
	"Dragon Counter": "roar",
	"Dragon Crush": "roar",
	"Dragon Dance": "roar",
	"Dragon Dew": "roar",
	"Dragon Dive": "torrent",
	"Dragon Energy": "roar",
	"Dragon Eye": "daze",
	"Dragon Fang": "bite",
	"Dragon Finish": "roar",
	"Dragon Flame": "flame",
	"Dragon Fleet": "roar",
	"Dragon Gale": "roar",
	"Dragon Hammer": "fist",
	"Dragon Headbutt": "roar",
	"Dragon Impact": "roar",
	"Dragon Laser": "beam",
	"Dragon Launcher": "roar",
	"Dragon Mist": "roar",
	"Dragon Nova-GX": "roar",
	"Dragon Pulse": "pulse",
	"Dragon Pump": "torrent",
	"Dragon Rage": "rage",
	"Dragon Roar": "sonic",
	"Dragon Rush": "roar",
	"Dragon's Fury": "barrage",
	"Dragon's Vengeance": "roar",
	"Dragon's Wish": "drain",
	"Dragon Slayer": "roar",
	"Dragon Smash": "quake",
	"Dragon Song": "note",
	"Dragon Spark": "bolt",
	"Dragon Stamp": "roar",
	"Dragon Steam": "roar",
	"Dragon Stream": "stream",
	"Dragon Strike": "roar",
	"Dragon Tail": "tail",
	"Dragon Tornado": "roar",
	"Dragon Trail": "roar",
	"Dragon Vortex": "roar",
	"Dragon Wave": "torrent",
	"Dragon Wisdom": "roar",
	"Dragonaxe": "slash",
	"Dragonblade": "roar",
	"Dragonblast": "boom",
	"Dragonbreath": "roar",
	"Dragonporter-GX": "roar",
	"Dragonslice": "roar",
	"Drain Down": "drain",
	"Drain Punch": "drain",
	"Drain Slap": "drain",
	"Drain Wash": "drain",
	"Draining Blade": "slash",
	"Draining Cut": "slash",
	"Draining Fin": "torrent",
	"Draining Kiss": "kiss",
	"Drainpour": "bloom",
	"Dravite": "bolt",
	"Draw for Everybody": "bolt",
	"Draw In": "flame",
	"Draw Toward": "quake",
	"Draw Up": "torrent",
	"Drawareness": "veil",
	"Drawup Power": "bloom",
	"Dread End": "veil",
	"Dread Launcher": "torrent",
	"Dread Mountain": "meteor",
	"Dread Storm-GX": "whirl",
	"Dreadful Flames-GX": "flame",
	"Dream Away": "pulse",
	"Dream Calling": "pulse",
	"Dream Catcher": "pulse",
	"Dream Dance": "pulse",
	"Dream Eater": "pulse",
	"Dream Fear-GX": "pulse",
	"Dream of Memories": "pulse",
	"Dream's Touch": "pulse",
	"Dream Waltz": "pulse",
	"Dreaming Tone": "sleep",
	"Dreamy Mist": "roar",
	"Dredge": "shard",
	"Dredge Up": "veil",
	"Drench": "impact",
	"Drenched Headbutt": "impact",
	"Dress Up": "sparkle",
	"Drift Ashore": "pulse",
	"Drill Bazooka": "drill",
	"Drill Peck": "drill",
	"Drill Run": "drill",
	"Drill Run Double": "barrage",
	"Drill Smash": "drill",
	"Drill Tackle": "drill",
	"Dripping Grudge": "drain",
	"Driving Buddy": "impact",
	"Drizzle": "torrent",
	"Drool": "bloom",
	"Drop Shot": "cannon",
	"Drought": "quake",
	"Drowning Ball": "aura",
	"Drowsy": "sleep",
	"Drum Beating": "bloom",
	"Drum Roll": "gyro",
	"Drum Rush": "impact",
	"Dual Blades": "shard",
	"Dual Blizzard": "frost",
	"Dual Bolt": "bolt",
	"Dual Bullet": "cannon",
	"Dual Burn": "flame",
	"Dual Calling": "shard",
	"Dual Chop": "chop",
	"Dual Claw": "slash",
	"Dual Cut": "slash",
	"Dual Draw": "pulse",
	"Dual Headbutt": "impact",
	"Dual Pump": "torrent",
	"Dual Splash": "torrent",
	"Dual Stream": "stream",
	"Dual Tail": "tail",
	"Dual Trans": "bolt",
	"Dual Turbo": "flame",
	"Dueling Saber": "shard",
	"Dull Light": "sparkle",
	"Dump and Draw": "flame",
	"Dump Truck Press": "impact",
	"Duralubeam": "beam",
	"Dusk Raid": "veil",
	"Dusk Shot": "cannon",
	"Dust Cannon": "cannon",
	"Dust Devil": "quake",
	"Dust Gathering": "pulse",
	"Dust Storm": "whirl",
	"Dusty Ruckus": "veil",
	"Dwindling Wave": "torrent",
	"Dyna Barrier": "shield",
	"Dyna-Blast": "boom",
	"Dynablade": "quake",
	"Dynamax Cannon": "cannon",
	"Dynamic Blaze": "flame",
	"Dynamic Bolt": "bolt",
	"Dynamic Chop": "chop",
	"Dynamic Dive": "torrent",
	"Dynamic Horn": "drill",
	"Dynamic Press": "impact",
	"Dynamic Punch": "fist",
	"Dynamic Roll": "gyro",
	"Dynamic Spark": "bolt",
	"Dynamic Swing": "impact",
	"Dynamic Tail": "tail",
	"Dynamic Wave": "torrent",
	"Dynamite Fang": "bite",
	"Dynamite Press": "impact",
	"Dynamite Punch": "fist",
	"Dynamite Steam": "torrent",
	"Dynamite Tackle": "impact",
	"Ear Dig": "quake",
	"Ear Force": "impact",
	"Ear Influence": "drain",
	"Ear Kinesis": "drain",
	"Earth Bomb": "quake",
	"Earth Poison": "quake",
	"Earth Power": "quake",
	"Earth Rift": "quake",
	"Earthdrill": "quake",
	"Earthen Boom": "quake",
	"Earthen Power": "quake",
	"Earthen Press": "quake",
	"Earthen Spike": "sting",
	"Earthen Sword": "slash",
	"Earthquake": "quake",
	"Ease Up": "impact",
	"Eat Sloppily": "veil",
	"Eat Up": "impact",
	"Echoed Voice": "sonic",
	"Echoing Madness": "veil",
	"Eeeeeeek": "sleep",
	"Eeek": "impact",
	"Eek": "impact",
	"Eerie Cry": "drain",
	"Eerie Fluid": "quake",
	"Eerie Gaze": "pulse",
	"Eerie Glow": "flame",
	"Eerie Howl": "sonic",
	"Eerie Impulse": "bolt",
	"Eerie Light": "sparkle",
	"Eerie Tentacles": "wrap",
	"Eerie Voice": "drain",
	"Eerie Wave": "torrent",
	"Egg Bomb": "boom",
	"Egg Rolling": "gyro",
	"Egg Splat": "roar",
	"Egg Surprise": "drain",
	"Egg Toss": "quake",
	"Eggsplosion": "bloom",
	"Either Face": "impact",
	"Elbow Strike": "impact",
	"Electri-Defuse": "bolt",
	"Electribeam": "beam",
	"Electribonus": "bolt",
	"Electric Ball": "bolt",
	"Electric Blast": "bolt",
	"Electric Bolt": "bolt",
	"Electric Circuit": "bolt",
	"Electric Claws": "slash",
	"Electric Current": "bolt",
	"Electric Fist": "fist",
	"Electric Mischief": "bolt",
	"Electric Nibbling": "bolt",
	"Electric Punch": "bolt",
	"Electric Ring": "bolt",
	"Electric Riot": "bolt",
	"Electric Run": "bolt",
	"Electric Shock": "bolt",
	"Electric Surfer": "bolt",
	"Electric Tackle": "bolt",
	"Electric Tail": "bolt",
	"Electric Trap": "bolt",
	"Electrical-GX": "bolt",
	"Electrical Signal": "bolt",
	"Electricannon": "bolt",
	"Electrichain": "bolt",
	"Electricounter": "bolt",
	"Electrified Bite Mark": "bite",
	"Electrified Bolt": "bolt",
	"Electrified Incisors": "bolt",
	"Electrify": "bolt",
	"Electrifying Chance": "bolt",
	"Electrifying Dash": "impact",
	"Electrigun": "bolt",
	"Electripult": "bolt",
	"Electrishower": "bolt",
	"Electrisilk": "bolt",
	"Electrispark": "bolt",
	"Electriwave": "bolt",
	"Electro Ball": "bolt",
	"Electro Ball Together": "bolt",
	"Electro Beam": "beam",
	"Electro Blaster": "bolt",
	"Electro Cannon": "bolt",
	"Electro Combo": "barrage",
	"Electro Diffusion": "bolt",
	"Electro Fall": "bolt",
	"Electro House": "bolt",
	"Electro Paws": "bolt",
	"Electro Rain": "bolt",
	"Electro Sprinkler": "bolt",
	"Electro Star": "swift",
	"Electro Wheel": "bolt",
	"Electroblast": "bolt",
	"Electrobullet": "bolt",
	"Electroburn": "flame",
	"Electrocharge": "bolt",
	"Electrodash": "bolt",
	"Electromagnetic Bomb": "bolt",
	"Electromagnetic Catapult": "bolt",
	"Electromagnetic Induction": "bolt",
	"Electromagnetic Jam": "bolt",
	"Electromagnetic Kick": "kick",
	"Electromagnetic Rock Wrecker": "bolt",
	"Electromagnetic Sonar": "bolt",
	"Electromark": "bolt",
	"Electron Crush": "bolt",
	"Electronica": "bolt",
	"Electroslug": "bolt",
	"Electrosmash": "bolt",
	"Electrostep": "bolt",
	"Electroweb": "web",
	"Elegant Sole": "bloom",
	"Elegant Swim": "torrent",
	"Element Chain": "torrent",
	"Elemental Blast": "boom",
	"Elemental Feather": "wing",
	"Eleventh Hour Tackle": "impact",
	"Elongating Arms": "pulse",
	"Ember": "flame",
	"Ember Dance": "flame",
	"Ember Star": "swift",
	"Emerald Blade": "slash",
	"Emerald Break": "impact",
	"Emerald Slash": "slash",
	"Emotional Draw": "torrent",
	"Empathic Healing": "drain",
	"Emperor's Command": "torrent",
	"Emperor’s Strike": "impact",
	"Empty Threat": "veil",
	"Encore": "pulse",
	"Encounter": "pulse",
	"Encouraging Gift": "bloom",
	"Endeavor": "torrent",
	"Endgame": "veil",
	"Endless Darkness": "veil",
	"Endure": "quake",
	"Enefountain": "torrent",
	"Enemy Show": "drain",
	"Energize": "bolt",
	"Energized Attack": "impact",
	"Energized Balloon": "pulse",
	"Energized Blade": "slash",
	"Energized Graffiti": "veil",
	"Energized Leaves": "bloom",
	"Energized Shell": "shell",
	"Energized Slap": "impact",
	"Energized Slash": "slash",
	"Energized Storm": "whirl",
	"Energizer Wheel": "veil",
	"Energizing Sketch": "impact",
	"Energy Absorption": "drain",
	"Energy Antics": "sleep",
	"Energy Arrow": "arrow",
	"Energy Assist": "impact",
	"Energy Ball": "bloom",
	"Energy Blender": "impact",
	"Energy Bloom": "bloom",
	"Energy Blow": "impact",
	"Energy Bomb": "boom",
	"Energy Bone": "bone",
	"Energy Burner": "flame",
	"Energy Burst": "boom",
	"Energy Call": "impact",
	"Energy Cannon": "cannon",
	"Energy Catch": "flame",
	"Energy Control": "pulse",
	"Energy Conversion": "pulse",
	"Energy Crane": "pulse",
	"Energy Crush": "impact",
	"Energy Cutoff": "impact",
	"Energy Cycle": "pulse",
	"Energy Cyclone": "whirl",
	"Energy Digging": "bloom",
	"Energy Dissolve": "bloom",
	"Energy Draw": "impact",
	"Energy Drink": "bloom",
	"Energy Drive": "pulse",
	"Energy Extract": "roar",
	"Energy Feather": "wing",
	"Energy Flare": "flame",
	"Energy Flip": "torrent",
	"Energy Garden": "bloom",
	"Energy Gaze": "pulse",
	"Energy Gift": "bloom",
	"Energy Glide": "bolt",
	"Energy Heal": "drain",
	"Energy Healing": "drain",
	"Energy Hunt": "pulse",
	"Energy Hurricane": "whirl",
	"Energy Kick": "kick",
	"Energy Kiss": "kiss",
	"Energy Link": "impact",
	"Energy Loop": "torrent",
	"Energy Milk": "drain",
	"Energy Mix": "pulse",
	"Energy Munch": "bite",
	"Energy Patch": "bolt",
	"Energy Plant": "bloom",
	"Energy Powder": "powder",
	"Energy Present": "pulse",
	"Energy Press": "impact",
	"Energy Punch": "fist",
	"Energy Recall": "pulse",
	"Energy Recycle": "impact",
	"Energy Retrieval": "drain",
	"Energy Salon": "impact",
	"Energy Short": "bolt",
	"Energy Shower": "impact",
	"Energy Singe": "pulse",
	"Energy Slap": "impact",
	"Energy Slosh": "veil",
	"Energy Spiral": "whirl",
	"Energy Splash": "torrent",
	"Energy Split": "bolt",
	"Energy Straw": "bloom",
	"Energy Stream": "stream",
	"Energy Support": "pulse",
	"Energy Teaser": "pulse",
	"Energy Typhoon": "impact",
	"Energy Warp": "pulse",
	"Energy Wheel": "impact",
	"Energy Whip": "slash",
	"Enhanced Blade": "slash",
	"Enhanced Fang": "bite",
	"Enhanced Horn": "drill",
	"Enhanced Horns": "drill",
	"Enhanced Stomp": "impact",
	"Enormous Explosion": "boom",
	"Enrage": "torrent",
	"Enraged Assault": "bloom",
	"Enraged Linear Attack": "drain",
	"Enraged Strike": "impact",
	"Enriching Egg": "drain",
	"Enriching Seeds": "drain",
	"Ensnaring Spray": "torrent",
	"Ensnarl": "pulse",
	"Entagling Thread": "web",
	"Entangle": "bolt",
	"Entangle Tackle": "impact",
	"Entangled Dive": "torrent",
	"Entangling Control": "daze",
	"Entangling String": "bloom",
	"Entangling Thread": "web",
	"Entangling Trap": "wrap",
	"Entangling Vines": "bloom",
	"Entangling Whip": "slash",
	"Enter the Dragon": "roar",
	"Entertain": "drain",
	"Enticing Pattern": "bloom",
	"Entrainment": "bolt",
	"Entrancing Melody": "bloom",
	"Entrap": "pulse",
	"Entwining Entrapment": "torrent",
	"Enumerating Blade": "slash",
	"Enveloping Shadow": "veil",
	"Eon Blade": "slash",
	"Eon Connection": "roar",
	"Epic Splash": "torrent",
	"Erasure Ball": "aura",
	"Errand-Running": "bloom",
	"Eruption": "flame",
	"Eruption Shot": "flame",
	"Escaping Incisors": "impact",
	"Escort": "torrent",
	"ESP": "torrent",
	"Eternal Flame-GX": "flame",
	"Eternal Light-GX": "sparkle",
	"Eternal Radiance": "drain",
	"Eternity Bloom": "bloom",
	"Ethereal Flame": "flame",
	"Euclase": "drain",
	"Euphoria-GX": "sleep",
	"Evaporating Heat": "flame",
	"Even Game": "torrent",
	"Evergreen-GX": "bloom",
	"Everlasting Darkness": "veil",
	"Everyone Discharge": "bolt",
	"Everyone Explode Now": "shard",
	"Everyone Laze Around": "drain",
	"Evil Admonition": "veil",
	"Evil Ball": "aura",
	"Evil Claw": "slash",
	"Evil Crash": "impact",
	"Evil Eye": "daze",
	"Evil Incineration": "flame",
	"Evil Orders": "veil",
	"Evo-Lariat": "impact",
	"Evo-Powder": "powder",
	"Evoblast": "boom",
	"Evoflight": "bloom",
	"Evoharmony": "pulse",
	"Evoluter": "impact",
	"Evolution": "impact",
	"Evolution Impulse": "bloom",
	"Evolution Jammer": "pulse",
	"Evolution Song": "note",
	"Evolution Wish": "drain",
	"Evolutionary Spore": "powder",
	"Evolving Aqua": "torrent",
	"Evolving Flare": "flame",
	"Evolving Thunder": "bolt",
	"Evomancy": "pulse",
	"Evopress": "bloom",
	"Exact Revenge": "pulse",
	"Exavolt": "bolt",
	"Excited Punch": "fist",
	"Excited Tail": "tail",
	"Exciting Dance": "whirl",
	"Exciting Flame": "flame",
	"Exciting Shake": "bloom",
	"Exciting Voltage": "bolt",
	"Exeggutor's Paradise": "roar",
	"Exercise": "impact",
	"Exhausted Tackle": "impact",
	"Expand": "impact",
	"Expelling Tornado": "whirl",
	"Expert Nurturer": "impact",
	"Expert Splasher": "torrent",
	"Explode Together Now": "veil",
	"Exploder": "flame",
	"Explosion": "boom",
	"Explosion Y": "boom",
	"Explosive Ascension": "quake",
	"Explosive Bolt": "bolt",
	"Explosive Discontent": "veil",
	"Explosive Evolution": "quake",
	"Explosive Fire": "flame",
	"Explosive Fireball": "flame",
	"Explosive Jet": "impact",
	"Explosive Kick": "kick",
	"Explosive Smoke": "pulse",
	"Explosive Thunder": "bolt",
	"Explosive Vortex": "flame",
	"Extend Ears": "impact",
	"Extend Fang": "bite",
	"Extend Fungus": "bloom",
	"Extended Damagriiigus": "drain",
	"Extra Ball": "aura",
	"Extra Call": "veil",
	"Extra Chop": "chop",
	"Extra Circuit": "bolt",
	"Extra Claws": "slash",
	"Extra Comet Punch": "fist",
	"Extra Crush": "impact",
	"Extra Curse": "veil",
	"Extra Draw": "flame",
	"Extra Flame": "flame",
	"Extra Poison": "veil",
	"Extra Punch": "fist",
	"Extra-Tight Press": "impact",
	"Extrasensory": "pulse",
	"Extreme Attack": "impact",
	"Extreme Current": "bolt",
	"Extreme Freeze": "frost",
	"Eye Opener": "daze",
	"Eye Strength": "daze",
	"Fabled Flarebolts": "flame",
	"Facade": "impact",
	"Fade Out": "pulse",
	"Fade to Black": "pulse",
	"Fairy Friend": "sparkle",
	"Fairy Lock": "sparkle",
	"Fairy Power": "sparkle",
	"Fairy Song": "note",
	"Fairy Wind": "sparkle",
	"Fake Out": "veil",
	"Fake Tears": "impact",
	"Falling Bubbles": "torrent",
	"Falling Down": "torrent",
	"Falling Press": "impact",
	"False Accusation": "veil",
	"False Charity": "impact",
	"False Surrender": "veil",
	"False Swipe": "drain",
	"Familial Combo-GX": "barrage",
	"Familial March": "impact",
	"Family Attack": "impact",
	"Family Beatdown": "impact",
	"Family Rescue": "pulse",
	"Famished": "bolt",
	"Fan Tornado": "whirl",
	"Fang Snipe": "bite",
	"Fangs of the Sunne": "bite",
	"Fantasia Force": "pulse",
	"Fascinate": "impact",
	"Fast-Acting Poison": "veil",
	"Fast Carrier": "impact",
	"Fast Charge": "impact",
	"Fast Evolution": "quake",
	"Fast Flight": "whirl",
	"Fast Forward": "roar",
	"Fast Punch": "fist",
	"Fast Raid": "roar",
	"Fast Stream": "stream",
	"Fast Swipe": "impact",
	"Fastball": "bolt",
	"Fasten Claw": "slash",
	"Fasten Claws": "slash",
	"Fastwave": "torrent",
	"Fateful Fang": "bite",
	"Fear and Panic": "veil",
	"Fear the Forest": "pulse",
	"Fearsome Shadow": "veil",
	"Feather Dance": "wing",
	"Feather Lance": "wing",
	"Feather Rondo": "wing",
	"Feather Shot": "cannon",
	"Feather Slice": "slash",
	"Feather Storm": "wing",
	"Feather Strike": "wing",
	"Feathery Cyclone": "whirl",
	"Feathery Strike": "impact",
	"Feedback": "drain",
	"Feelin' Fine": "impact",
	"Feint": "quake",
	"Feint Attack": "veil",
	"Ferment Poison": "veil",
	"Ferocious Bellow": "impact",
	"Ferry": "torrent",
	"Festering Saliva": "flame",
	"Fetch": "impact",
	"Fetch Family": "veil",
	"Feverish Kiss": "kiss",
	"Fickle Attack": "pulse",
	"Fickle Beam": "beam",
	"Fickle Impact": "impact",
	"Fickle Spitting": "impact",
	"Fiddle Around": "impact",
	"Fidget": "quake",
	"Field Crush": "impact",
	"Field Trap": "wrap",
	"Fierce Dragon": "roar",
	"Fiery Big Bang": "flame",
	"Fiery Blast": "flame",
	"Fiery Bone": "bone",
	"Fiery Breeze": "flame",
	"Fiery Cheering": "flame",
	"Fiery Dance": "flame",
	"Fiery Dribbling": "flame",
	"Fiery Fighting Spirit": "flame",
	"Fiery Licks": "flame",
	"Fiery Punch": "flame",
	"Fiery Wrath": "flame",
	"Fight Alone": "shard",
	"Fight Back": "quake",
	"Fighting Blaze": "flame",
	"Fighting Claws": "slash",
	"Fighting Fangs": "bite",
	"Fighting Fist": "fist",
	"Fighting Headbutt": "impact",
	"Fighting Knuckle": "fist",
	"Fighting Lightning": "bolt",
	"Fighting Pulse": "pulse",
	"Fighting Sword": "slash",
	"Fighting Tackle": "impact",
	"Fighting Whirlpool": "torrent",
	"Fighting Wings": "wing",
	"Filch": "veil",
	"Fin Slap": "impact",
	"Fin Smack": "torrent",
	"Final Blast": "boom",
	"Final Blizzard": "frost",
	"Final Blowup": "impact",
	"Final Burn": "flame",
	"Final Gambit": "torrent",
	"Final Laser": "beam",
	"Find": "impact",
	"Find a Friend": "impact",
	"Find a Home": "veil",
	"Find Ice": "frost",
	"Find It": "torrent",
	"Find Treasure": "pulse",
	"Find Wildfire": "flame",
	"Finest Selection": "impact",
	"Finger Poke": "pulse",
	"Finishing Blow": "impact",
	"Finishing Combo": "barrage",
	"Finishing Fang": "bite",
	"Finishing Stinger": "quake",
	"Fire Arrow": "flame",
	"Fire Blast": "stream",
	"Fire Blaster": "flame",
	"Fire Blow": "flame",
	"Fire Claws": "slash",
	"Fire Counterattack": "flame",
	"Fire Dance": "flame",
	"Fire Fang": "flame",
	"Fire Fling": "flame",
	"Fire Force": "flame",
	"Fire Kagura": "flame",
	"Fire Mane": "flame",
	"Fire Payback": "flame",
	"Fire Punch": "flame",
	"Fire Ring": "flame",
	"Fire's Power": "flame",
	"Fire Shard": "flame",
	"Fire Slash": "slash",
	"Fire Soul": "flame",
	"Fire Spin": "flame",
	"Fire Stream": "flame",
	"Fire Tackle": "flame",
	"Fire Tail": "flame",
	"Fire Tail Slap": "flame",
	"Fire Wall": "flame",
	"Fire Wind": "flame",
	"Fire Wing": "flame",
	"Fireball": "flame",
	"Fireball Bazooka": "flame",
	"Fireball Circus": "flame",
	"Fireball Fever": "flame",
	"Fireball Shot": "flame",
	"Fireblast": "flame",
	"Firebreathing": "flame",
	"Firefighting": "flame",
	"Firefly Light": "flame",
	"Firefly Scent": "flame",
	"Firestorm": "flame",
	"Fireworks": "flame",
	"Fireworks Bomb": "flame",
	"First Aid": "drain",
	"First Contact": "pulse",
	"First Freeze": "frost",
	"First Impression": "bloom",
	"First Step": "impact",
	"Fish Out": "pulse",
	"Fishing Tail": "tail",
	"Fissure": "quake",
	"Fist of Antiquity": "fist",
	"Fist of Focus": "fist",
	"Fists of Strife": "veil",
	"Five Fierce Chops": "quake",
	"Fixer of the Forest": "pulse",
	"Flail": "torrent",
	"Flail Around": "torrent",
	"Flailing Flop": "torrent",
	"Flame": "flame",
	"Flame Ball": "flame",
	"Flame Bash": "flame",
	"Flame Blast": "flame",
	"Flame Bluster": "flame",
	"Flame Burst": "flame",
	"Flame Cannon": "flame",
	"Flame Charge": "flame",
	"Flame Cloak": "flame",
	"Flame Dance": "flame",
	"Flame Drum": "flame",
	"Flame Gift": "flame",
	"Flame Jet": "flame",
	"Flame Jet-GX": "flame",
	"Flame Kick": "kick",
	"Flame Legion": "flame",
	"Flame Pillar": "flame",
	"Flame Screen": "flame",
	"Flame Surge": "flame",
	"Flame Swirl": "flame",
	"Flame Tackle": "flame",
	"Flame Tail": "flame",
	"Flame Wheel": "flame",
	"Flamebody Cannon": "flame",
	"Flames of Rage": "rage",
	"Flames of Revival": "flame",
	"Flamethrower": "stream",
	"Flaming Avalanche": "fall",
	"Flaming Breath": "breath",
	"Flaming Honk": "flame",
	"Flaming Punch": "fist",
	"Flap": "impact",
	"Flare": "flame",
	"Flare Blitz": "flame",
	"Flare Blitz-GX": "flame",
	"Flare Blitzer": "flame",
	"Flare Blizzard": "flame",
	"Flare Bonus": "flame",
	"Flare Bringer": "flame",
	"Flare Combo": "barrage",
	"Flare Destroy": "flame",
	"Flare Fall": "flame",
	"Flare Juggling": "flame",
	"Flare Parade": "flame",
	"Flare Raid": "flame",
	"Flare Recharge": "flame",
	"Flare Shot": "flame",
	"Flare Starter": "flame",
	"Flare Storm": "flame",
	"Flare Strike": "flame",
	"Flare Striker": "flame",
	"Flare Tail": "flame",
	"Flare Up": "flame",
	"Flaring Dash": "impact",
	"Flash": "sparkle",
	"Flash Cannon": "shard",
	"Flash Claw": "slash",
	"Flash Freeze": "frost",
	"Flash Impact": "sparkle",
	"Flash Needle": "sting",
	"Flash of Destruction": "boom",
	"Flash Ray": "beam",
	"Flash Splash": "torrent",
	"Flash Touch": "sparkle",
	"Flashing Barrier": "shield",
	"Flashing Bolt": "bolt",
	"Flashing Eyes": "daze",
	"Flashing Signal": "bolt",
	"Flashing Spear": "bolt",
	"Flat-Out Dash": "impact",
	"Flick Poison": "veil",
	"Flickering Flames": "flame",
	"Flickering Glow": "flame",
	"Flickering Light": "sparkle",
	"Flickering Spores": "powder",
	"Flickering Tail": "tail",
	"Flight Surf": "wave",
	"Flight Up": "whirl",
	"Fling": "quake",
	"Fling Away": "quake",
	"Fling Fire": "flame",
	"Flip Over": "pulse",
	"Flipper Splash": "torrent",
	"Flipper Stroke": "torrent",
	"Flippity Flap": "flame",
	"Flitter": "bloom",
	"Float": "torrent",
	"Float On": "torrent",
	"Float Up": "bloom",
	"Floatify": "torrent",
	"Flock": "bloom",
	"Flock Attack": "veil",
	"Floe Return": "torrent",
	"Flog": "bloom",
	"Floodlight": "bolt",
	"Flop": "bloom",
	"Flop-Down Punch": "fist",
	"Flopping Trap": "wrap",
	"Floral Gain": "bloom",
	"Floral Invitation": "sparkle",
	"Flower Aroma": "petal",
	"Flower Bearing": "petal",
	"Flower Blast": "petal",
	"Flower Dance": "petal",
	"Flower Garden Rondo": "petal",
	"Flower Shower": "petal",
	"Flower Spin": "petal",
	"Flower Storm": "petal",
	"Flower Supply": "petal",
	"Flower Tornado": "petal",
	"Flower Trick": "petal",
	"Flowery Zephyr": "bloom",
	"Fluff Gets in the Way": "pulse",
	"Fluffball Star": "swift",
	"Fluffy Breeze": "bloom",
	"Fluffy Dream": "pulse",
	"Fluffy Guard": "shield",
	"Fluffy Tag": "bloom",
	"Fluffy Tail": "tail",
	"Fluffy Transport": "bloom",
	"Fluorite": "drain",
	"Flurries": "sleep",
	"Flutter Trick": "bloom",
	"Fly": "whirl",
	"Fly Around": "whirl",
	"Flying Beatdown": "impact",
	"Flying Flare": "flame",
	"Flying Flip": "bolt",
	"Flying Fury": "barrage",
	"Flying Press": "impact",
	"Flying Stomp": "impact",
	"Flytrap": "bloom",
	"Focus": "shard",
	"Focus Blast": "aura",
	"Focus Energy": "impact",
	"Focus Fangs": "bite",
	"Focus Fist": "fist",
	"Focus Punch": "fist",
	"Focused Wish": "drain",
	"Follow Me": "sparkle",
	"Follow My Tail": "tail",
	"Follow the Scent": "powder",
	"Follow the Wound": "drain",
	"Follow-Up": "shard",
	"Follow-Up Bolt": "bolt",
	"Follow-Up Kerzap": "bolt",
	"Forbidden Iron Hammer": "fist",
	"Force Palm": "drain",
	"Force Regeneration": "drain",
	"Forced Sleep": "sleep",
	"Forceful Tackle": "impact",
	"Forecast": "impact",
	"Foresight": "pulse",
	"Forest Blast": "boom",
	"Forest Dump": "bloom",
	"Forest Feast": "bloom",
	"Forest March": "bloom",
	"Forest Press": "impact",
	"Forest Storm": "whirl",
	"Form Ranks": "quake",
	"Fortress of Rage": "rage",
	"Fortunate Draw": "pulse",
	"Fortunate Eye": "daze",
	"Fossil Beatdown": "impact",
	"Fossil Charge": "impact",
	"Fossil Clutch": "torrent",
	"Fossil Drop": "quake",
	"Fossil Fangs": "bite",
	"Fossil Finding": "torrent",
	"Fossil Hunt": "torrent",
	"Fossil Search": "torrent",
	"Foul Gas": "powder",
	"Foul Odor": "veil",
	"Foul Play": "veil",
	"Fountain": "torrent",
	"Four as One": "bloom",
	"Free Diving": "torrent",
	"Freestyle Strike": "impact",
	"Freeze": "frost",
	"Freeze Down": "frost",
	"Freeze Dry": "frost",
	"Freeze Light": "frost",
	"Freeze Lock": "frost",
	"Freeze Shock": "frost",
	"Freeze Solid": "frost",
	"Freezing Breath": "breath",
	"Freezing Chill": "torrent",
	"Freezing Flames": "flame",
	"Freezing Force": "impact",
	"Freezing Headbutt": "impact",
	"Freezing Kiss Goodnight": "kiss",
	"Freezing Punch": "fist",
	"Freezing Wind": "whirl",
	"Freezing Wing": "wing",
	"Frenzied Attack": "quake",
	"Frenzied Blade": "slash",
	"Frenzied Gouging": "veil",
	"Frenzy Plant": "bloom",
	"Fresh-Picked Fruit": "drain",
	"Friction Heat": "flame",
	"Friend Search": "pulse",
	"Friend Tackle": "impact",
	"Frighten Horn": "drill",
	"Frightening Howl": "sonic",
	"Frigid Block": "torrent",
	"Frigid Breath": "breath",
	"Frigid Fangs": "bite",
	"Frigid Fluttering": "torrent",
	"Frog Hop": "torrent",
	"Front Spark": "bolt",
	"Frost Barrier": "frost",
	"Frost Breath": "frost",
	"Frost Bullet": "frost",
	"Frost Charge": "frost",
	"Frost Crush": "frost",
	"Frost Prison": "frost",
	"Frost Purge": "frost",
	"Frost Smash": "frost",
	"Frost Spear": "frost",
	"Frost Stamp": "frost",
	"Frost Stone": "frost",
	"Frost Vanish": "frost",
	"Frost Wall": "frost",
	"Frostbite": "bite",
	"Frosty Flattening": "torrent",
	"Frosty Jail": "torrent",
	"Frosty Thunder": "bolt",
	"Frosty Typhoon": "torrent",
	"Frozen Awakening": "frost",
	"Frozen Breath": "frost",
	"Frozen Ground": "frost",
	"Frozen Heat": "flame",
	"Frozen Lock": "frost",
	"Frozen Slice": "slash",
	"Frozen Splash": "frost",
	"Frozen Wings": "frost",
	"Frozen Wood": "frost",
	"Fruit Bearing": "impact",
	"Fruition": "drain",
	"Fruity Aroma": "powder",
	"Frustration": "rage",
	"Fulgurite": "bolt",
	"Full Belly Bolt": "bolt",
	"Full-Belly Refresh": "drain",
	"Full Blitz": "bolt",
	"Full Bloom": "bloom",
	"Full Burst": "boom",
	"Full Clean": "pulse",
	"Full Heart": "pulse",
	"Full Metal Blade": "slash",
	"Full Metal Impact": "shard",
	"Full Metal Knuckle": "fist",
	"Full Metal Wall-GX": "shield",
	"Full Moon Ray": "beam",
	"Full Moon Rondo": "sparkle",
	"Full Moon Star": "swift",
	"Full Nelson": "quake",
	"Full On": "bloom",
	"Full Retaliation": "torrent",
	"Full Speed Charge": "impact",
	"Full Throttle": "impact",
	"Full Tilt Fling": "impact",
	"Full Voltage-GX": "bolt",
	"Fully Singe": "roar",
	"Fur Attack": "impact",
	"Furious Anger": "impact",
	"Furious Kicks": "kick",
	"Furious Shurikens": "torrent",
	"Furry Chance": "impact",
	"Furtive Drop": "drain",
	"Fury": "barrage",
	"Fury Attack": "barrage",
	"Fury Cutter": "slash",
	"Fury Headbutt": "barrage",
	"Fury Punch": "barrage",
	"Fury Strikes": "barrage",
	"Fury Swipes": "barrage",
	"Fusion Bolt": "bolt",
	"Fusion Flare": "flame",
	"Fusion Strike Assault": "impact",
	"Future Sight": "pulse",
	"Future Spin": "whirl",
	"G Booster": "impact",
	"G-Max Bloom": "bloom",
	"G-Max Bombard": "torrent",
	"G-Max Boulder": "quake",
	"G-Max Centiferno": "flame",
	"G-Max Chi Strike": "impact",
	"G-Max Cuddle": "impact",
	"G-Max Cyclone": "whirl",
	"G-Max Drill": "drill",
	"G-Max Drum Solo": "bloom",
	"G-Max Fall": "impact",
	"G-Max Fireball": "flame",
	"G-Max Gold Rush": "impact",
	"G-Max Hammer": "fist",
	"G-Max Headbutt": "impact",
	"G-Max Hurricane": "whirl",
	"G-Max Juggernaut": "shard",
	"G-Max Malodor": "veil",
	"G-Max One Blow": "impact",
	"G-Max Pincer": "torrent",
	"G-Max Pulverization": "roar",
	"G-Max Pump": "torrent",
	"G-Max Rapid Flow": "quake",
	"G-Max Riot": "bolt",
	"G-Max Rolling": "gyro",
	"G-Max Smite": "pulse",
	"G-Max Spiral": "whirl",
	"G-Max Swallow Up": "veil",
	"G-Max Thunder": "bolt",
	"G-Max Toxbreeze": "bloom",
	"G-Max Volt Tackle": "bolt",
	"G-Max Wave": "torrent",
	"G-Max Whisk": "pulse",
	"G-Max Wildfire": "flame",
	"G Scope": "impact",
	"Gadget Bolt": "bolt",
	"Gadget Show": "bolt",
	"Gaia Blast": "boom",
	"Gaia Blaster": "boom",
	"Gaia Crush": "impact",
	"Gaia Hammer": "fist",
	"Gaia Impact": "impact",
	"Gaia Press": "impact",
	"Gaia Punk": "quake",
	"Gaia Volcano": "quake",
	"Gaia Wave": "torrent",
	"Gale Blade": "slash",
	"Gale Claws": "slash",
	"Gale Roundhouse": "whirl",
	"Gale Slash": "slash",
	"Gale Thrust": "whirl",
	"Gallop": "flame",
	"Gang Up": "veil",
	"Garbage Attack": "impact",
	"Garbage Collection": "pulse",
	"Garland Ray": "beam",
	"Garnet Volley": "flame",
	"Gas Bomb": "powder",
	"Gas Bond": "powder",
	"Gastro Acid": "acid",
	"Gather Energy": "impact",
	"Gather Flowers": "impact",
	"Gather Food": "veil",
	"Gather Light": "sparkle",
	"Gather Order": "bloom",
	"Gather Strength": "roar",
	"Gather Sunlight": "bloom",
	"Gather the Crew": "impact",
	"Gather Up": "impact",
	"Gathering Food": "shard",
	"Gathering Footsteps": "quake",
	"Gatling Peck": "barrage",
	"Gatling Slug": "shard",
	"Gatling Tar": "quake",
	"Gear Cutter": "slash",
	"Gear Grind": "gyro",
	"Gear Scan": "shard",
	"Gear Smash": "quake",
	"Gear Spinner": "shard",
	"Gear Throw": "quake",
	"Gemini Laser": "beam",
	"Gemstone Mimicry": "pulse",
	"Generate Cold": "torrent",
	"Generate Electricity": "bolt",
	"Genetic Memory": "torrent",
	"Genome Charge": "impact",
	"Genome Hacking": "pulse",
	"Genome Spiral": "whirl",
	"Gentle Bite": "bite",
	"Gentle Flames": "flame",
	"Gentle Kick": "kick",
	"Gentle Light": "sparkle",
	"Gentle Slap": "impact",
	"Gentle Song": "note",
	"Gentle Wrap": "wrap",
	"Geo Cannon": "cannon",
	"Geo Gate": "pulse",
	"Geo Hunt": "pulse",
	"Geo Impact": "impact",
	"Geo Storm": "whirl",
	"Geoburst": "pulse",
	"Geobuster": "impact",
	"Geomancy": "sparkle",
	"Geostrike": "quake",
	"Gesture": "impact",
	"Get Angry": "torrent",
	"Get Even": "quake",
	"Get Help": "bloom",
	"Get Lost": "pulse",
	"Get Loud": "torrent",
	"GG End-GX": "roar",
	"Ghastly Sound": "pulse",
	"Ghost Eye": "daze",
	"Ghost Hammer": "fist",
	"Ghost Hand": "veil",
	"Ghost Head": "veil",
	"Ghostly Blow": "veil",
	"Ghostly Cries": "veil",
	"Ghostly Touch": "veil",
	"Ghostly Trip": "veil",
	"Giant Bloom": "bloom",
	"Giant Bouquet": "bloom",
	"Giant Claw": "slash",
	"Giant Fangs": "bite",
	"Giant Geyser-GX": "torrent",
	"Giant Growth": "impact",
	"Giant Horn": "drill",
	"Giant Rock": "meteor",
	"Giant Stomp": "impact",
	"Giant Tail": "tail",
	"Giant Tusk": "quake",
	"Giant Twister": "impact",
	"Giant Wave": "torrent",
	"Giant Whirlpool": "torrent",
	"Gift Delivery": "bolt",
	"Gift of Spite": "drain",
	"Giga Blaster": "boom",
	"Giga Burn": "flame",
	"Giga Claw": "slash",
	"Giga Drain": "drain",
	"Giga Frost": "frost",
	"Giga Hammer": "fist",
	"Giga Horn": "drill",
	"Giga Impact": "impact",
	"Giga Power": "impact",
	"Giga Railgun": "bolt",
	"Giga Turbo": "impact",
	"Gigacrush": "veil",
	"Gigafall-GX": "veil",
	"Gigantic Bolt": "bolt",
	"Gigantic Press": "impact",
	"Gigantic Tusks": "quake",
	"Giganticannon": "impact",
	"Gigas Punch": "fist",
	"Gigashock": "bolt",
	"Gigaspark": "bolt",
	"Gigaton Bash": "impact",
	"Gigaton Break": "impact",
	"Gigaton Hammer": "fist",
	"Gigaton Punch": "fist",
	"Gigaton Shake": "quake",
	"Gigaton Stomp": "impact",
	"Gigatron-GX": "bolt",
	"Gigavolt": "bolt",
	"Give Aid": "pulse",
	"Glacial Lance": "torrent",
	"Glaciate": "torrent",
	"Glacier Drop": "torrent",
	"Glance": "impact",
	"Glare": "daze",
	"Glare and Peck": "daze",
	"Glide": "impact",
	"Glinting Claw": "slash",
	"Glistening Droplets": "drain",
	"Glittering Eyes": "daze",
	"Glittering Gift": "pulse",
	"Glutton-GX": "veil",
	"Gluttonous Tail": "tail",
	"Gnash Teeth": "daze",
	"Gnaw": "bite",
	"Gnaw and Run": "bite",
	"Gnaw Off": "bite",
	"Gnaw Relentlessly": "bite",
	"Gnaw the Wound": "bite",
	"Gnaw Through": "bite",
	"Gnaw Up": "bite",
	"Go and Collect": "impact",
	"Go Fetch": "sparkle",
	"Goad 'n' Grab": "veil",
	"Gobble Down": "shard",
	"Gold Breaker": "impact",
	"Gold Rush": "impact",
	"Gold Scale": "torrent",
	"Golurk Hammer": "fist",
	"Good Morning": "pulse",
	"Good Night": "veil",
	"Good Night Song": "note",
	"Good Punch": "fist",
	"Gooey": "drain",
	"Gooey Thread": "web",
	"Gooped Up": "veil",
	"Gormandizer": "impact",
	"Gossip": "drain",
	"Gouge": "bloom",
	"Grab": "impact",
	"Graffiti": "sleep",
	"Grainy Sand": "sand",
	"Grand Bloom-GX": "bloom",
	"Grand Bolt": "bolt",
	"Grand Echo-GX": "drain",
	"Grand Falls": "torrent",
	"Grand Flame": "flame",
	"Grand Loop": "bloom",
	"Grand Swell": "quake",
	"Grand Wave": "torrent",
	"Grandiose Fangs": "bite",
	"Granite Head": "impact",
	"Grasping Draw": "pulse",
	"Grasping Vine": "bloom",
	"Grass Cocooning": "drain",
	"Grass Fire": "flame",
	"Grass Kagura": "bloom",
	"Grass Knot": "bloom",
	"Grass Munch": "bite",
	"Grass' Power": "torrent",
	"Gravdrop": "impact",
	"Graveyard Gamboling": "pulse",
	"Gravitational Drop": "shard",
	"Gravitational Tackle": "impact",
	"Gravity Wave": "torrent",
	"Great Bash": "impact",
	"Great Swing": "impact",
	"Greedy Crush": "impact",
	"Greedy Draw": "bolt",
	"Greedy Fang": "bite",
	"Greedy Hunt": "veil",
	"Green Acid": "acid",
	"Green Blast": "boom",
	"Green Call": "bloom",
	"Green Dance": "whirl",
	"Green Draw": "bloom",
	"Green Fling": "torrent",
	"Green Force": "bloom",
	"Green Heal": "drain",
	"Greenness": "bloom",
	"Grenade Hammer": "fist",
	"Grimhound Flare": "flame",
	"Grind": "veil",
	"Grindcore": "veil",
	"Grip and Squeeze": "bloom",
	"Gripthrow": "torrent",
	"Gritty Claws": "slash",
	"Gritty Comeback": "drain",
	"Groovy Dance": "whirl",
	"Grope": "impact",
	"Ground Beat": "impact",
	"Ground Burn": "flame",
	"Ground Crasher": "quake",
	"Ground Crush": "impact",
	"Ground Frost": "frost",
	"Ground Melter": "flame",
	"Ground Slash": "slash",
	"Ground Stream": "stream",
	"Groundquake": "quake",
	"Group Attack": "bloom",
	"Group Beatdown": "impact",
	"Group Swim": "torrent",
	"Group Therapy": "drain",
	"Growing Tall": "wing",
	"Growl": "sonic",
	"Growth": "bloom",
	"Growth Spurt": "bloom",
	"Grudge": "pulse",
	"Grudge Dive": "torrent",
	"Guard Claw": "slash",
	"Guard Press": "shield",
	"Guarded Rolling": "gyro",
	"Guardian Burst": "boom",
	"Guiding Flame": "flame",
	"Guillotine": "bloom",
	"Guillotine-GX": "bloom",
	"Guillotine Hug": "bloom",
	"Guillotine Rush": "impact",
	"Gulf Stream": "stream",
	"Gulp Down": "torrent",
	"Gummy Press": "impact",
	"Gumshoe Chance-GX": "impact",
	"Gunk Shot": "acid",
	"Gunky": "pulse",
	"Gust": "whirl",
	"Gusting Collision": "torrent",
	"Gut Blow": "impact",
	"Gut Kick": "kick",
	"Gut Punch": "fist",
	"Gut Spin": "whirl",
	"Gut Strike": "impact",
	"Gutsy Hammer": "fist",
	"Gutsy Swing": "impact",
	"Guzzle": "drain",
	"Gyro Ball": "gyro",
	"Gyro Swap": "drain",
	"Hack At": "veil",
	"Hack Off": "shard",
	"Hacking": "impact",
	"Hadron Ray": "beam",
	"Hadron Spark": "bolt",
	"Hail": "frost",
	"Hail Blade": "slash",
	"Hail Blizzard": "frost",
	"Hail Claw": "slash",
	"Hail Prison": "frost",
	"Hail Storm": "frost",
	"Hailstone": "torrent",
	"Hailstorm": "torrent",
	"Hammer Arm": "fist",
	"Hammer In": "fist",
	"Hammer Kick": "kick",
	"Hammer-lanche": "fist",
	"Hammer Pressure": "fist",
	"Hammerhead": "quake",
	"Hammering Tail": "tail",
	"Hand Charge": "impact",
	"Hand Control": "pulse",
	"Hand Fling": "impact",
	"Hand Kinesis": "pulse",
	"Hand of Djinn": "veil",
	"Hand Press": "impact",
	"Hand Refresh": "pulse",
	"Hand Trick": "impact",
	"Hand Trim": "impact",
	"Hang Down": "bloom",
	"Hang High": "impact",
	"Hangry Blaster": "boom",
	"Hangry Spike": "sting",
	"Hangry Tackle": "impact",
	"Happened to Headbutt": "impact",
	"Happy Chance": "impact",
	"Happy Cyclone": "whirl",
	"Happy Delivery": "torrent",
	"Happy Mime": "sparkle",
	"Happy Punch": "fist",
	"Happy Return": "pulse",
	"Happy Turn": "impact",
	"Harass": "veil",
	"Hard Bashing": "shard",
	"Hard Bite": "bite",
	"Hard Bone": "bone",
	"Hard Crash": "impact",
	"Hard Crunch": "bite",
	"Hard Crush": "impact",
	"Hard Face": "torrent",
	"Hard Feelings": "drain",
	"Hard Gears": "shard",
	"Hard Head": "impact",
	"Hard Headbutt": "impact",
	"Hard Metal": "shard",
	"Hard Plant": "bloom",
	"Hard Press": "impact",
	"Hard Roll": "gyro",
	"Hard Scissors": "slash",
	"Hard Swing": "impact",
	"Hard Tackle": "impact",
	"Hard Times Slash": "slash",
	"Harden": "shard",
	"Harmonious Spirit Palm": "quake",
	"Harmonize": "impact",
	"Harrumph": "impact",
	"Harsh Fluid": "veil",
	"Hasty Headbutt": "impact",
	"Hatch": "drain",
	"Haughty Order": "impact",
	"Haul In": "quake",
	"Haunt": "drain",
	"Haymaker": "torrent",
	"Hazard Stinger": "bloom",
	"Hazardous Claws": "slash",
	"Hazardous Greed": "bloom",
	"Hazardous Scales": "sleep",
	"Hazardous Tail": "tail",
	"Hazardous Venom": "veil",
	"Haze Slash": "slash",
	"Head Bolt": "bolt",
	"Head Charge": "impact",
	"Head Crack": "impact",
	"Head Hunt": "impact",
	"Head Smash": "quake",
	"Head Swing": "impact",
	"Head Walking": "impact",
	"Headache": "torrent",
	"Headbang": "impact",
	"Headbutt": "impact",
	"Headbutt Bounce": "impact",
	"Headlock": "bolt",
	"Headpress": "impact",
	"Headstrike": "veil",
	"Headwind": "impact",
	"Heal Bell": "drain",
	"Heal Pulse": "drain",
	"Healing Circle": "drain",
	"Healing Dance": "drain",
	"Healing Dust": "drain",
	"Healing Egg": "drain",
	"Healing Fruit": "drain",
	"Healing Light": "drain",
	"Healing Look": "drain",
	"Healing Melody": "drain",
	"Healing Milk": "drain",
	"Healing Oasis": "drain",
	"Healing Pheromone": "drain",
	"Healing Pirouette": "drain",
	"Healing Pollen": "drain",
	"Healing Scale": "drain",
	"Healing Sea": "drain",
	"Healing Song": "note",
	"Healing Sound": "drain",
	"Healing Steps": "drain",
	"Healing Trial": "drain",
	"Healing Water": "torrent",
	"Healing Wave": "torrent",
	"Healing Wish": "drain",
	"Healing Wrapping": "drain",
	"Healwing": "drain",
	"Heap Up": "shard",
	"Heart Sign": "pulse",
	"Heart Stamp": "pulse",
	"Heart-Stopping Kiss": "kiss",
	"Heart Wink": "torrent",
	"Heartfelt Shine": "impact",
	"Heartfelt Song": "note",
	"Hearthflame Dance": "flame",
	"Heat Acceleration": "flame",
	"Heat Assist": "flame",
	"Heat Bazooka": "flame",
	"Heat Beak": "flame",
	"Heat Blast": "flame",
	"Heat Blow": "flame",
	"Heat Boiler": "flame",
	"Heat Breath": "flame",
	"Heat Burn": "flame",
	"Heat Charged": "flame",
	"Heat Crash": "flame",
	"Heat Crawler": "flame",
	"Heat Dash": "flame",
	"Heat Dive": "flame",
	"Heat Ray": "beam",
	"Heat Stage": "flame",
	"Heat Tackle": "flame",
	"Heat Typhoon": "flame",
	"Heat-Up Crunch": "flame",
	"Heat Wave": "stream",
	"Heated Poison": "flame",
	"Heave": "impact",
	"Heavy Blizzard": "frost",
	"Heavy Blow": "impact",
	"Heavy Bone": "bone",
	"Heavy Bullet": "cannon",
	"Heavy Choke": "pulse",
	"Heavy Draw": "impact",
	"Heavy Hold": "impact",
	"Heavy Impact": "impact",
	"Heavy Metal": "shard",
	"Heavy Nose": "shard",
	"Heavy Perfume": "daze",
	"Heavy Pincers": "torrent",
	"Heavy Potential": "drain",
	"Heavy Press": "impact",
	"Heavy Punch": "fist",
	"Heavy Rock Artillery": "meteor",
	"Heavy Rock-GX": "meteor",
	"Heavy Rocket": "quake",
	"Heavy Slam": "iron",
	"Heavy Snow": "frost",
	"Heavy Splash": "torrent",
	"Heavy Stomp": "impact",
	"Heavy Storm": "whirl",
	"Heavy Suplex": "bloom",
	"Heavy Thunder": "bolt",
	"Heavy Whip": "slash",
	"Heel Drop": "quake",
	"Hefty Cannon": "cannon",
	"Hefty Whip": "slash",
	"Held-Item Inspection": "impact",
	"Helicoptero": "quake",
	"Helix Force": "pulse",
	"Helpful Slash": "slash",
	"Helping Hand": "bloom",
	"Herd Charge": "impact",
	"Heroic Punch": "fist",
	"Hex": "wisp",
	"Hex Hurl": "wisp",
	"Hexa-Magic": "pulse",
	"Hexed Flame": "flame",
	"Hexed Mirror": "veil",
	"Hexing Flight": "whirl",
	"Hibernation Spore": "powder",
	"Hidden Power": "aura",
	"Hide": "pulse",
	"Hide a Berry": "bloom",
	"Hide and Seek": "bloom",
	"Hide Crowd": "veil",
	"Hide in Shadows": "veil",
	"Hide in Shell": "shell",
	"High Breaching": "torrent",
	"High Flight": "whirl",
	"High Hat": "impact",
	"High-Heat Blast": "flame",
	"High Horsepower": "quake",
	"High-Impact Kick": "kick",
	"High Jump Kick": "kick",
	"High-Pressure Blast": "boom",
	"High-Pressure Heat": "flame",
	"High-Speed Charge": "impact",
	"High Tide": "torrent",
	"High Volt": "bolt",
	"High Voltage": "bolt",
	"High-Voltage Cannon": "cannon",
	"High-Voltage Current": "bolt",
	"High-Voltage Knuckle": "fist",
	"High-Voltage Press": "impact",
	"High Water": "torrent",
	"Hind Kick": "kick",
	"Hip Bump": "impact",
	"Hit and Hide": "impact",
	"Hit and Run": "impact",
	"Hit Back": "impact",
	"Hit Twice": "impact",
	"Hoard": "impact",
	"Hocus Pinkus": "sparkle",
	"Hold Still": "drain",
	"Hole-Diggin' Noggin": "quake",
	"Hollow Binding": "pulse",
	"Hollow Dive": "torrent",
	"Hollow Flame": "flame",
	"Hollow Geist": "pulse",
	"Hollow Hands": "pulse",
	"Hollow Hunt-GX": "bloom",
	"Hollow Missile": "pulse",
	"Holon Blizzard": "frost",
	"Holon Draw": "impact",
	"Holon Search": "flame",
	"Holon Splash": "torrent",
	"Holy Flame": "flame",
	"Holy Star": "swift",
	"Home Ground": "quake",
	"Homeward Chime": "pulse",
	"Homing Headbutt": "impact",
	"Homing Pidove": "impact",
	"Homing Uppercut": "fist",
	"Honcho's Command": "veil",
	"Hone Claws": "slash",
	"Hone ClawsScratch": "quake",
	"Honey Courier": "bloom",
	"Honey Rush": "impact",
	"Honey Scent": "powder",
	"Honey Snack": "drain",
	"Hoodwink": "pulse",
	"Hook": "bloom",
	"Hook Shot": "cannon",
	"Hop": "bloom",
	"Hop on My Back": "torrent",
	"Hopeless Scream": "bloom",
	"Hopping Shot": "cannon",
	"Horn Attack": "drill",
	"Horn Charge": "drill",
	"Horn Drill": "drill",
	"Horn Grab": "drill",
	"Horn Hazard": "drill",
	"Horn Leech": "drain",
	"Horn Pierce": "drill",
	"Horn Rend": "slash",
	"Horn Rush": "drill",
	"Horn Slash": "slash",
	"Horn Swipe": "drill",
	"Horn Thrust": "drill",
	"Horn Toss": "drill",
	"Horoscope": "pulse",
	"Horrid Pollen": "powder",
	"Horrifying Bite": "bite",
	"Horrifying Fang": "bite",
	"Horrifying Revenge": "pulse",
	"Horrifying Rondo": "pulse",
	"Horror Chant": "pulse",
	"Horror House-GX": "pulse",
	"Horror Note": "pulse",
	"Hospitality": "drain",
	"Hostile Fang": "bite",
	"Hot Air": "flame",
	"Hot Bite": "bite",
	"Hot Burn-GX": "flame",
	"Hot Lick": "lick",
	"Hot Magma": "flame",
	"Hound's Fang": "bite",
	"Hover Heal": "drain",
	"Hover Hit": "impact",
	"Hover Over": "bolt",
	"Howl": "sonic",
	"Howl in the Dark": "sonic",
	"Howling Rampage": "torrent",
	"Hug": "pulse",
	"Huge Bite": "bite",
	"Huge Tackle": "impact",
	"Humming Charge": "impact",
	"Hundred-Blows Impact": "impact",
	"Hundred Foot Flames": "flame",
	"Hundred Furious Blows": "quake",
	"Hundred Furious Lashes": "bloom",
	"Hundred Furious Punches": "fist",
	"Hundred-Hitting Ball": "aura",
	"Hungrily Draw": "impact",
	"Hungry Jaws": "bite",
	"Hunt": "veil",
	"Hunter's Nails": "flame",
	"Hunting Arrow": "arrow",
	"Hunting Claw": "slash",
	"Hunting Pack": "veil",
	"Hurl into Darkness": "veil",
	"Hurricane": "whirl",
	"Hurricane Blender": "whirl",
	"Hurricane Call": "whirl",
	"Hurricane Kick": "kick",
	"Hurricane of Needles": "whirl",
	"Hurricane Punch": "fist",
	"Hurricane Shock": "bolt",
	"Hurricane Tail": "tail",
	"Hurricane Wing": "wing",
	"Hustle Punch": "fist",
	"Hustling Strike": "impact",
	"Hydra Breath": "breath",
	"Hydro Bazooka": "torrent",
	"Hydro Bombard": "torrent",
	"Hydro Break": "torrent",
	"Hydro Burn": "flame",
	"Hydro Crunch": "torrent",
	"Hydro Impact": "torrent",
	"Hydro Jet": "torrent",
	"Hydro Kick": "kick",
	"Hydro Knuckle": "fist",
	"Hydro Lander": "torrent",
	"Hydro Launcher": "torrent",
	"Hydro Press": "torrent",
	"Hydro Pressure": "torrent",
	"Hydro Pump": "wave",
	"Hydro Pump-GX": "wave",
	"Hydro Punch": "torrent",
	"Hydro Reflect": "torrent",
	"Hydro Reverse": "torrent",
	"Hydro Shot": "torrent",
	"Hydro Snipe": "torrent",
	"Hydro Splash": "torrent",
	"Hydro Tackle": "torrent",
	"Hydro Turn": "torrent",
	"Hydro Wave": "torrent",
	"Hydrocannon": "torrent",
	"Hydrocutter": "torrent",
	"Hydrokinesis": "pulse",
	"Hydrosplash": "torrent",
	"Hyper Beam": "beam",
	"Hyper Beam-GX": "beam",
	"Hyper Cannon": "cannon",
	"Hyper Claws": "slash",
	"Hyper Fang": "bite",
	"Hyper Flame": "flame",
	"Hyper Healing": "drain",
	"Hyper Jump": "torrent",
	"Hyper Lariat": "impact",
	"Hyper Needle": "sting",
	"Hyper Pump": "torrent",
	"Hyper Ray": "beam",
	"Hyper Reverse": "drain",
	"Hyper Splash": "torrent",
	"Hyper Tail": "tail",
	"Hyper Voice": "sonic",
	"Hyper Whirlpool": "torrent",
	"Hyperspace Fury": "barrage",
	"Hyperspace Punch": "fist",
	"Hyperspace Ring": "pulse",
	"Hypno Hammer": "fist",
	"Hypno Headbutt": "pulse",
	"Hypno Roll": "gyro",
	"Hypno Splash": "torrent",
	"Hypno Wave": "torrent",
	"Hypnoblast": "boom",
	"Hypnoshower": "pulse",
	"Hypnosis": "pulse",
	"Hypnosplash": "pulse",
	"Hypnostrike": "pulse",
	"Hypnotic Blizzard": "frost",
	"Hypnotic Gaze": "pulse",
	"Hypnotic Ray": "beam",
	"Hypnotic Reign": "pulse",
	"Hypnotic Stare": "pulse",
	"I Choose You!": "bolt",
	"Ice Age": "frost",
	"Ice Ball": "frost",
	"Ice Barrier": "frost",
	"Ice Beam": "beam",
	"Ice Beam-GX": "beam",
	"Ice Bind": "frost",
	"Ice Blade": "slash",
	"Ice Blast": "frost",
	"Ice Block": "frost",
	"Ice Bonus": "frost",
	"Ice Breath": "frost",
	"Ice Burn": "flame",
	"Ice Chain": "frost",
	"Ice Cyclone": "frost",
	"Ice Edge": "frost",
	"Ice Entomb": "frost",
	"Ice Fang": "frost",
	"Ice Generator": "frost",
	"Ice Gift": "frost",
	"Ice Hammer": "frost",
	"Ice Over": "frost",
	"Ice Path-GX": "frost",
	"Ice Pillar": "frost",
	"Ice Prison": "frost",
	"Ice Punch": "frost",
	"Ice Reflect": "frost",
	"Ice Rider": "frost",
	"Ice Shard": "fall",
	"Ice Shot": "frost",
	"Ice Throw": "frost",
	"Ice Wing": "frost",
	"Iceberg Breaker": "frost",
	"Iceberg Crush": "frost",
	"Iceberg Press": "frost",
	"Icecalibur": "frost",
	"Icicle": "frost",
	"Icicle Barb": "frost",
	"Icicle Crash": "fall",
	"Icicle Loop": "frost",
	"Icicle Missile": "frost",
	"Icicle Punch": "frost",
	"Icicle Shot": "frost",
	"Icicle Sole": "frost",
	"Icy Breath": "frost",
	"Icy Kiss": "kiss",
	"Icy Snow": "frost",
	"Icy Wind": "frost",
	"Ideal Fishing Day": "torrent",
	"Identify": "impact",
	"Igloo Hold": "torrent",
	"Ignite": "flame",
	"Illumisile": "bloom",
	"Illusory Hijacking": "veil",
	"Illusory Impulse": "roar",
	"Imitate": "impact",
	"Imittack": "impact",
	"Impact Blow": "impact",
	"Impact Bolt": "bolt",
	"Impaling Tusk": "quake",
	"Impersonate": "veil",
	"Impersonation": "pulse",
	"Important Errands": "impact",
	"Impound": "bloom",
	"Improvisational Performance": "bloom",
	"Incendiary Pillar": "flame",
	"Incendiary Thunder": "bolt",
	"Incessant Incisors": "impact",
	"Incessant Onslaught": "bolt",
	"Incessant Peck": "barrage",
	"Incessant Punching": "fist",
	"Incinerate": "stream",
	"Incite": "torrent",
	"Increasing Spice": "bloom",
	"Incredible Snore": "sleep",
	"Indomitable Blaze": "flame",
	"Infernal Slash": "slash",
	"Infernal Vortex": "flame",
	"Inferno": "flame",
	"Inferno Dance": "flame",
	"Inferno Fang": "flame",
	"Inferno Kick Flurry": "kick",
	"Inferno Onrush": "flame",
	"Inferno Spear": "flame",
	"Inferno Wings": "flame",
	"Inferno X": "flame",
	"Infestation": "pulse",
	"Infiltrate": "veil",
	"Infinite Force": "sparkle",
	"Infinite Wind": "whirl",
	"Infinite Wing": "wing",
	"Infinity": "flame",
	"Inflame": "flame",
	"Influence": "torrent",
	"Ingot Swing": "impact",
	"Ingrain": "bloom",
	"Injection-GX": "roar",
	"Ink Blast": "boom",
	"Ink Bomb": "boom",
	"Ink Spit": "torrent",
	"Ink Spurt": "torrent",
	"Inquire": "impact",
	"Insatiable Striking": "torrent",
	"Inspiring Dance": "whirl",
	"Insta-Strike": "impact",
	"Instant Freeze": "frost",
	"Instigate": "veil",
	"Intelligence Gathering": "bloom",
	"Intense Glare": "daze",
	"Intense Kiss": "kiss",
	"Intensifying Burn": "flame",
	"Intentional Grounding": "quake",
	"Intercept-GX": "pulse",
	"Interjet": "torrent",
	"Interrupt": "bloom",
	"Intimidate": "bloom",
	"Intimidating Stare": "impact",
	"Intimidation Pebble": "torrent",
	"Into the Deep": "torrent",
	"Invade": "quake",
	"Invigorate": "drain",
	"Invisible Hand": "quake",
	"Invite and Strike": "impact",
	"Invite Evil": "veil",
	"Invite Out": "quake",
	"Inviting Bell": "pulse",
	"Inviting Flowers": "pulse",
	"Inviting Kiss": "kiss",
	"Inviting Poison": "veil",
	"Inviting Scent": "powder",
	"Inviting Trap": "wrap",
	"Ion Blast": "boom",
	"Ion Pool": "torrent",
	"Ire-Fly": "whirl",
	"Iron Bash": "impact",
	"Iron Beam Breaker": "beam",
	"Iron Blaster": "boom",
	"Iron Breaker": "shard",
	"Iron Buster": "shard",
	"Iron Cannon": "cannon",
	"Iron-Clad Roll": "gyro",
	"Iron Collecting": "shard",
	"Iron Crash": "shard",
	"Iron Crusher": "shard",
	"Iron Defense": "shard",
	"Iron Feathers": "shard",
	"Iron Fist": "fist",
	"Iron Fist of Justice": "fist",
	"Iron Force-GX": "shard",
	"Iron Hammer": "fist",
	"Iron Hand": "shard",
	"Iron Head": "iron",
	"Iron Intake": "shard",
	"Iron Lance": "shard",
	"Iron Roar": "sonic",
	"Iron Rule-GX": "shard",
	"Iron Shake-Up": "shard",
	"Iron Smash": "quake",
	"Iron Smasher": "shard",
	"Iron Supply": "shard",
	"Iron Swing": "shard",
	"Iron Tackle": "shard",
	"Iron Tail": "iron",
	"Iron Wing": "shard",
	"Iron Wings": "shard",
	"Irongrip": "torrent",
	"Irritated Bomb": "boom",
	"Irritated Outburst": "veil",
	"Itchy Pollen": "powder",
	"Item Maniac-GX": "veil",
	"Jab": "quake",
	"Jabber On": "impact",
	"Jagged Fang": "bite",
	"Jagged Saber": "bloom",
	"Jam-Packed": "bloom",
	"Jamming Wing": "wing",
	"Jaw Bite": "bite",
	"Jaw Clamp": "bite",
	"Jaw Lock": "bite",
	"Jazzed": "impact",
	"Jealous Eyes": "daze",
	"Jealously Singe": "flame",
	"Jellyfish Pod": "torrent",
	"Jellyfish Poison": "veil",
	"Jellyfish Sting": "sting",
	"Jet Assault": "impact",
	"Jet Bite": "bite",
	"Jet Blast": "boom",
	"Jet Cyclone": "whirl",
	"Jet Draft": "impact",
	"Jet Headbutt": "impact",
	"Jet Impact": "impact",
	"Jet Needle": "sting",
	"Jet of Ink": "impact",
	"Jet Pierce": "impact",
	"Jet Punch": "fist",
	"Jet Return": "impact",
	"Jet Screw": "impact",
	"Jet Shoot": "impact",
	"Jet Smash": "quake",
	"Jet Sonic": "sonic",
	"Jet Spear": "impact",
	"Jet Sword": "slash",
	"Jet Wing": "wing",
	"Jet Woofer": "impact",
	"Jetting Blow": "impact",
	"Jewel Breaker": "impact",
	"Jeweled Gift": "veil",
	"Jingly Noise": "pulse",
	"Jolt": "bolt",
	"Jolting Charge": "impact",
	"Joust": "pulse",
	"Joy Maker-GX": "impact",
	"Judgement": "pulse",
	"Judgment": "impact",
	"Judgment Blast": "boom",
	"Judgment Surge": "roar",
	"Juggernaut Horn": "drill",
	"Juggling": "pulse",
	"Jump": "torrent",
	"Jump Blues": "bloom",
	"Jump Catch": "impact",
	"Jump Kick": "kick",
	"Jump On": "impact",
	"Jump Over": "flame",
	"Jump Tackle": "impact",
	"Jumping Balloon": "impact",
	"Jumping Kick": "kick",
	"Jumping Press": "impact",
	"Jumping Shot": "cannon",
	"Jumping Side Kick": "kick",
	"Jumping Uppercut": "fist",
	"Jungle Blast": "boom",
	"Jungle Dump": "bloom",
	"Jungle Edge": "slash",
	"Jungle Hammer": "fist",
	"Jungle Heal-GX": "drain",
	"Jungle Rage": "rage",
	"Jungle Rising": "bloom",
	"Jungle Whip": "slash",
	"Junk Hunt": "veil",
	"Junk Magnet": "bolt",
	"Junk Spark": "bolt",
	"Jurassic Hammer": "fist",
	"Justice Kick": "kick",
	"Justified Press": "impact",
	"Juxtapose": "drain",
	"Kaboom Doll": "drain",
	"Kaiser Tackle": "impact",
	"Kaleidostorm": "sparkle",
	"Kaleidowaltz": "impact",
	"Karate Chop": "chop",
	"Keen Eye": "daze",
	"Keep Calling": "torrent",
	"Kerzap": "bolt",
	"Kick": "kick",
	"Kick Away": "kick",
	"Kick Down": "kick",
	"Kick of Righteousness": "kick",
	"Kick Shot": "kick",
	"Kindle": "flame",
	"Kindling Panic": "flame",
	"Kindred Kick": "kick",
	"King's Drum": "pulse",
	"King's Instructions": "bloom",
	"King's Order": "torrent",
	"King's Shield": "shield",
	"Kingly Impact": "impact",
	"Knickknack Carrying": "veil",
	"Knife Leaf": "bloom",
	"Knock Away": "impact",
	"Knock Back": "quake",
	"Knock Down": "quake",
	"Knock Flat": "quake",
	"Knock Off": "veil",
	"Knock Over": "impact",
	"Knocking Hammer": "fist",
	"Knockout Needle": "sting",
	"Knockout Reviver": "pulse",
	"Knuckle Blast": "fist",
	"Knuckle Claws": "slash",
	"Knuckle Down": "fist",
	"Knuckle Impact": "fist",
	"Knuckle Justice": "fist",
	"Knuckle Punch": "fist",
	"Knuckle Sandwich": "sand",
	"KO Crab": "torrent",
	"Krookoroll": "quake",
	"Labyrinth of Shadows": "veil",
	"Lagoon Flight": "whirl",
	"Laid-Back Tackle": "impact",
	"Lambaste": "veil",
	"Land Collapse": "quake",
	"Land Crush": "impact",
	"Land Laser": "beam",
	"Land Maker": "quake",
	"Land's Judgment": "quake",
	"Land's Pulse": "pulse",
	"Land's Wrath": "quake",
	"Land Scoop": "quake",
	"Land Shake": "quake",
	"Land Sonic": "sonic",
	"Land Stream": "stream",
	"Landslide": "quake",
	"Landslip": "quake",
	"Lap Up": "impact",
	"Large Whirlpool": "torrent",
	"Lariat": "impact",
	"Larimar Rain": "torrent",
	"Laser Blade": "slash",
	"Laser Focus": "beam",
	"Last-Chance Chop": "chop",
	"Last-Chance Punch": "fist",
	"Last Resort": "impact",
	"Last Respects": "pulse",
	"Last Scene": "pulse",
	"Latent Power": "torrent",
	"Lateral Eggsplosion": "pulse",
	"Laundry-Go-Round": "note",
	"Lava Burn": "flame",
	"Lava Burst": "flame",
	"Lava Flow": "flame",
	"Lava Plume": "flame",
	"Lava Wall": "flame",
	"Lavish Hospitality": "shard",
	"Law of the Underworld": "drain",
	"Lay the Smackdown-GX": "veil",
	"Layabout": "drain",
	"Lazy Attack": "pulse",
	"Lazy Blow": "impact",
	"Lazy Headbutt": "impact",
	"Lazy Howl": "sonic",
	"Lazy Press": "impact",
	"Lazy Punch": "fist",
	"Lead": "impact",
	"Leaf Bind": "bloom",
	"Leaf Blade": "slash",
	"Leaf Blast": "bloom",
	"Leaf Boomerang": "bloom",
	"Leaf Bringer": "bloom",
	"Leaf Cutter": "slash",
	"Leaf Cyclone": "bloom",
	"Leaf Drain": "drain",
	"Leaf Guard": "bloom",
	"Leaf Honey": "bloom",
	"Leaf Hurricane": "bloom",
	"Leaf Litter Tackle": "bloom",
	"Leaf Munch": "bloom",
	"Leaf Needle": "sting",
	"Leaf Poison": "bloom",
	"Leaf Refresh": "bloom",
	"Leaf Shade": "bloom",
	"Leaf Slice": "slash",
	"Leaf Step": "bloom",
	"Leaf Storm": "petal",
	"Leaf Supply": "bloom",
	"Leaf Tornado": "bloom",
	"Leaf Wallop": "bloom",
	"Leafage": "petal",
	"Leaflet Blessings": "drain",
	"Leaflet Dance": "whirl",
	"Leafy Charge": "impact",
	"Leafy Cyclone": "whirl",
	"Leaking Gas": "powder",
	"Leap": "torrent",
	"Leap Out": "torrent",
	"Leap Over": "veil",
	"Leap to Leap": "bloom",
	"Learning": "impact",
	"Leech Life": "drain",
	"Leech Seed": "drain",
	"Leek Clobber": "impact",
	"Leek Jab": "impact",
	"Leek Lash": "impact",
	"Leek Rush": "impact",
	"Leek Slam": "impact",
	"Leek Slap": "impact",
	"Leek Strike": "impact",
	"Leer": "daze",
	"Leg Quake": "quake",
	"Leg Stomp": "impact",
	"Legend Ceremony": "shard",
	"Legendary Guidance": "pulse",
	"Let's All Rollout": "gyro",
	"Let's Eat Together": "drain",
	"Let's Play!": "bolt",
	"Let's Snuggle & Fall": "sparkle",
	"Let's Throw": "quake",
	"Levin Strike": "impact",
	"Liability": "drain",
	"Liberation-GX": "quake",
	"Libra Horn": "drill",
	"Lick": "lick",
	"Lick Away": "lick",
	"Lick Whip": "lick",
	"Lick Wounds": "lick",
	"Lickichop": "impact",
	"Licking Catch": "flame",
	"Licking Flames": "flame",
	"Licking Fury": "barrage",
	"Licking-Licking Heal": "drain",
	"Licking Shot": "cannon",
	"Licks Go Crazy": "impact",
	"Lie Low": "quake",
	"Life Drain": "drain",
	"Life Leap": "sparkle",
	"Life Saver": "torrent",
	"Life Squeeze": "drain",
	"Life Stream": "stream",
	"Life Sucker": "pulse",
	"Life Trick-GX": "drain",
	"Lifesplosion": "bloom",
	"Lifting": "pulse",
	"Light Kick": "kick",
	"Light of Life": "sparkle",
	"Light of the Protector-GX": "sparkle",
	"Light Poison": "veil",
	"Light Pulse": "pulse",
	"Light Punch": "fist",
	"Light Screen": "sparkle",
	"Light Steps": "sparkle",
	"Light Touch Throw": "quake",
	"Light Wave": "torrent",
	"Lighting-GX": "bolt",
	"Lightless World": "pulse",
	"Lightning Accelerator": "bolt",
	"Lightning Ball": "bolt",
	"Lightning Blast": "bolt",
	"Lightning Bolt": "bolt",
	"Lightning Burn": "flame",
	"Lightning Claw": "slash",
	"Lightning Crash": "bolt",
	"Lightning Crush": "bolt",
	"Lightning Cut": "slash",
	"Lightning Flash": "bolt",
	"Lightning Lancer": "bolt",
	"Lightning Laser": "beam",
	"Lightning Rampage": "bolt",
	"Lightning Ride-GX": "bolt",
	"Lightning Rod": "bolt",
	"Lightning Rondo": "bolt",
	"Lightning Shot": "bolt",
	"Lightning Slam": "bolt",
	"Lightning Spark": "bolt",
	"Lightning Sphere": "bolt",
	"Lightning Star": "swift",
	"Lightning Storm": "bolt",
	"Lightning Storm Star": "swift",
	"Lightning Strike": "bolt",
	"Lightning Tackle": "bolt",
	"Lightning Tail": "bolt",
	"Lightning Turn": "bolt",
	"Lightning Twister": "bolt",
	"Lightning Wall": "bolt",
	"Lightning Wing": "bolt",
	"Limber Up": "impact",
	"Limbo Limbo": "pulse",
	"Limit Break": "pulse",
	"Limitation": "veil",
	"Limited Delivery": "torrent",
	"Line Force": "torrent",
	"Linear Attack": "quake",
	"Link Blast": "boom",
	"Link Fusion": "pulse",
	"Link Needle": "sting",
	"Linked Lightning": "bolt",
	"Liquid Blow": "torrent",
	"Liquid Lashing": "torrent",
	"Liquidation": "wave",
	"Litter": "pulse",
	"Little Grudge": "pulse",
	"Live Coal": "flame",
	"Live Painting": "impact",
	"Live Wire": "bolt",
	"Lively": "drain",
	"Lively Cutter": "slash",
	"Lively Flower": "petal",
	"Lively Grouping": "torrent",
	"Lively Needles": "bloom",
	"Lively Tackle": "impact",
	"Lizard Poison": "veil",
	"Loaded Needle": "sting",
	"Loathe": "bloom",
	"Lock Gear": "shard",
	"Lock-on": "shard",
	"Lock Up": "pulse",
	"Lode Search": "veil",
	"Loll Roll Spin": "gyro",
	"Loneliness": "pulse",
	"Lonely Fang": "bite",
	"Long Tentacle": "wrap",
	"Long Tongue": "impact",
	"Long Whip": "slash",
	"Longhair Shot": "cannon",
	"Look-Alike Show": "pulse",
	"Look for Friends": "bloom",
	"Look for Keys": "sparkle",
	"Lookout": "quake",
	"Loom Over": "bloom",
	"Loop Cannon": "cannon",
	"Loop-the-Loop": "impact",
	"Lord's Valley": "veil",
	"Lordly Songleader": "torrent",
	"Losing Control": "veil",
	"Lost Blast": "boom",
	"Lost Boomerang-GX": "flame",
	"Lost Burn": "flame",
	"Lost Claw": "slash",
	"Lost Crisis": "veil",
	"Lost Crush": "impact",
	"Lost Dive": "torrent",
	"Lost Flame": "flame",
	"Lost Hack": "bolt",
	"Lost Headbutt": "impact",
	"Lost Impact": "impact",
	"Lost in the Waves": "pulse",
	"Lost March": "sparkle",
	"Lost Mine": "drain",
	"Lost Purge-GX": "impact",
	"Lost Shot": "cannon",
	"Lost Volcano": "flame",
	"Lost Voltage": "bolt",
	"Loud Howl": "sonic",
	"Loud Mix": "bolt",
	"Loud Snort": "quake",
	"Love Call": "torrent",
	"Love Impact": "impact",
	"Love Lariat": "impact",
	"Love Resonance": "pulse",
	"Lovely Kiss": "kiss",
	"Lovely Star-GX": "swift",
	"Lovestrike": "veil",
	"Loving Draw": "torrent",
	"Loving Sympathy": "pulse",
	"Low Current": "bolt",
	"Low Kick": "kick",
	"Low Sweep": "kick",
	"Lucha Fight": "quake",
	"Lucky Attachment": "impact",
	"Lucky Find": "veil",
	"Lucky Punch": "fist",
	"Lucky Shot": "cannon",
	"Lullaby": "sleep",
	"Lumina Crash": "impact",
	"Luminous Blade": "slash",
	"Luminous Swirl": "sparkle",
	"Luna Turn": "pulse",
	"Lunar Blast": "boom",
	"Lunar Dance": "whirl",
	"Lunar Fall-GX": "pulse",
	"Lunar Flight": "whirl",
	"Lunar Javelin": "pulse",
	"Lunar Pain": "drain",
	"Lunar Payback": "drain",
	"Lunar Power": "impact",
	"Lunatic Sense": "veil",
	"Lunge": "impact",
	"Lunge Out": "quake",
	"Lure": "flame",
	"Lure Poison": "veil",
	"Luring Antenna": "quake",
	"Luring Flame": "flame",
	"Luring Glow": "bolt",
	"Luring Light": "sparkle",
	"Luster Blast": "boom",
	"Luster Burn": "flame",
	"Luster of Downfall": "roar",
	"Luster Purge": "roar",
	"Lycanfang": "bite",
	"Lycanfang-GX": "bite",
	"Mach Blade": "slash",
	"Mach Blow": "impact",
	"Mach Bolt": "bolt",
	"Mach Claw": "slash",
	"Mach Cross": "quake",
	"Mach Cut": "slash",
	"Mach Cyclone": "whirl",
	"Mach Delivery-GX": "roar",
	"Mach Descent": "impact",
	"Mach Flight": "whirl",
	"Mach Press": "impact",
	"Mach Punch": "fist",
	"Mach Turn": "pulse",
	"Mach Wind": "whirl",
	"Machamp Crush": "impact",
	"Machine Burst": "boom",
	"Machine Gun Headbutt": "impact",
	"Machine Gun Stomp": "impact",
	"Macho Revenge": "quake",
	"Mad Bite": "bite",
	"Mad Bull-GX": "impact",
	"Mad Dance": "whirl",
	"Mad Hammer": "fist",
	"Mad Mountain": "meteor",
	"Mad Party": "pulse",
	"Maddening Scent": "powder",
	"Madkinesis": "pulse",
	"Maelstrom-GX": "torrent",
	"Magic Darts": "pulse",
	"Magic Dust": "bloom",
	"Magic Heal": "drain",
	"Magic Pollen": "powder",
	"Magic Whip": "slash",
	"Magical Charm": "sparkle",
	"Magical Dance": "whirl",
	"Magical Delusion": "pulse",
	"Magical Echo": "drain",
	"Magical Fire": "flame",
	"Magical Leaf": "petal",
	"Magical Miracle-GX": "sparkle",
	"Magical Needle": "sting",
	"Magical Ribbon": "sparkle",
	"Magical Shot": "cannon",
	"Magical Step": "daze",
	"Magical Swap": "drain",
	"Magical Symphony": "impact",
	"Magma Burn": "flame",
	"Magma Eruption": "flame",
	"Magma Fall": "flame",
	"Magma Jab": "flame",
	"Magma Mantle": "flame",
	"Magma Pointer": "flame",
	"Magma Punch": "flame",
	"Magma Purge": "flame",
	"Magma Quake": "flame",
	"Magma Ring": "flame",
	"Magma Spurt": "flame",
	"Magma Storm": "flame",
	"Magma Volcano": "flame",
	"Magnet Slash": "slash",
	"Magnetic Blast": "bolt",
	"Magnetic Bolt": "bolt",
	"Magnetic Bomb": "bolt",
	"Magnetic Burst": "bolt",
	"Magnetic Catch": "bolt",
	"Magnetic Charge": "bolt",
	"Magnetic Force": "bolt",
	"Magnetic Grip": "bolt",
	"Magnetic Laser": "beam",
	"Magnetic Lift": "bolt",
	"Magnetic Lines": "bolt",
	"Magnetic Pull": "bolt",
	"Magnetic Ray": "beam",
	"Magnetic Release": "bolt",
	"Magnetic Repulsion": "bolt",
	"Magnetic Resonance": "bolt",
	"Magnetic Swirl": "bolt",
	"Magnetic Switch": "bolt",
	"Magnetic Tackle": "bolt",
	"Magnetic Tension": "bolt",
	"Magnetic Trip": "bolt",
	"Magnetic Wave": "torrent",
	"Magnetism": "bolt",
	"Magnitude": "quake",
	"Magnum Kick": "kick",
	"Magnum Punch": "fist",
	"Majestic Sword": "slash",
	"Major Earthquake": "quake",
	"Major Flood": "torrent",
	"Make a Mess": "sparkle",
	"Make a Wish": "drain",
	"Make 'Em Pay": "impact",
	"Make It Rain": "shard",
	"Make the Assist": "quake",
	"Malevolent Fire": "flame",
	"Mantle Bazooka": "flame",
	"Manual Wash": "torrent",
	"Marine Guidance": "torrent",
	"Marvelous Edge": "slash",
	"Marvelous Shine": "drain",
	"Mass Attack": "bloom",
	"Mass Destruction": "boom",
	"Mass Explosion": "boom",
	"Massage": "drain",
	"Massive Bloom": "bloom",
	"Massive Catch-GX": "torrent",
	"Massive Eruption": "flame",
	"Massive Heat Wave-GX": "stream",
	"Massive Rend": "slash",
	"Master Blade": "slash",
	"Master's Punch": "fist",
	"Master Strike": "impact",
	"Mat Block": "torrent",
	"Matcha Spin": "whirl",
	"Matcha Splash": "torrent",
	"Matching": "torrent",
	"Matching Look": "torrent",
	"Matchless Maelstrom": "impact",
	"Matron's Anger": "bloom",
	"Max Anchor": "bloom",
	"Max Balloon": "bolt",
	"Max Beating": "bloom",
	"Max Blaze": "flame",
	"Max Bolt": "bolt",
	"Max Bubbles": "torrent",
	"Max Bullet": "cannon",
	"Max Burst": "boom",
	"Max Cure": "pulse",
	"Max Cutter": "slash",
	"Max Darkness": "veil",
	"Max Detonate": "boom",
	"Max Discharge": "bolt",
	"Max Drain": "drain",
	"Max Edge": "slash",
	"Max Energy Source": "impact",
	"Max Fist": "fist",
	"Max Frost": "frost",
	"Max Geist": "pulse",
	"Max Gimme Gimme": "impact",
	"Max Glide": "impact",
	"Max Hack": "shard",
	"Max Harmony": "pulse",
	"Max Heat Burst": "flame",
	"Max Icicle": "frost",
	"Max Impact": "impact",
	"Max Jammer": "veil",
	"Max Jet": "impact",
	"Max Lance": "torrent",
	"Max Leaf": "bloom",
	"Max Milk": "drain",
	"Max Mindstorm": "pulse",
	"Max Miracle": "pulse",
	"Max Phantom": "pulse",
	"Max Plant": "bloom",
	"Max Poltergeist": "flame",
	"Max Pyro Ball": "aura",
	"Max Rockfall": "quake",
	"Max Rush": "impact",
	"Max Shadow": "veil",
	"Max Shock": "bolt",
	"Max Steelspike": "shard",
	"Max Surfer": "bolt",
	"Max Take Down": "impact",
	"Max Thunder and Lightning": "bolt",
	"Max Thunder Rumble": "bolt",
	"Max Torrent": "torrent",
	"Max Toxify": "veil",
	"Max Transform": "impact",
	"Max Tree": "bloom",
	"Max Tyrant": "torrent",
	"Max Victory": "flame",
	"Max Voltage": "bolt",
	"Max Whiteout": "torrent",
	"Max Wind Spirit": "whirl",
	"Max Wings": "wing",
	"MAXamar": "veil",
	"Maximum Drilling": "shard",
	"Me First": "impact",
	"Meal Time": "bolt",
	"Mean Look": "daze",
	"Meddle": "veil",
	"Meddling": "torrent",
	"Meditate": "pulse",
	"Mega Ascension": "impact",
	"Mega Blaster": "boom",
	"Mega Brave": "quake",
	"Mega Bravo": "flame",
	"Mega Burn": "flame",
	"Mega Burning": "flame",
	"Mega Burst": "boom",
	"Mega Drain": "drain",
	"Mega Flame": "flame",
	"Mega Harmony": "pulse",
	"Mega Impact": "impact",
	"Mega Kick": "kick",
	"Mega Peck": "barrage",
	"Mega Punch": "fist",
	"Mega Shock": "bolt",
	"Mega Shot": "cannon",
	"Mega Symphonia": "pulse",
	"Mega Thrash": "rage",
	"Mega Throw": "quake",
	"Mega Thunderbolt": "bolt",
	"Mega Tidal Wave": "torrent",
	"Megafire of Envy": "flame",
	"Megahorn": "drill",
	"Megalo Cannon": "cannon",
	"Megaton Cannon": "cannon",
	"Megaton Fall": "quake",
	"Megaton Fang": "bite",
	"Megaton Friends-GX": "impact",
	"Megaton Lariat": "impact",
	"Megaton Rock": "meteor",
	"Megaton Slam": "impact",
	"Megaton Slap Push": "impact",
	"Megaton Slash": "slash",
	"Megaton Tail": "tail",
	"Mellow Wave": "torrent",
	"Melodious Echo": "pulse",
	"Melt": "roar",
	"Melting Floe": "torrent",
	"Melting Horn": "drill",
	"Melting Mountain": "meteor",
	"Melting Sweetness": "roar",
	"Memory Lock": "shard",
	"Memory Melt": "torrent",
	"Memory Skip": "pulse",
	"Menacing Fangs": "bite",
	"Mend": "drain",
	"Mental Crush": "impact",
	"Mental Panic": "veil",
	"Mental Shock": "bolt",
	"Mental Surge": "veil",
	"Mental Trash": "veil",
	"Merciless Blade": "slash",
	"Merciless Strike": "impact",
	"Messenger": "impact",
	"Meta Voltage": "bolt",
	"Metal Armament": "shard",
	"Metal Arms": "shard",
	"Metal Ball": "shard",
	"Metal Barrier": "shield",
	"Metal Blade": "slash",
	"Metal Blast": "boom",
	"Metal Block": "shard",
	"Metal-bolize": "shard",
	"Metal Bomber": "shard",
	"Metal Burn": "flame",
	"Metal Charge": "shard",
	"Metal Claw": "slash",
	"Metal Coating": "shard",
	"Metal Crush": "shard",
	"Metal Crusher": "shard",
	"Metal Defender": "shard",
	"Metal Fang": "bite",
	"Metal Flash": "shard",
	"Metal Hook": "shard",
	"Metal Horns": "drill",
	"Metal Jail": "shard",
	"Metal Load": "shard",
	"Metal Max": "shard",
	"Metal Pincer": "shard",
	"Metal Press": "shard",
	"Metal Rain": "shard",
	"Metal Reversal": "shard",
	"Metal Scissors": "slash",
	"Metal Scoop": "shard",
	"Metal Sharpener": "shard",
	"Metal Slash": "slash",
	"Metal Sound": "shard",
	"Metal Star": "swift",
	"Metal Stomp": "shard",
	"Metal Surge": "shard",
	"Metal Tail": "tail",
	"Metal Wallop": "shard",
	"Metallic Blow": "shard",
	"Metallic Bolt": "bolt",
	"Metallic Hammer": "fist",
	"Metallic Sound": "shard",
	"Metallic Thunder": "bolt",
	"Metallic Turbo": "shard",
	"Meteor": "meteor",
	"Meteor Assault": "meteor",
	"Meteor Blast": "meteor",
	"Meteor Mash": "meteor",
	"Meteor Punch": "meteor",
	"Meteor Smash": "meteor",
	"Meteor Tempest": "meteor",
	"Metronome": "impact",
	"Miasma Wind": "whirl",
	"Mid-air Crush": "impact",
	"Mid-air Strike": "impact",
	"Midair Strike": "impact",
	"Midnight Eyes": "daze",
	"Midnight Fang": "bite",
	"Mighty Magnetism": "bolt",
	"Mighty Meteor": "meteor",
	"Mighty Wind": "whirl",
	"Migraine": "torrent",
	"Milk Cannon": "cannon",
	"Milk Drink": "drain",
	"Mime": "pulse",
	"Mime-y Shuffle": "pulse",
	"Mimed Games": "pulse",
	"Mimic": "impact",
	"Mimicry": "torrent",
	"Mind Bend": "pulse",
	"Mind Blast": "boom",
	"Mind Blown": "pulse",
	"Mind Boost": "pulse",
	"Mind Bullet": "cannon",
	"Mind Jack": "pulse",
	"Mind Off": "pulse",
	"Mind Play": "pulse",
	"Mind Ruler": "pulse",
	"Mind Shock": "bolt",
	"Mind Splash": "torrent",
	"Mind Trip": "pulse",
	"Mine": "quake",
	"Mineral Pump": "torrent",
	"Mini Drain": "drain",
	"Mini Earthquake": "quake",
	"Mini Eruption": "flame",
	"Mini Link": "pulse",
	"Mini-Metronome": "impact",
	"Minimize": "impact",
	"Minimized": "bloom",
	"Mining": "shard",
	"Mining Rush": "impact",
	"Minor Errand-Running": "bolt",
	"Minus Energy": "bolt",
	"Miracle": "impact",
	"Miracle Blow": "impact",
	"Miracle Essence": "bloom",
	"Miracle Force": "pulse",
	"Miracle Harmony": "pulse",
	"Miracle Leaf": "bloom",
	"Miracle Powder": "powder",
	"Miracle Tail": "tail",
	"Miracle Wing": "wing",
	"Miraculous Cologne": "sparkle",
	"Miraculous Comeback": "veil",
	"Miraculous Duo-GX": "pulse",
	"Miraculous Light": "sparkle",
	"Miraculous Memory": "pulse",
	"Miraculous Paint": "veil",
	"Miraculous Shine": "pulse",
	"Miraculous Spin": "whirl",
	"Miraculous Thunder": "bolt",
	"Mirage": "torrent",
	"Mirage Barrage": "barrage",
	"Mirage Flare": "flame",
	"Mirage Step": "pulse",
	"Mirror Attack": "pulse",
	"Mirror Barrier": "shield",
	"Mirror Draw": "shard",
	"Mirror Gem": "veil",
	"Mirror Mirror": "pulse",
	"Mirror Move": "impact",
	"Mirror Pain": "drain",
	"Mirror Shell": "shell",
	"Mirror Shot": "cannon",
	"Mirror Step": "pulse",
	"Mirrored Flames": "flame",
	"Mischief": "quake",
	"Mischievous Crunch": "bite",
	"Mischievous Hands": "drain",
	"Mischievous Painting": "veil",
	"Mischievous Punch": "fist",
	"Mischievous Ring": "pulse",
	"Mischievous Tail": "tail",
	"Mischievous Tentacles": "wrap",
	"Mise en Place": "torrent",
	"Misfire": "flame",
	"Misinformation": "impact",
	"Mislead": "daze",
	"Missile Jab": "quake",
	"Missing in the Forest": "bloom",
	"Mist Attack": "bloom",
	"Mist Ball": "aura",
	"Mist Guard": "shield",
	"Mist Purge": "sparkle",
	"Mist Slash": "slash",
	"Misty Gale": "sparkle",
	"Mix-Up": "impact",
	"Mixed Call": "pulse",
	"Mixin' Toxin": "daze",
	"Mochi Rush": "impact",
	"Modular Axe": "slash",
	"Mold Breaker": "impact",
	"Monkey Beatdown": "impact",
	"Moombahton": "impact",
	"Moomoo Rolling": "gyro",
	"Moomoo Squeeze": "impact",
	"Moon Barrier": "shield",
	"Moon Dance": "sparkle",
	"Moon Guidance": "sparkle",
	"Moon Impact": "sparkle",
	"Moon Kick": "kick",
	"Moon Kinesis": "sparkle",
	"Moon Mirage": "sparkle",
	"Moon Press": "sparkle",
	"Moon Raker": "sparkle",
	"Moon's Eclipse-GX": "sparkle",
	"Moon's Invite": "sparkle",
	"Moon Skip": "sparkle",
	"Moon Twinkle": "sparkle",
	"Moon-Viewing Invitation": "sparkle",
	"Moon-Watching Dance": "sparkle",
	"Moonblast": "beam",
	"Moongeist Beam": "beam",
	"Moonglow Reverse": "drain",
	"Moonless Madness": "daze",
	"Moonlight": "drain",
	"Moonlight Blade": "slash",
	"Moonlight Fang": "drain",
	"Moonlight Gain": "drain",
	"Moonlight Shuriken": "drain",
	"Moonlight Slash": "slash",
	"Moonlit Miracle": "pulse",
	"Moonsault Blaze": "flame",
	"Moonsault Press": "impact",
	"Moonsault Stomp": "impact",
	"Moonwatching": "impact",
	"More Moon": "sparkle",
	"Morning Sun": "pulse",
	"Mortal Crunch": "bite",
	"Moss Agate": "bloom",
	"Motivate": "impact",
	"Mountain Bite": "bite",
	"Mountain Breaker": "meteor",
	"Mountain Chopping": "meteor",
	"Mountain Crush": "meteor",
	"Mountain Drop": "meteor",
	"Mountain Eater": "bite",
	"Mountain Gale": "meteor",
	"Mountain Hunt": "meteor",
	"Mountain Hurl": "meteor",
	"Mountain Mashing": "meteor",
	"Mountain Munch": "bite",
	"Mountain Ramming": "meteor",
	"Mountain Scrounging": "meteor",
	"Mountain Smasher": "meteor",
	"Mountain Stroll": "meteor",
	"Mountain Swing": "meteor",
	"Mountaintop Mining": "impact",
	"Mouth Pump": "torrent",
	"Moving Fire": "flame",
	"Mow Down": "bolt",
	"Mud Bomb": "mud",
	"Mud Flood": "mud",
	"Mud Gun": "mud",
	"Mud Shot": "mud",
	"Mud-Slap": "mud",
	"Mud Spatter": "mud",
	"Mud Spit": "mud",
	"Mud Splash": "mud",
	"Mud Sport": "mud",
	"Mud Stock": "mud",
	"Muddy Acid": "acid",
	"Muddy Bolt": "bolt",
	"Muddy Bomb": "boom",
	"Muddy Eye": "daze",
	"Muddy Hammer": "fist",
	"Muddy Headbutt": "impact",
	"Muddy Water": "wave",
	"Mudslide": "shard",
	"Mug": "quake",
	"Multi Bubble": "barrage",
	"Multi Burn": "barrage",
	"Multi Pulse": "barrage",
	"Multiple Force": "barrage",
	"Multiply": "barrage",
	"Multishot Lightning": "barrage",
	"Multishot Star": "barrage",
	"Mumble": "pulse",
	"Muscle Punch-GX": "fist",
	"Muscular Nose": "shard",
	"Muscular Slap": "impact",
	"Mushroom Drain": "drain",
	"Mushroom Tackle": "impact",
	"Myriad Leaf Shower": "bloom",
	"Mysterious Beam": "beam",
	"Mysterious Dance": "whirl",
	"Mysterious Evolution": "bloom",
	"Mysterious Flames": "flame",
	"Mysterious Light": "sparkle",
	"Mysterious Noise": "pulse",
	"Mysterious Powder": "powder",
	"Mysterious Wave": "torrent",
	"Mysterious Wing": "wing",
	"Mystery Bolt": "bolt",
	"Mystery Press": "impact",
	"Mystic Fang": "bite",
	"Mystic Water": "torrent",
	"Mystical Eyes": "daze",
	"Mystical Return": "pulse",
	"Mystifying Horns": "drill",
	"Nadir Needle": "sting",
	"Nadir Powder": "powder",
	"Nail Flick": "flame",
	"Nap": "sleep",
	"Nap Time": "sleep",
	"Naptime": "sleep",
	"Nasal Lariat": "impact",
	"Nasal Suction": "pulse",
	"Nasty Goo": "veil",
	"Nasty Goo Mix-GX": "veil",
	"Nasty Plot": "veil",
	"Nature Dive": "torrent",
	"Nature Power": "bloom",
	"Nature's Breath": "breath",
	"Nature's Judgment": "bloom",
	"Nature Wave": "torrent",
	"Nebula Beam": "beam",
	"Needle": "sting",
	"Needle Arm": "sting",
	"Needle Ball": "sting",
	"Needle Bone": "bone",
	"Needle Crush": "sting",
	"Needle Lariat": "sting",
	"Needle Rush": "sting",
	"Needle Shock": "bolt",
	"Needle Storm": "sting",
	"Needles": "quake",
	"Needling Sting": "sting",
	"Negative Discard": "bolt",
	"Negative Ion": "bolt",
	"Negative Spark": "bolt",
	"Neon Sign": "torrent",
	"Neon Trickery": "torrent",
	"Nerve Poison": "veil",
	"Nerve Shot": "cannon",
	"Nest Building": "quake",
	"Net Force": "pulse",
	"Netherwing": "wing",
	"Neurokinesis": "pulse",
	"Never Enough": "quake",
	"Never Ever Enough": "impact",
	"Never Give Up": "bolt",
	"New Wave": "torrent",
	"Nice-Nice Catch": "impact",
	"Nicked Nibble": "impact",
	"Nido Press": "impact",
	"Night Ambush": "veil",
	"Night Attack": "veil",
	"Night Bind": "wrap",
	"Night Claw": "slash",
	"Night Cyclone": "veil",
	"Night Daze": "veil",
	"Night Eyes": "daze",
	"Night Footsteps": "veil",
	"Night Impact": "veil",
	"Night Joker": "veil",
	"Night March": "veil",
	"Night Murmurs": "veil",
	"Night Punishment": "veil",
	"Night Raid": "veil",
	"Night Roam": "veil",
	"Night Scan": "veil",
	"Night Shade": "shade",
	"Night Slash": "slash",
	"Night Song": "note",
	"Night Spear": "veil",
	"Night Spin": "veil",
	"Night Spirits": "veil",
	"Night Watch": "veil",
	"Nightcap": "pulse",
	"Nightmare": "pulse",
	"Nightmare Feast": "sleep",
	"Nightmare Mambo": "veil",
	"Nimble": "pulse",
	"Nine-Tailed Dance": "whirl",
	"Nine-Tailed Shapeshifter": "flame",
	"Nine-Tailed Transfer": "drain",
	"Ninja Blade": "slash",
	"Ninja Fang": "bite",
	"Ninja Spinner": "torrent",
	"Ninja Tornado": "whirl",
	"Nipping Cyclone": "whirl",
	"Nitro Dive": "torrent",
	"Nitro Tank-GX": "flame",
	"No Reprieve": "impact",
	"Noble Light": "sparkle",
	"Noble Roar": "sonic",
	"Nocturnal Maneuvers-GX": "veil",
	"Nom-Nom-Nom Incisors": "impact",
	"Nonahex": "drain",
	"Nose Jet": "impact",
	"Nose Poke": "quake",
	"Nose Unit": "quake",
	"Nosedive": "impact",
	"Nosequake": "quake",
	"Nosh": "drain",
	"Now You're in My Power": "impact",
	"Noxious Scales": "bloom",
	"Nullifying Zero": "quake",
	"Numb": "bolt",
	"Numbing Hold": "bolt",
	"Numbing Saliva": "impact",
	"Numbing Water": "torrent",
	"Nurse's Egg": "drain",
	"Nurturing": "bloom",
	"Nutrients": "drain",
	"Nutritional Support": "bloom",
	"Nuzzle": "zap",
	"Nuzzle Shot": "zap",
	"Nyan Press": "impact",
	"Nyan Roll": "gyro",
	"Obliterating Nose": "quake",
	"Oblivion Wing": "drain",
	"Obscuring Gas": "powder",
	"Obsidian": "veil",
	"Obsidian Fang": "bite",
	"Obstruct": "veil",
	"Ocean Cyclone": "whirl",
	"Ocean Loop": "torrent",
	"Ocean Waves": "torrent",
	"Oceanic Gift": "torrent",
	"Oceanic Gloom": "pulse",
	"Octazooka": "ink",
	"Octo Beatdown": "impact",
	"Octolock": "quake",
	"Odor Sleuth": "impact",
	"Offensive Bomb": "boom",
	"Offensive Gas": "powder",
	"Offensive Needle": "sting",
	"Offensive Scent": "powder",
	"Offer Help": "pulse",
	"Ogre Comeback": "bloom",
	"Ogre's Hammer": "fist",
	"Ogre’s Whip": "slash",
	"Oil Salvo": "bloom",
	"Oil Shot": "cannon",
	"Olfactory Enchantment": "daze",
	"Ominous Claw": "slash",
	"Ominous Eyes": "daze",
	"Ominous News": "veil",
	"Ominous Numbers": "drain",
	"Ominous Prose": "pulse",
	"Ominous Wind": "whirl",
	"One-derful Rumble": "pulse",
	"One Desire": "shard",
	"One-Two Kick": "kick",
	"One-Two Punch": "fist",
	"One-Two Strike": "impact",
	"Onyx": "veil",
	"Open Sea": "torrent",
	"Opposing Winds": "impact",
	"Oppressing Sandstorm": "sand",
	"Oracle Arrow": "arrow",
	"Oracle Inflict": "shard",
	"Oracle Press": "impact",
	"Orb Collector": "bolt",
	"Orb Polish": "sparkle",
	"Order a Raid": "bloom",
	"Orichalcum Fang": "bite",
	"Otherworldly Return": "veil",
	"Outbreak Power": "shard",
	"Outlaw Leg": "veil",
	"Outlet": "bolt",
	"Outrage": "rage",
	"Outta-Control Dash": "impact",
	"Over Slash": "slash",
	"Over Slice": "slash",
	"Overacceleration": "impact",
	"Overclock": "roar",
	"Overconfident": "veil",
	"Overdrive Smash": "quake",
	"Overflowing Wishes": "wing",
	"Overhaul": "shard",
	"Overhead Throw": "quake",
	"Overhead Toss": "quake",
	"Overload": "impact",
	"Overlord’s Blade": "slash",
	"Overrun": "flame",
	"Overshort": "bolt",
	"Overspark": "bolt",
	"Overspin": "quake",
	"Overthink": "torrent",
	"Overwhelming Pain": "pulse",
	"Own the Place": "impact",
	"Ozone Buster": "impact",
	"Ozone Flare": "flame",
	"Pachi": "bolt",
	"Pack Call": "bloom",
	"Package Deal": "impact",
	"Package Delivery": "torrent",
	"Pain Amplifier": "drain",
	"Pain Burst": "boom",
	"Pain Explosion": "boom",
	"Pain-full Punch": "fist",
	"Pain Payback": "drain",
	"Pain Pellets": "drain",
	"Pain Split": "drain",
	"Painful Memories": "drain",
	"Painful Sword": "slash",
	"Paint": "impact",
	"Paint Trick": "daze",
	"Paired Tackle": "impact",
	"Pale Moon-GX": "sparkle",
	"Palette of Friends": "impact",
	"Palm Strike": "impact",
	"Pandemonium": "pulse",
	"Pandemonium Blade": "slash",
	"Panic": "torrent",
	"Panic Liquid": "torrent",
	"Panic Poison": "veil",
	"Panic-Prompting Pattern": "bloom",
	"Panic Vine": "bloom",
	"Parabolic Charge": "impact",
	"Parabolic Counter": "impact",
	"Parabolic Spark": "bolt",
	"Parade": "quake",
	"Paradise Draw": "roar",
	"Paradise Pollen": "powder",
	"Parallel Drain": "drain",
	"Parallel Gain": "bloom",
	"Parallel Placement": "bolt",
	"Parallel Spin": "whirl",
	"Paralyze Poison": "veil",
	"Paralyzing Ball": "aura",
	"Paralyzing Bolt": "bolt",
	"Paralyzing Clamp": "pulse",
	"Paralyzing Crackle": "bolt",
	"Paralyzing Gaze": "bolt",
	"Paralyzing Jab": "pulse",
	"Paralyzing Kiss": "kiss",
	"Paranormal": "pulse",
	"Parboil": "bloom",
	"Parental Fury": "barrage",
	"Parting Shot": "cannon",
	"Passionate Dance": "whirl",
	"Passionate Singing": "flame",
	"Past Friends": "pulse",
	"Paste": "shard",
	"Patrol": "impact",
	"Paw-cket Pilfer": "impact",
	"Paw Shake Punch": "fist",
	"Pay Day": "gold",
	"Payback": "quake",
	"Peace Maker": "quake",
	"Peak Acceleration": "roar",
	"Pearl Blast": "boom",
	"Pearl Breath": "breath",
	"Pearl Hurricane": "whirl",
	"Peat Hunt": "impact",
	"Peat Shoulder": "quake",
	"Pebble Hurl": "quake",
	"Pebble Throw": "quake",
	"Peck": "barrage",
	"Peck Attack": "barrage",
	"Peck Bugs": "barrage",
	"Peck Off": "barrage",
	"Peck the Wound": "barrage",
	"Peerless Edge": "slash",
	"Peerless Hundred Blows-GX": "quake",
	"Peko Blaster": "boom",
	"Pelagic Blade": "slash",
	"Pendulum Curse": "veil",
	"Pendulum Influence": "pulse",
	"Pep Up": "bolt",
	"Perfume Blast": "boom",
	"Perfume Press": "impact",
	"Perish Dream": "pulse",
	"Perish Song": "note",
	"Permeating Chill": "torrent",
	"Pernicious Poison": "veil",
	"Perplex": "daze",
	"Perplexing Eyes": "daze",
	"Perplexing Forest": "pulse",
	"Perplexing Powder": "powder",
	"Perplexing Transfer": "drain",
	"Persist Sting": "sting",
	"Persuade": "quake",
	"Pervasive Gas": "powder",
	"Pester": "bloom",
	"Pester the Dizzy": "pulse",
	"Petal Blade Dance": "slash",
	"Petal Blizzard": "frost",
	"Petal Dance": "petal",
	"Petal Spikes": "petal",
	"Petal Whirlwind": "petal",
	"Petrifying Flame": "flame",
	"Petty Grudge": "pulse",
	"Phantasmal Barrage": "barrage",
	"Phantom Dive": "torrent",
	"Phantom Force": "pulse",
	"Phantom Gate": "pulse",
	"Phantom Maze": "pulse",
	"Phantom Queen": "pulse",
	"Phantom Strike": "impact",
	"Phat Sound": "pulse",
	"Pheromone Catch": "bloom",
	"Pheromone Poison": "veil",
	"Pheromone Signals": "bloom",
	"Pheromotion": "bloom",
	"Phoenix Burn": "flame",
	"Phoenix Flame": "flame",
	"Phoenix Turbo": "flame",
	"Photon Blaster": "boom",
	"Photon Boost": "pulse",
	"Photon Claw": "slash",
	"Photon Geyser": "roar",
	"Photon Kinesis": "bolt",
	"Photon Laser": "beam",
	"Photon Wave": "torrent",
	"Pick and Choose": "sleep",
	"Pick and Collect": "impact",
	"Pick and Stick": "bolt",
	"Pick On": "shard",
	"Pick Out": "shard",
	"Pickup": "impact",
	"Pickup Power": "impact",
	"Picnic Weather": "impact",
	"Pierce": "bloom",
	"Pierce the Pain": "bloom",
	"Piercing Claw": "slash",
	"Piercing Drill": "drill",
	"Piercing Gaze": "bolt",
	"Piercing Prizes": "pulse",
	"Piercing Spin": "whirl",
	"Piercing Strike": "impact",
	"Pika Ball": "aura",
	"Pika Bolt": "bolt",
	"Pika Draw": "bolt",
	"Pika Drive": "bolt",
	"Pika-Portrait": "bolt",
	"Pika Punch": "fist",
	"Pika Strike": "impact",
	"Pike": "torrent",
	"Pile-Driving Hammer": "fist",
	"Pile Up": "pulse",
	"Pilfer": "impact",
	"Pin Missile": "barrage",
	"Pin Missle": "bolt",
	"Pinning": "veil",
	"Pinpoint Dive": "torrent",
	"Pinpoint Wave": "torrent",
	"Piston Headbutt": "impact",
	"Pit Search": "shard",
	"Pit Trap": "wrap",
	"Pitch": "impact",
	"Pitch-Black Blade": "slash",
	"Pitch-Black Fangs": "bite",
	"Pitch-Black Spear": "veil",
	"Pitch-Dark": "veil",
	"Pivot Throw": "quake",
	"Plant Cloak Tackle": "impact",
	"Planting": "bloom",
	"Plasma": "bolt",
	"Plasma Arrow": "arrow",
	"Plasma Fists": "bolt",
	"Plasma Gale": "whirl",
	"Plasma Hurricane": "whirl",
	"Plasma Slice": "slash",
	"Plasmagic": "drain",
	"Play Dead": "torrent",
	"Play Rough": "sparkle",
	"Play Search": "pulse",
	"Play with Fire": "flame",
	"Playful": "flame",
	"Playful Kick": "kick",
	"Playful Knockdown": "veil",
	"Playground": "sleep",
	"Playing with Fire": "flame",
	"Plea-GX": "sparkle",
	"Plead": "impact",
	"Pleasant Aroma": "powder",
	"Pleasant Tone": "pulse",
	"Pleasing Present": "torrent",
	"Plentiful Placement": "drain",
	"Plentiful Pollen": "powder",
	"Plotter's Command": "pulse",
	"Plow Over": "bloom",
	"Pluck": "impact",
	"Plunder": "veil",
	"Plunging Headbutt": "impact",
	"Plus Damage": "bolt",
	"Plus Energy": "impact",
	"Poaching Fangs": "bite",
	"Pointy Claws": "slash",
	"Pointy Nails": "veil",
	"Poison Absorption": "drain",
	"Poison Antennae": "veil",
	"Poison Barb": "veil",
	"Poison Berry": "veil",
	"Poison Bind": "wrap",
	"Poison Bite": "bite",
	"Poison Blend": "veil",
	"Poison Boost": "veil",
	"Poison Breath": "veil",
	"Poison Buildup": "veil",
	"Poison Chain": "veil",
	"Poison Claws": "slash",
	"Poison Cultivation": "veil",
	"Poison Effect": "veil",
	"Poison Experiment": "veil",
	"Poison Fang": "bite",
	"Poison Flame": "flame",
	"Poison Gas": "powder",
	"Poison Horn": "drill",
	"Poison Impact": "veil",
	"Poison Jab": "sting",
	"Poison Leaf": "bloom",
	"Poison Needle": "sting",
	"Poison Needle Rush": "sting",
	"Poison Petals": "veil",
	"Poison Point": "veil",
	"Poison Powder": "powder",
	"Poison Power": "veil",
	"Poison Pulse": "pulse",
	"Poison Reaction": "veil",
	"Poison Revenge": "veil",
	"Poison Ring": "veil",
	"Poison Rub": "veil",
	"Poison Scent": "powder",
	"Poison Seed": "bloom",
	"Poison Shard": "veil",
	"Poison Shout": "veil",
	"Poison Skin": "veil",
	"Poison Sludge": "acid",
	"Poison Smog": "acid",
	"Poison Sound Wave": "torrent",
	"Poison Spike": "sting",
	"Poison Spore": "powder",
	"Poison Spray": "veil",
	"Poison Spurt": "veil",
	"Poison Sting": "sting",
	"Poison Sting Tackle": "sting",
	"Poison String-Up": "veil",
	"Poison Suction": "veil",
	"Poison Tail": "tail",
	"Poison Tentacles": "wrap",
	"Poison Thread": "web",
	"Poison Up": "veil",
	"Poison Vapor": "veil",
	"Poison Vine": "bloom",
	"Poisonous Gem": "veil",
	"Poisonous Musculature": "veil",
	"Poisonous Ploy": "veil",
	"Poisonous Prison": "veil",
	"Poisonous Saliva": "veil",
	"Poisonous Whip": "veil",
	"Poisonpowder": "veil",
	"Poke Through": "shard",
	"Polar Spear-GX": "torrent",
	"Polka-Dot Search": "sparkle",
	"Pollen Bomb": "powder",
	"Pollen Hazard": "powder",
	"Pollen Shield": "powder",
	"Pollen Shot": "powder",
	"Pollen Spray": "powder",
	"Poltergeist": "pulse",
	"Pom-Pom Punch": "fist",
	"Pompous Punch": "fist",
	"Poor Sleep": "sleep",
	"Pop": "shard",
	"Pop Out Throughout": "torrent",
	"Pop-Punk": "flame",
	"Portal Strike": "impact",
	"Pose": "impact",
	"Positive Hand": "bolt",
	"Positive Ion": "bolt",
	"Positive Spark": "bolt",
	"Pot Smash": "quake",
	"Pounce": "impact",
	"Pouncing Trap": "wrap",
	"Pound": "impact",
	"Pound Down": "impact",
	"Pour Tea": "drain",
	"Pouty Slap": "impact",
	"Pow-Pow Punching": "fist",
	"Powder": "powder",
	"Powder Snow": "frost",
	"Powdery Uppercut": "fist",
	"Power Accelerator": "veil",
	"Power Ball": "aura",
	"Power Beam": "beam",
	"Power Blast": "boom",
	"Power Blow": "impact",
	"Power Bolt": "bolt",
	"Power Breath": "breath",
	"Power Burner-GX": "flame",
	"Power Charger": "impact",
	"Power Claw": "slash",
	"Power Count": "shard",
	"Power Creation": "sparkle",
	"Power Crush": "impact",
	"Power Cyclone": "whirl",
	"Power Edge": "slash",
	"Power Flame": "flame",
	"Power Gem": "meteor",
	"Power Generation": "flame",
	"Power Guillotine": "bloom",
	"Power Heal": "drain",
	"Power Heater": "flame",
	"Power Howl": "sonic",
	"Power Hurricane": "whirl",
	"Power Lariat": "impact",
	"Power Move": "pulse",
	"Power Pinch": "bloom",
	"Power Poison": "veil",
	"Power Press": "impact",
	"Power Recharge": "bolt",
	"Power Revenge": "pulse",
	"Power Run": "impact",
	"Power Rush": "impact",
	"Power Short": "bolt",
	"Power Shot": "cannon",
	"Power Splash": "torrent",
	"Power Split": "pulse",
	"Power Stomp": "impact",
	"Power Stone": "meteor",
	"Power Swing": "impact",
	"Power Tackle": "impact",
	"Power Wave": "torrent",
	"Power Whip": "slash",
	"Powered Ball": "aura",
	"Powerful Axe": "slash",
	"Powerful Bite": "bite",
	"Powerful Bloom": "bloom",
	"Powerful Bolt": "bolt",
	"Powerful Cross": "torrent",
	"Powerful Dance": "whirl",
	"Powerful Friends": "bloom",
	"Powerful Gain": "impact",
	"Powerful Hand": "drain",
	"Powerful Needles": "bloom",
	"Powerful Rage": "rage",
	"Powerful Slap": "impact",
	"Powerful Spark": "bolt",
	"Powerful Spin": "whirl",
	"Powerful Splash": "torrent",
	"Powerful Steam": "torrent",
	"Powerful Steps": "pulse",
	"Powerful Storm": "whirl",
	"Powerful Vise": "shard",
	"Powerful Vision": "impact",
	"Powervolt": "bolt",
	"Pranks": "quake",
	"Pre-Dawn Strike": "impact",
	"Precious Ribbon": "sparkle",
	"Precious Touch": "drain",
	"Precise Beak": "impact",
	"Precocious Evolution": "bloom",
	"Precognitive Dream": "pulse",
	"Prehistoric Water": "torrent",
	"Prehistoric Wisdom": "torrent",
	"Prelude": "bloom",
	"Present": "torrent",
	"Pressure Shot": "cannon",
	"Pressurized Gas": "powder",
	"Prickly Needles": "bloom",
	"Pride Attack": "pulse",
	"Prima Rondo": "quake",
	"Primal Breath": "breath",
	"Primal Calling": "torrent",
	"Primal Guidance": "torrent",
	"Primal Scythe": "quake",
	"Primal Tentacles": "wrap",
	"Primal Wingbeat": "impact",
	"Primate Acting": "impact",
	"Primate's Trap": "wrap",
	"Primeval Beak": "bolt",
	"Primordial Beatdown": "impact",
	"Primordial Boom": "boom",
	"Prism Charge": "impact",
	"Prism Edge": "slash",
	"Prism Impact": "impact",
	"Prismatic Burst": "boom",
	"Prismatic Laser": "beam",
	"Prismatic Ray": "beam",
	"Prismatic Wave": "torrent",
	"Prize Count": "pulse",
	"Proclaim the Night": "veil",
	"Procurement": "impact",
	"Profane Punch": "fist",
	"Profound Knowledge": "pulse",
	"Prominence-GX": "drain",
	"Prop-up Pinchers": "torrent",
	"Prophecy": "pulse",
	"Protect": "shield",
	"Protect Charge": "shield",
	"Protecting Steel": "shard",
	"Protective Flame": "flame",
	"Protective Swirl": "quake",
	"Protective Wave": "torrent",
	"Proud Fang": "bite",
	"Proud Fangs": "bite",
	"Provoke": "impact",
	"Pry": "torrent",
	"Psy Alert": "pulse",
	"Psy Ball": "pulse",
	"Psy Bolt": "bolt",
	"Psy Call": "pulse",
	"Psy Confuse": "pulse",
	"Psy Protection": "pulse",
	"Psy Purge": "pulse",
	"Psy Report": "pulse",
	"Psy Turbo": "pulse",
	"Psybeam": "beam",
	"Psybite": "pulse",
	"Psyblast": "boom",
	"Psyburn": "flame",
	"Psyburst": "pulse",
	"Psych Out": "pulse",
	"Psych Up": "pulse",
	"Psycharge": "pulse",
	"Psychic": "pulse",
	"Psychic Abduction": "pulse",
	"Psychic Arrow": "arrow",
	"Psychic Assault": "pulse",
	"Psychic Balance": "pulse",
	"Psychic Bolt": "bolt",
	"Psychic Boom": "boom",
	"Psychic Boost": "pulse",
	"Psychic Club": "pulse",
	"Psychic Corkscrew": "pulse",
	"Psychic Cut": "slash",
	"Psychic Damage": "pulse",
	"Psychic Defense": "pulse",
	"Psychic Destruction": "boom",
	"Psychic Erase": "pulse",
	"Psychic Exchange": "pulse",
	"Psychic Explosion": "boom",
	"Psychic Fang": "pulse",
	"Psychic Fangs": "pulse",
	"Psychic Flash": "pulse",
	"Psychic Force": "pulse",
	"Psychic Guard": "shield",
	"Psychic Infinity": "pulse",
	"Psychic Javelin": "pulse",
	"Psychic Leaf": "bloom",
	"Psychic Leap": "pulse",
	"Psychic Lock": "pulse",
	"Psychic Loop": "pulse",
	"Psychic Nova-GX": "pulse",
	"Psychic Option": "pulse",
	"Psychic Protection": "pulse",
	"Psychic Pulse": "pulse",
	"Psychic Rage": "rage",
	"Psychic Raid": "pulse",
	"Psychic Removal": "pulse",
	"Psychic Research": "pulse",
	"Psychic Resonance": "pulse",
	"Psychic Restore": "drain",
	"Psychic Select": "pulse",
	"Psychic Shield": "shield",
	"Psychic Shot": "cannon",
	"Psychic Snap": "pulse",
	"Psychic Sphere": "pulse",
	"Psychic Star": "swift",
	"Psychic Strategy": "pulse",
	"Psychic Suppression": "pulse",
	"Psycho Boost": "pulse",
	"Psycho Waves": "pulse",
	"Psychobilly": "pulse",
	"Psycrush-GX": "pulse",
	"Psydrive": "pulse",
	"Psyimpact": "pulse",
	"Psyjack": "pulse",
	"Psyjamming": "pulse",
	"Psykick": "pulse",
	"Psykiss": "pulse",
	"Psylaser": "pulse",
	"Psyloop": "pulse",
	"Psymist": "pulse",
	"Psypower": "pulse",
	"Psypump": "pulse",
	"Psypunch": "pulse",
	"Psyray": "pulse",
	"Psyscan": "pulse",
	"Psyshield Bash": "impact",
	"Psyshock": "pulse",
	"Psyshot": "pulse",
	"Psyslash": "pulse",
	"Psyspear": "pulse",
	"Psyspeed": "pulse",
	"Psysplash": "pulse",
	"Psysplosion": "pulse",
	"Psystorm": "pulse",
	"Psystrike-GX": "pulse",
	"Psywave": "pulse",
	"Puffy Smashers-GX": "sleep",
	"Pull": "quake",
	"Pull Away": "torrent",
	"Pull Down": "torrent",
	"Pull In": "pulse",
	"Pull In and Pound": "impact",
	"Pull Out": "torrent",
	"Pulled Punch": "fist",
	"Pulling Currents": "torrent",
	"Pulse Barrier": "shield",
	"Pulse Blast": "boom",
	"Pulse Guard": "shield",
	"Pulse Launcher": "pulse",
	"Pulse Search": "pulse",
	"Pulverize": "quake",
	"Pulverizing Pancake-GX": "impact",
	"Pulverizing Press": "impact",
	"Pummel": "quake",
	"Pump Out": "torrent",
	"Pump-up Smash": "torrent",
	"Pumped-Up Whip": "slash",
	"Pumpkin Bomb": "boom",
	"Punch": "fist",
	"Punch and Draw": "fist",
	"Punch and Run": "fist",
	"Puncture": "veil",
	"Puncturing Fangs": "bite",
	"Pungent Aroma": "powder",
	"Punish": "quake",
	"Punishing Fang": "bite",
	"Punishing Kick": "kick",
	"Punishing Scissors": "slash",
	"Punishing Slap": "impact",
	"Punishment": "veil",
	"Punk Shock": "bolt",
	"Punk Smash": "quake",
	"Puppet Pull": "pulse",
	"Puppy Pile": "flame",
	"Pure Power": "drain",
	"Purging Strike": "impact",
	"Purifying Flame": "flame",
	"Pursue and Turn": "bloom",
	"Pursuit": "veil",
	"Pursuit Blast": "boom",
	"Pursuit Claw": "slash",
	"Push Aside": "veil",
	"Push Away": "impact",
	"Push Down": "bloom",
	"Push Out": "quake",
	"Push Over": "quake",
	"Pyro Ball": "aura",
	"Quad Smash": "quake",
	"Quaking Punch": "fist",
	"Queen Press": "impact",
	"Queen's Command-GX": "bloom",
	"Queen's Haze-GX": "flame",
	"Queen's Orders": "bloom",
	"Queenly Heel": "bloom",
	"Quick Attack": "impact",
	"Quick Bind": "wrap",
	"Quick Blow": "impact",
	"Quick Change": "impact",
	"Quick Charge": "impact",
	"Quick Dive": "torrent",
	"Quick Draw": "impact",
	"Quick Freeze": "frost",
	"Quick Gift": "impact",
	"Quick-Grow Beam": "beam",
	"Quick Guard": "shield",
	"Quick Hunt": "pulse",
	"Quick Sign": "bloom",
	"Quick Straight": "quake",
	"Quick Swim": "torrent",
	"Quick Tail Smash": "quake",
	"Quick Touch": "bloom",
	"Quick Turn": "pulse",
	"Quintuple Headbutt": "impact",
	"Quiver Dance": "whirl",
	"R Command": "impact",
	"Radar": "pulse",
	"Radar Eyes": "daze",
	"Radar Jam": "bloom",
	"Radiant Hunt": "roar",
	"Radiant Star": "swift",
	"Radiating Heat": "flame",
	"Radiating Pulse": "pulse",
	"Rage": "rage",
	"Rage Fist": "rage",
	"Ragin’ Mad Strike": "impact",
	"Raging Amethyst": "flame",
	"Raging and Rocking": "quake",
	"Raging Blade": "slash",
	"Raging Blast": "boom",
	"Raging Blaze": "flame",
	"Raging Bull": "impact",
	"Raging Cannon": "cannon",
	"Raging Charge": "impact",
	"Raging Claws": "slash",
	"Raging Crash": "impact",
	"Raging Curse": "veil",
	"Raging Destruction": "boom",
	"Raging Drill": "drill",
	"Raging Fin": "torrent",
	"Raging Flames": "flame",
	"Raging Flare": "flame",
	"Raging Floe": "torrent",
	"Raging Flood": "torrent",
	"Raging Freeze": "frost",
	"Raging Hammer": "fist",
	"Raging Headbutt": "impact",
	"Raging Herd": "impact",
	"Raging Horns": "drill",
	"Raging Out-GX": "flame",
	"Raging Pecks": "impact",
	"Raging Pincer": "torrent",
	"Raging Punch": "fist",
	"Raging Repeated Strike": "impact",
	"Raging Scales": "bloom",
	"Raging Sea": "quake",
	"Raging Smash": "quake",
	"Raging Swing": "impact",
	"Raging Tentacles": "wrap",
	"Raging Thunder": "bolt",
	"Raging Thunder Punch": "bolt",
	"Raging Tremble": "drain",
	"Raging Uppercut": "fist",
	"Raid": "bolt",
	"Raiden Knuckle": "fist",
	"Rain Splash": "torrent",
	"Rainbow Burn": "flame",
	"Rainbow Flavor": "pulse",
	"Rainbow Force": "sparkle",
	"Rainbow Lariat": "impact",
	"Rainbow Moves": "impact",
	"Rainbow Powder": "powder",
	"Rainbow Shower": "roar",
	"Rainbow Spear": "sparkle",
	"Rainbow Star": "swift",
	"Rainbow Wave": "torrent",
	"Rainbow Wing": "wing",
	"Rainfall": "torrent",
	"Rainy Absorbing": "drain",
	"Rainy Day Blues": "torrent",
	"Raised Bad": "quake",
	"Rally": "torrent",
	"Rally Back": "flame",
	"Rallying Horn": "drill",
	"Ram": "impact",
	"Rambunctious Party": "torrent",
	"Ramming Shell": "shell",
	"Ramming Strike": "impact",
	"Rampage": "impact",
	"Rampage Bolt-GX": "bolt",
	"Rampage Drill": "drill",
	"Rampaging Fang": "bite",
	"Rampaging Hammer": "fist",
	"Rampaging Kick": "kick",
	"Rampaging Star": "swift",
	"Rampaging Thunder": "bolt",
	"Rampaging Whirlpool": "torrent",
	"Random Curse": "veil",
	"Random ESP": "torrent",
	"Random Peck": "barrage",
	"Random Spark": "bolt",
	"Ransack": "veil",
	"Rant and Rave": "quake",
	"Rapid Blaster": "boom",
	"Rapid Draw": "impact",
	"Rapid Evolution": "torrent",
	"Rapid-Fire Combo": "barrage",
	"Rapid-Fire Needles": "flame",
	"Rapid-Fisted Rush": "impact",
	"Rapid Freeze": "frost",
	"Rapid Hunt": "pulse",
	"Rapid Smashers": "quake",
	"Rapid Spin": "whirl",
	"Rapid Strike Squad": "impact",
	"Rapid Strike Tentacles": "wrap",
	"Rapids": "torrent",
	"Rapture Pollen": "powder",
	"Raven's Claw": "slash",
	"Razor Fin": "torrent",
	"Razor Leaf": "bloom",
	"Razor-Sharp Incisors": "impact",
	"Razor Shell": "shell",
	"Razor Wind": "whirl",
	"Razor Wing": "wing",
	"Re-Brew": "drain",
	"Re-creation": "pulse",
	"Reach Over": "veil",
	"Reaching Vine": "bloom",
	"Reaction": "pulse",
	"Reactive Beating": "veil",
	"Reactive Blast": "boom",
	"Reactive Poison": "veil",
	"Reactive Pulse": "pulse",
	"Read the Wind": "whirl",
	"Ready to Ram": "impact",
	"Reaper Pulse": "pulse",
	"Reaping Claw": "slash",
	"Reaping Dash": "impact",
	"Rear Attack": "veil",
	"Rear Guard": "shield",
	"Rear Kick": "kick",
	"Rear Spark": "bolt",
	"Rebel-GX": "impact",
	"Recall": "torrent",
	"Recharge": "bolt",
	"Reckless Abandon": "impact",
	"Reckless Bomb": "boom",
	"Reckless Charge": "impact",
	"Reckless Charge Together": "impact",
	"Reckless Throw": "quake",
	"Recover": "drain",
	"Recovery Net": "drain",
	"Recruit": "impact",
	"Recycle": "torrent",
	"Red Banquet": "veil",
	"Red-Hot Headbutt": "impact",
	"Red Knuckles": "pulse",
	"Redirected Sunlight": "bloom",
	"Reflect": "pulse",
	"Reflect Energy": "bolt",
	"Reflect Shield": "shield",
	"Reflected Beam": "beam",
	"Reflected Sunlight": "bloom",
	"Reflective Barrier": "shield",
	"Reflective Shield": "shield",
	"Reforged Axe": "slash",
	"Refresh": "drain",
	"Refreshing Rain": "drain",
	"Refrigerated Stream": "stream",
	"Regal Blender": "bloom",
	"Regal Command": "bloom",
	"Regeneration": "drain",
	"Regi Charge": "impact",
	"Regi Gate": "torrent",
	"Regiblast": "boom",
	"Reheat": "flame",
	"Reigning Pulse": "pulse",
	"Reignite": "flame",
	"Reinforced Drill": "drill",
	"Reinforced Flame": "flame",
	"Reinforced Headbutt": "impact",
	"Reinforced Lariat": "impact",
	"Reinforced Needle": "sting",
	"Reinforced Nose": "shard",
	"Reinforced Punch": "fist",
	"Relaxed Roll": "gyro",
	"Relaxing Fragrance": "drain",
	"Release Rage": "rage",
	"Relentless Burrowing": "wing",
	"Relentless Flames": "flame",
	"Relentless Punches": "fist",
	"Rely on Friends": "torrent",
	"Removal Beam": "beam",
	"Removal Pulse": "pulse",
	"Remove Lost": "shard",
	"Rend": "slash",
	"Rendezvous": "torrent",
	"Rendezvous Draw": "torrent",
	"Rending Jaws": "bite",
	"Repeat Lightning": "bolt",
	"Repeated Whip": "slash",
	"Repeater Blaze": "flame",
	"Repeating Drill": "drill",
	"Repeating Kick": "kick",
	"Repelling Odor": "impact",
	"Replace": "pulse",
	"Replenish Time": "drain",
	"Reply Strongly": "pulse",
	"Reprisal": "flame",
	"Repulsion": "quake",
	"Repulsion Bolt": "bolt",
	"Repulsor Axe": "slash",
	"Requiem-GX": "pulse",
	"Rescue": "torrent",
	"Rescue Kedge": "bloom",
	"Rescue String": "bloom",
	"Resentful Refrain": "torrent",
	"Resistance Blizzard": "frost",
	"Resistance Desert": "quake",
	"Resolute Blade": "slash",
	"Resolute Blade-GX": "slash",
	"Resolute Claws": "slash",
	"Resolute Fang": "bite",
	"Resolute Spite": "pulse",
	"Resonance": "shard",
	"Resonate": "pulse",
	"Resonating Blade": "slash",
	"Resource Management": "impact",
	"Rest": "drain",
	"Rest Well": "drain",
	"Restore": "drain",
	"Retaliate": "quake",
	"Retaliation": "bloom",
	"Retaliatory Incisors": "impact",
	"Retribution": "bloom",
	"Retribution Strike": "impact",
	"Retro Cave": "impact",
	"Return": "impact",
	"Return Attack": "pulse",
	"Return Blow": "impact",
	"Return Burn": "flame",
	"Return Charge": "impact",
	"Return Home": "quake",
	"Return Spark": "bolt",
	"Return Trance": "sleep",
	"Return Wave": "torrent",
	"Returning Echo": "pulse",
	"Returning Flames": "flame",
	"Rev": "shard",
	"Revelation": "pulse",
	"Revelation Dance": "whirl",
	"Revenge": "quake",
	"Revenge Blast": "boom",
	"Revenge Buster": "quake",
	"Revenge Cannon": "cannon",
	"Revenge Melody": "bloom",
	"Revengeful Storm": "whirl",
	"Reverse Edge": "slash",
	"Reverse Shoulder Throw": "quake",
	"Reverse Spin": "whirl",
	"Reverse Stream": "stream",
	"Reverse Thrust": "torrent",
	"Reversing Gust": "whirl",
	"Reversing Storm": "whirl",
	"Revival": "pulse",
	"Revival Blessing": "pulse",
	"Rewind": "pulse",
	"Rewind Beam": "beam",
	"Rewind Time": "shard",
	"Rhythmic Steps": "torrent",
	"Ride of the High King": "torrent",
	"Ride the Wind": "whirl",
	"Right Back at You": "drain",
	"Righteous Edge": "slash",
	"Rigidify": "shard",
	"Riled Horn": "drill",
	"Ring of Fire": "flame",
	"Riot": "veil",
	"Riotous Beating": "veil",
	"Riotous Blasting": "bolt",
	"Rip and Run": "veil",
	"Rip Claw": "slash",
	"Rip Off": "veil",
	"Ripping Horn": "drill",
	"Ripple": "drain",
	"Ripple Swell": "impact",
	"Riptide": "torrent",
	"Rising Blade": "slash",
	"Rising Bloom": "bloom",
	"Rising Chop": "chop",
	"Rising Dash": "impact",
	"Rising Fist": "fist",
	"Rising Lunge": "quake",
	"Rising Sword": "slash",
	"Rising Tackle": "impact",
	"Risk Taker": "bolt",
	"Risky Attack": "quake",
	"Risky Kick": "kick",
	"Roam": "drain",
	"Roar": "sonic",
	"Roar of Time": "sonic",
	"Roaring Flames": "flame",
	"Roaring Scream": "drain",
	"Roaring Seas": "torrent",
	"Roasting Burn": "flame",
	"Roasting Heat": "flame",
	"Rob": "veil",
	"Rock Artillery": "meteor",
	"Rock Black": "meteor",
	"Rock Blast": "meteor",
	"Rock Blaster": "meteor",
	"Rock Bullet": "meteor",
	"Rock Cannon": "meteor",
	"Rock Crush": "meteor",
	"Rock Drill Dive": "torrent",
	"Rock Head": "meteor",
	"Rock Hurl": "meteor",
	"Rock Kagura": "meteor",
	"Rock Polish": "meteor",
	"Rock Rush": "meteor",
	"Rock Shot": "meteor",
	"Rock Shower": "meteor",
	"Rock Slide": "meteor",
	"Rock Smash": "meteor",
	"Rock Stomp": "meteor",
	"Rock Tackle": "meteor",
	"Rock Throw": "meteor",
	"Rock Tomb": "meteor",
	"Rock Toss": "meteor",
	"Rock Tumble": "meteor",
	"Rock Vengeance": "meteor",
	"Rock Wrecker": "meteor",
	"Rocket Evolution": "quake",
	"Rocket Fall": "shard",
	"Rocket Feathers": "veil",
	"Rocket Jump": "pulse",
	"Rocket Mirror": "drain",
	"Rocket Poison": "veil",
	"Rocket Rush": "impact",
	"Rocket Slap": "impact",
	"Rocket Splash": "torrent",
	"Rocket Tackle": "impact",
	"Rocket Tail": "tail",
	"Rocky Avalanche-GX": "fall",
	"Rocky Tackle": "impact",
	"Rogue Fangs": "bite",
	"Rogue Ring": "veil",
	"Roll and Release": "gyro",
	"Roll Call": "gyro",
	"Roll Over": "gyro",
	"Roll Up": "gyro",
	"Rolling Attack": "gyro",
	"Rolling Dash": "gyro",
	"Rolling Fireball": "flame",
	"Rolling Frenzy": "gyro",
	"Rolling Iron": "gyro",
	"Rolling Kick": "kick",
	"Rolling Panic": "gyro",
	"Rolling Rocks": "gyro",
	"Rolling Rollout": "gyro",
	"Rolling Rush": "gyro",
	"Rolling Shell": "shell",
	"Rolling Slider": "gyro",
	"Rolling Spin": "gyro",
	"Rolling Tackle": "gyro",
	"Rolling Thunder": "gyro",
	"Rollout": "gyro",
	"Roof Fling": "bloom",
	"Roost": "drain",
	"Rotating Claws": "slash",
	"Roto Call": "pulse",
	"Rototiller": "quake",
	"Round": "note",
	"Rouse": "quake",
	"Rout": "impact",
	"Rowdy Hammer": "fist",
	"Royal Blades": "roar",
	"Royal Blaze": "flame",
	"Royal Flare": "flame",
	"Rubbish Blizzard": "frost",
	"Ruckus": "sparkle",
	"Ruffians Attack": "veil",
	"Rule of Evil": "veil",
	"Rule the Region": "torrent",
	"Rumble": "quake",
	"Rumble Stomp": "impact",
	"Rumbling Bees": "bloom",
	"Rumbling March": "quake",
	"Rumbling Wires": "bolt",
	"Rummage": "veil",
	"Run Around": "impact",
	"Running Charge": "impact",
	"Rush": "impact",
	"Rush Up": "impact",
	"Rushing Flames": "flame",
	"Rushing Magma": "flame",
	"Rushing Water": "torrent",
	"Rusty Claws": "slash",
	"Ruthless Tail": "tail",
	"Ruthless Whirlpool": "torrent",
	"Ryuno Glide": "roar",
	"Sacred Fire": "flame",
	"Sacred Sword": "slash",
	"Sacred Wing": "wing",
	"Safety Check": "impact",
	"Sage's Riddle": "impact",
	"Saliva Lure": "bloom",
	"Salt Cannon": "cannon",
	"Salt Coating": "drain",
	"Salt Water": "torrent",
	"Salty-sweet Pollen": "powder",
	"Salvage": "bolt",
	"Samesies Slap": "impact",
	"Sanctuary-GX": "drain",
	"Sand Attack": "sand",
	"Sand Bazooka": "sand",
	"Sand Breath": "sand",
	"Sand Bringer": "sand",
	"Sand Dive": "sand",
	"Sand Eater": "sand",
	"Sand Eject": "sand",
	"Sand Impact": "sand",
	"Sand Jet": "sand",
	"Sand Pit": "sand",
	"Sand Press": "sand",
	"Sand Pulse": "sand",
	"Sand Sink": "sand",
	"Sand Sonic": "sand",
	"Sand Spray": "sand",
	"Sand Sweep": "sand",
	"Sand Swirl": "sand",
	"Sand Tomb": "sand",
	"Sand Trap": "sand",
	"Sand Veil": "sand",
	"Sand Wall": "sand",
	"Sand Wind": "sand",
	"Sandpot Trap": "sand",
	"Sandstorm": "sand",
	"Sandstorm Spray": "sand",
	"Sandy Cloak Tackle": "sand",
	"Sandy Fear-GX": "sand",
	"Sandy Shot": "sand",
	"Satellite Beam": "beam",
	"Sauna Blast": "boom",
	"Savage Wing": "wing",
	"Save Sand": "sand",
	"Scald": "torrent",
	"Scalding Block": "flame",
	"Scalding Steam": "impact",
	"Scale Blow": "impact",
	"Scale Hurricane": "whirl",
	"Scaly Uppercut": "fist",
	"Scam": "shard",
	"Scamper Away": "bloom",
	"Scanblast": "boom",
	"Scar-Charged Smash": "quake",
	"Scar Strikes": "bolt",
	"Scarf Hold": "quake",
	"Scarring Shout": "veil",
	"Scary Face": "daze",
	"Scary Fangs": "bite",
	"Scatterbomb": "shard",
	"Scattered Shower": "torrent",
	"Scattering Cyclone": "whirl",
	"Scavenge": "pulse",
	"School Storm": "whirl",
	"Schooling Shot": "cannon",
	"Scintillating Surfing": "shard",
	"Scissor Blow": "slash",
	"Scissor Swing": "slash",
	"Scoop Water": "torrent",
	"Scorch": "flame",
	"Scorching Bazooka": "flame",
	"Scorching Breath": "breath",
	"Scorching Column": "flame",
	"Scorching Cyclone": "whirl",
	"Scorching Earth": "quake",
	"Scorching Fang": "bite",
	"Scorching Fire": "flame",
	"Scorching Heater": "flame",
	"Scorching Horn": "drill",
	"Scorching Interruption": "roar",
	"Scorching Lava": "flame",
	"Scorching Light": "sparkle",
	"Scorching Smoke": "flame",
	"Scorching Whirlwind": "whirl",
	"Scorching Wind": "whirl",
	"Scorching Wing": "wing",
	"Scorpion Grapple": "veil",
	"Scout": "impact",
	"Scramble Trip": "impact",
	"Scrap Attack": "shard",
	"Scrap Drop": "shard",
	"Scrap Pickup": "pulse",
	"Scrap Pulse": "pulse",
	"Scrap Short": "bolt",
	"Scrape Down": "drain",
	"Scrape Off": "impact",
	"Scrappy Spark": "bolt",
	"Scratch": "slash",
	"Scratch and Draw": "slash",
	"Scratching Nails": "bloom",
	"Scream": "pulse",
	"Screaming Circle": "drain",
	"Screaming Fit": "daze",
	"Screaming Headbutt": "impact",
	"Screech": "sonic",
	"Screechy Voice": "impact",
	"Screw Knuckle": "fist",
	"Screw Tail": "tail",
	"Scrounge": "impact",
	"Scrounge-and-Scarf": "veil",
	"Scrunch": "impact",
	"Scrutinize": "impact",
	"Sea Bathing": "drain",
	"Sea Creeper Net": "bloom",
	"Sea Feast": "torrent",
	"Sea Spray": "torrent",
	"Seafaring": "torrent",
	"Seal Off": "veil",
	"Search and Escape": "impact",
	"Search and Invite": "impact",
	"Searching Eyes": "daze",
	"Searching Light": "sparkle",
	"Searching Magnet": "bolt",
	"Searchlight": "bolt",
	"Searchlight Tail": "tail",
	"Searing Flame": "flame",
	"Searing Flames": "flame",
	"Seashell Attack": "torrent",
	"Seaweed Grab": "pulse",
	"Second Bite": "bite",
	"Second Strike": "impact",
	"Secondary Chills": "bolt",
	"Secret Attack": "flame",
	"Secret Blessings": "sparkle",
	"Secret Sword": "slash",
	"Secrete Poison": "veil",
	"Sediment Sink": "torrent",
	"See Beyond": "impact",
	"See Off": "pulse",
	"See Through": "pulse",
	"Seed Bomb": "bloom",
	"Seed Flare": "flame",
	"Seek Inspiration": "pulse",
	"Seek Out": "impact",
	"Seeking Fang": "bite",
	"Seething Anger": "impact",
	"Seething Tentacles": "wrap",
	"Seismic Punch": "quake",
	"Seismic Rift": "quake",
	"Seismic Toss": "quake",
	"Select Powder": "powder",
	"Self-abandonment": "impact",
	"Self Charge": "impact",
	"Self-Destruct": "boom",
	"Selfdestruct": "boom",
	"Selfish Draw": "shard",
	"Selickt": "impact",
	"Send Back": "impact",
	"Send Flowers": "bloom",
	"Sensitive Blade": "slash",
	"Sensitive Ray": "beam",
	"Serial Swipes": "flame",
	"Serve Trash": "shard",
	"Set Song": "note",
	"Settle the Score": "quake",
	"Seven Shock": "bolt",
	"Seventh Echo": "roar",
	"Seventh Kick": "kick",
	"Sever": "bloom",
	"Severe Gas": "powder",
	"Severe Poison": "veil",
	"Severe Squall": "torrent",
	"Shadow Attack": "veil",
	"Shadow Ball": "veil",
	"Shadow Beam": "beam",
	"Shadow Bind": "wrap",
	"Shadow Bullet": "cannon",
	"Shadow Cage": "veil",
	"Shadow Chant": "veil",
	"Shadow Charge": "veil",
	"Shadow Claw": "slash",
	"Shadow Crush": "veil",
	"Shadow Cyclone": "veil",
	"Shadow Dance": "veil",
	"Shadow Drain": "drain",
	"Shadow Flicker": "veil",
	"Shadow Force": "veil",
	"Shadow Hand": "veil",
	"Shadow Hit": "veil",
	"Shadow Images": "veil",
	"Shadow Imitation": "veil",
	"Shadow Impact": "veil",
	"Shadow Mist": "veil",
	"Shadow Punch": "fist",
	"Shadow Ripper": "veil",
	"Shadow Room": "veil",
	"Shadow Scratch": "slash",
	"Shadow Seeker": "veil",
	"Shadow Shutdown": "veil",
	"Shadow Skip": "veil",
	"Shadow Slash": "slash",
	"Shadow Sneak": "veil",
	"Shadow Steal": "veil",
	"Shadow Stitching": "veil",
	"Shadow Tag": "veil",
	"Shadowy Bite": "bite",
	"Shadowy Echoes": "veil",
	"Shadowy Hunter-GX": "veil",
	"Shadowy Knot": "veil",
	"Shadowy Side Kick": "kick",
	"Shadowy Whip": "veil",
	"Shadowy Wind": "veil",
	"Shady Stamp": "pulse",
	"Shake": "flame",
	"Shake and Discharge": "bolt",
	"Shake and Gather": "bloom",
	"Shake It Off": "bloom",
	"Shake Vine": "bloom",
	"Shakedown": "veil",
	"Shaking Stomp": "impact",
	"Shaky Fall": "torrent",
	"Shaky Wave": "torrent",
	"Share": "drain",
	"Shared Peace": "pulse",
	"Sharp Beak": "impact",
	"Sharp Blade Quill": "slash",
	"Sharp Claws": "slash",
	"Sharp Fang": "bite",
	"Sharp Fin": "torrent",
	"Sharp Leaf": "bloom",
	"Sharp Mane": "quake",
	"Sharp Pincers": "torrent",
	"Sharp Point": "impact",
	"Sharp Scythe": "quake",
	"Sharp Sickle": "quake",
	"Sharp Sting": "sting",
	"Sharp Stinger": "bolt",
	"Sharp Tail": "tail",
	"Sharp Teeth": "impact",
	"Sharpen": "impact",
	"Sharpen Claws": "slash",
	"Sharpness": "pulse",
	"Sharpshooter": "bloom",
	"Sharpshooting": "torrent",
	"Shatter": "veil",
	"Shatter Shot": "cannon",
	"Shattering Speed": "bolt",
	"Shear": "quake",
	"Shed": "drain",
	"Shed Skin": "drain",
	"Shedding Spiral": "whirl",
	"Sheer Cold": "torrent",
	"Shell Attack": "shell",
	"Shell Crash": "shell",
	"Shell Grab": "shell",
	"Shell Hunting": "shell",
	"Shell Press": "shell",
	"Shell Protection": "shell",
	"Shell Rest": "shell",
	"Shell Rupture": "shell",
	"Shell Scatter": "shell",
	"Shell Smack": "shell",
	"Shell Stunner": "shell",
	"Shell Trap": "shell",
	"Shellnado Spin": "whirl",
	"Shield Attack": "shield",
	"Shield Bash": "impact",
	"Shield Beam": "beam",
	"Shiftadieu": "drain",
	"Shifting Shuriken": "torrent",
	"Shimmering Scales": "flame",
	"Shimmering Slash": "slash",
	"Shimmering Star": "swift",
	"Shine On": "bolt",
	"Shining Arrow": "arrow",
	"Shining Blaze": "flame",
	"Shining Breath": "breath",
	"Shining Burst": "boom",
	"Shining Claws": "slash",
	"Shining Current": "torrent",
	"Shining Eyes": "daze",
	"Shining Fang": "bite",
	"Shining Feathers": "flame",
	"Shining Fingers": "sleep",
	"Shining Flame": "flame",
	"Shining Star": "swift",
	"Shining Wind": "whirl",
	"Shinobi Blade": "slash",
	"Shinobi Mastery": "bloom",
	"Shinobi Strike": "impact",
	"Shivery Wave": "torrent",
	"Shock Bolt": "bolt",
	"Shock Generator": "bolt",
	"Shock Wave": "torrent",
	"Shocking Bolt": "bolt",
	"Shocking Jaws": "bolt",
	"Shocking Knuckle": "fist",
	"Shocking Needles": "bolt",
	"Shocking Pursuit": "bolt",
	"Shocking Shock": "bolt",
	"Shocking Smash": "bolt",
	"Shocking Sting": "bolt",
	"Shocking Web": "web",
	"Shockwave": "bolt",
	"Shoegaze": "roar",
	"Shooing Shout": "pulse",
	"Shoot Down": "quake",
	"Shoot Needle": "sting",
	"Shoot Through": "bloom",
	"Shooting Fire": "flame",
	"Shooting Moons": "pulse",
	"Shooting Star": "swift",
	"Shooting Star Pirouette": "swift",
	"Shore Up": "quake",
	"Short-Circuit Knuckle": "fist",
	"Shorting Spark": "bolt",
	"Shot Air": "cannon",
	"Shot in the Dark": "cannon",
	"Shoulder Throw": "quake",
	"Shout": "impact",
	"Shout of Power": "roar",
	"Shove": "quake",
	"Show Off": "impact",
	"Showboating Pose": "impact",
	"Shred": "roar",
	"Shrieking Poison": "veil",
	"Shuffle Attack": "pulse",
	"Side Eye": "daze",
	"Sidestep": "quake",
	"Signal Beam": "beam",
	"Signs of Evolution": "impact",
	"Silence": "veil",
	"Silent Bite": "bite",
	"Silent Claw": "slash",
	"Silent Fear": "drain",
	"Silent Shot": "cannon",
	"Silent Wing": "wing",
	"Silhouette": "drain",
	"Silver Cannon": "cannon",
	"Silver Feather": "wing",
	"Silver Fist": "fist",
	"Silver Knight-GX": "impact",
	"Silver Scale": "bloom",
	"Silver Wind": "whirl",
	"Silver Wing": "wing",
	"Silvery Snow Star": "swift",
	"Simultaneous Peck": "barrage",
	"Sing": "note",
	"Singe": "flame",
	"Singe Off": "flame",
	"Singing Voice": "sparkle",
	"Single-Horn Throw": "drill",
	"Single Lunge": "bloom",
	"Single Shot Blast": "boom",
	"Single Smash": "quake",
	"Single Strike Crush": "impact",
	"Single Strike Tackle": "impact",
	"Single Strike Wings": "wing",
	"Sinister Fog": "acid",
	"Sinister Suggestion": "pulse",
	"Sink Deep": "torrent",
	"Siphon Off": "torrent",
	"Sitdown Bounce": "impact",
	"Sitdown Splash": "torrent",
	"Skedaddle": "impact",
	"Sketch": "impact",
	"Sketching Trash": "impact",
	"Skill Copy": "pulse",
	"Skill Dive": "torrent",
	"Skill Hack": "veil",
	"Skill Thief": "veil",
	"Skim Attack": "bloom",
	"Skip": "impact",
	"Skull Bash": "impact",
	"Sky Attack": "wing",
	"Sky Blade": "slash",
	"Sky Drop": "impact",
	"Sky Heal": "drain",
	"Sky-High Claws": "slash",
	"Sky Hunting": "impact",
	"Sky Hurricane": "whirl",
	"Sky Judgement": "impact",
	"Sky Judgment": "roar",
	"Sky Kick": "kick",
	"Sky Lariat": "impact",
	"Sky Legends-GX": "impact",
	"Sky Return": "impact",
	"Sky’s Blessing": "roar",
	"Sky-Scorching Light-GX": "sparkle",
	"Sky Spear": "impact",
	"Sky Uppercut": "fist",
	"Sky Wave": "torrent",
	"Skyward Kick": "kick",
	"Slack Off": "drain",
	"Slacker's Headstrike": "impact",
	"Slam": "impact",
	"Slap": "impact",
	"Slap Awake": "impact",
	"Slap Down": "impact",
	"Slap of Misfortune": "impact",
	"Slap Push": "impact",
	"Slap Slap": "impact",
	"Slapping Knockdown": "quake",
	"Slappy Knuckle": "fist",
	"Slash": "slash",
	"Slash Back": "slash",
	"Slash Back-GX": "slash",
	"Slash Blast": "slash",
	"Slashing Claw": "slash",
	"Slashing Cutter": "slash",
	"Slashing Steel": "shard",
	"Slashing Strike": "impact",
	"Sledgehammer": "quake",
	"Sleep Bubble": "bubble",
	"Sleep Drain": "drain",
	"Sleep Hole": "sleep",
	"Sleep Inducer": "sleep",
	"Sleep Pearl": "sleep",
	"Sleep Pinchers": "sleep",
	"Sleep Poison": "sleep",
	"Sleep Powder": "powder",
	"Sleep Pulse": "sleep",
	"Sleep Sap": "sleep",
	"Sleep Scent": "sleep",
	"Sleep Seed": "sleep",
	"Sleep Spore": "powder",
	"Sleep Swirl": "sleep",
	"Sleeping Gas": "powder",
	"Sleeping Spell": "sleep",
	"Sleepy": "sleep",
	"Sleepy Ball": "sleep",
	"Sleepy Lost": "sleep",
	"Sleepy Lullaby": "sleep",
	"Sleepy Press": "sleep",
	"Sleepy Pulse": "sleep",
	"Sleepy Song": "note",
	"Sleight of Hand": "pulse",
	"Slice": "slash",
	"Slice Drain": "slash",
	"Slicing Blade": "slash",
	"Slicing Snipe": "bloom",
	"Slicing Wind": "whirl",
	"Slight Intrusion": "quake",
	"Slight Shift": "pulse",
	"Slight Splash": "torrent",
	"Slightly Simmer": "pulse",
	"Slightly Spicy": "bloom",
	"Slim Screw": "torrent",
	"Slime": "torrent",
	"Slimy Water": "torrent",
	"Sling": "bloom",
	"Slip 'n' Roll": "gyro",
	"Slip-'n'-Trip": "roar",
	"Slippery Sludge": "acid",
	"Slosh 'n' Crash": "impact",
	"Slow-Acting Acid": "acid",
	"Slow-Acting Poison": "veil",
	"Slow-Acting Syncope": "quake",
	"Slow Ballad": "drain",
	"Slow Crunch": "bite",
	"Slow Trip Gas": "powder",
	"Slowing Beam": "beam",
	"Slowing Perfume": "wing",
	"Sludge": "acid",
	"Sludge Bomb": "acid",
	"Sludge Crash": "acid",
	"Sludge Drag": "acid",
	"Sludge Grip": "acid",
	"Sludge Punch": "acid",
	"Sludge Shock": "bolt",
	"Sludge Toss": "acid",
	"Sludge Whirlpool": "torrent",
	"Slumbering Smack": "sleep",
	"Slurp Shakedown": "bolt",
	"Slurp Slurp": "pulse",
	"Smack": "pulse",
	"Smack and Run": "impact",
	"Smack Attack": "shard",
	"Smack Down": "quake",
	"Smack ‘n' Slack": "impact",
	"Small Appetite": "bolt",
	"Smart Service": "pulse",
	"Smash Bomb": "quake",
	"Smash Bomber": "quake",
	"Smash Kick": "kick",
	"Smash Punch": "quake",
	"Smash Short": "quake",
	"Smash Turn": "quake",
	"Smash Uppercut": "fist",
	"Smashing Edge": "slash",
	"Smashing Headbutt": "impact",
	"Smashing Horn": "drill",
	"Smashing Wing": "wing",
	"Smelly Gas": "powder",
	"Smithereen Smash": "quake",
	"Smitten Strike": "impact",
	"Smog": "acid",
	"Smog Burst": "acid",
	"Smogbank": "pulse",
	"Smogscreen": "pulse",
	"Smoke Bomb": "boom",
	"Smokescreen": "ink",
	"Smokescreen Shot": "ink",
	"Smolder-sault": "flame",
	"Smoldering Scales": "flame",
	"Snake Hook": "impact",
	"Snap Attack": "impact",
	"Snap Inspection": "impact",
	"Snap Tail": "tail",
	"Snapping Pincers": "bloom",
	"Snapping Trap": "wrap",
	"Snarl": "sonic",
	"Snatch": "shard",
	"Snatch and Flee": "veil",
	"Snatch and Run": "veil",
	"Sneaky Attack": "impact",
	"Sneaky Placement": "drain",
	"Sneaky Pocket": "sparkle",
	"Sneaky Smash": "quake",
	"Sneaky Snacking": "torrent",
	"Sniff Out": "bolt",
	"Sniffle": "torrent",
	"Snip Snip": "torrent",
	"Snipe Shot": "cannon",
	"Sniping Arrow": "arrow",
	"Sniping Feathers": "veil",
	"Sniping Tail": "tail",
	"Snipping Pincers": "quake",
	"Snivel": "quake",
	"Snooze": "sleep",
	"Snotted Up": "torrent",
	"Snow Bringer": "frost",
	"Snow Cloak": "frost",
	"Snow Coating": "frost",
	"Snow Mirage": "frost",
	"Snow Play": "frost",
	"Snow Squall": "frost",
	"Snowball": "frost",
	"Snowball Fight": "frost",
	"Snowstorm": "frost",
	"Snowy Chilling": "frost",
	"Snowy Drop": "frost",
	"Snowy Present": "frost",
	"Snowy Wind": "frost",
	"Snuggly Generator": "bolt",
	"Soak in Water": "torrent",
	"Soaking Horn": "drill",
	"Sob": "torrent",
	"Soggy Rush": "impact",
	"Sol Breaker": "impact",
	"Sol Burst-GX": "boom",
	"Sol Charge": "impact",
	"Sol Fangs": "bite",
	"Sol Slice": "slash",
	"Solar Beam": "beam",
	"Solar Birth": "bloom",
	"Solar Blade": "slash",
	"Solar Blast": "bloom",
	"Solar Coiling": "bloom",
	"Solar Cutter": "slash",
	"Solar Generator": "bloom",
	"Solar Geyser": "bloom",
	"Solar Heat": "flame",
	"Solar Plant-GX": "bloom",
	"Solar Power": "bloom",
	"Solar Ray": "beam",
	"Solar Shot": "bloom",
	"Solar Step": "bloom",
	"Solar Suggestion": "bloom",
	"Solar Transporter": "bloom",
	"Solar Typhoon": "bloom",
	"Solarbeam": "beam",
	"Soliciting Nectar": "sleep",
	"Somersault Dive": "torrent",
	"Somersault Feathers": "quake",
	"Somersault Kick": "kick",
	"Song of Echoes": "note",
	"Sonic Ace": "sonic",
	"Sonic Blade": "slash",
	"Sonic Blast": "sonic",
	"Sonic Boom": "sonic",
	"Sonic Distortion": "sonic",
	"Sonic Dive": "sonic",
	"Sonic Double": "barrage",
	"Sonic Edge": "sonic",
	"Sonic Edge-GX": "sonic",
	"Sonic Evil": "sonic",
	"Sonic Impulse": "sonic",
	"Sonic Legs": "sonic",
	"Sonic Noise": "sonic",
	"Sonic Peridot": "sonic",
	"Sonic Ripper": "sonic",
	"Sonic Scream": "sonic",
	"Sonic Signal": "sonic",
	"Sonic Strike": "sonic",
	"Sonic Volume": "sonic",
	"Sonic Wave": "sonic",
	"Sonic Wing": "sonic",
	"Sonicboom": "bolt",
	"Soothing Lullaby": "roar",
	"Soothing Melody": "drain",
	"Soothing Scent": "powder",
	"Soothing Wave": "torrent",
	"Sooting Scent": "powder",
	"Soprano Wave": "torrent",
	"Sore Performance": "bloom",
	"Sore Spot": "torrent",
	"Soul Blaster": "boom",
	"Soul Counter": "torrent",
	"Soul Destroyer": "veil",
	"Soul Shot": "cannon",
	"Sound Waves": "daze",
	"Sour Spit": "bloom",
	"Souvenir": "drain",
	"Space Crash": "impact",
	"Space Out": "sleep",
	"Spacial Rend": "slash",
	"Spacing Out": "drain",
	"Spark": "bolt",
	"Spark Ball-GX": "bolt",
	"Spark Bolt": "bolt",
	"Spark Duo": "bolt",
	"Spark Rush": "bolt",
	"Spark Trap": "bolt",
	"Sparking Ball": "bolt",
	"Sparking Gadget": "bolt",
	"Sparking Strike": "bolt",
	"Sparkle": "sparkle",
	"Sparkle Motion": "sparkle",
	"Sparkling Aria": "note",
	"Sparkling Pearl": "torrent",
	"Sparkling Tail": "tail",
	"Sparkling Wing": "wing",
	"Sparkling Wish": "drain",
	"Spatial Control": "roar",
	"Spear Dive": "torrent",
	"Spearhead": "impact",
	"Special Anchor": "bloom",
	"Special Artillery": "torrent",
	"Special Blow": "impact",
	"Special Circuit": "bolt",
	"Special Combo": "barrage",
	"Special Fang": "bite",
	"Special Formula": "bloom",
	"Special Hammer": "fist",
	"Special Horn": "drill",
	"Special Laser": "beam",
	"Special Mow": "bloom",
	"Special Punch": "fist",
	"Special Reaction": "bloom",
	"Special Roll": "gyro",
	"Special Tackle": "impact",
	"Special Wave": "torrent",
	"Special Whip": "slash",
	"Spectacular Save": "torrent",
	"Speed Attack": "impact",
	"Speed Ball": "aura",
	"Speed Bolt": "bolt",
	"Speed Dive": "torrent",
	"Speed Evolution": "bloom",
	"Speed Growth": "bloom",
	"Speed Impact": "impact",
	"Speed Shot": "cannon",
	"Speed Slide": "torrent",
	"Speed Stroke": "impact",
	"Speed Wing": "wing",
	"Speeding Skystrike-GX": "impact",
	"Speedy Uppercut": "fist",
	"Spellbinding Start": "pulse",
	"Spelunk": "shard",
	"Spending Rush": "impact",
	"Spicy Headbutt": "impact",
	"Spicy Rage": "rage",
	"Spider Force": "web",
	"Spider Scram": "web",
	"Spider Thread": "web",
	"Spider Trap": "web",
	"Spider Web": "web",
	"Spike Armor": "sting",
	"Spike Ball Tackle": "sting",
	"Spike Barrage": "barrage",
	"Spike Cannon": "cannon",
	"Spike Draw": "sting",
	"Spike Lariat": "sting",
	"Spike Lash": "sting",
	"Spike Rend": "slash",
	"Spike Shot": "sting",
	"Spike Spread": "sting",
	"Spike Stab": "slash",
	"Spike Sting": "sting",
	"Spike Whip": "sting",
	"Spike Wound": "sting",
	"Spiky Hopper": "impact",
	"Spiky Knuckle": "fist",
	"Spiky Rolling": "gyro",
	"Spiky Shell": "shell",
	"Spiky Storm-GX": "whirl",
	"Spiky Thunder": "bolt",
	"Spiky Wheel": "veil",
	"Spill Out": "impact",
	"Spill the Tea": "bloom",
	"Spin and Draw": "whirl",
	"Spin Ball": "whirl",
	"Spin Storm": "whirl",
	"Spin Tackle": "whirl",
	"Spin Turn": "whirl",
	"Spine Missile": "torrent",
	"Spinning Attack": "pulse",
	"Spinning Bird": "impact",
	"Spinning Blow": "impact",
	"Spinning Draw": "shard",
	"Spinning Drift": "shard",
	"Spinning Fan": "bolt",
	"Spinning Fumes": "veil",
	"Spinning Gears": "shard",
	"Spinning Head": "impact",
	"Spinning Horn": "drill",
	"Spinning Kick": "kick",
	"Spinning Needles": "shard",
	"Spinning Tail": "tail",
	"Spinning Turn": "quake",
	"Spinning Whip": "slash",
	"Spiny Punch": "fist",
	"Spiny Rush": "whirl",
	"Spiral Attack": "whirl",
	"Spiral Aura": "whirl",
	"Spiral Blast": "boom",
	"Spiral Burst": "boom",
	"Spiral Buzz": "whirl",
	"Spiral Current": "torrent",
	"Spiral Dive": "torrent",
	"Spiral Drain": "drain",
	"Spiral Growth": "whirl",
	"Spiral Gyration": "whirl",
	"Spiral Jet": "whirl",
	"Spiral Kick": "kick",
	"Spiral Leaf": "bloom",
	"Spiral Punch": "fist",
	"Spiral Rush": "whirl",
	"Spiral Shot": "cannon",
	"Spiral Thunder": "bolt",
	"Spiral Wave": "torrent",
	"Spirit Burner": "flame",
	"Spirit Compressor": "veil",
	"Spirit Dance": "whirl",
	"Spirit Juggling": "pulse",
	"Spirit Scream": "drain",
	"Spirit Smash": "quake",
	"Spirited Drill": "drill",
	"Spirited Headbutt": "impact",
	"Spirited Rushdown": "bloom",
	"Spirited Smack": "bloom",
	"Spirited Tackle": "impact",
	"Spirited Throw": "quake",
	"Spiritual End": "drain",
	"Spit Acid": "acid",
	"Spit Beam": "beam",
	"Spit Innocently": "torrent",
	"Spit-Out Shot": "cannon",
	"Spit Poison": "veil",
	"Spit Shot": "cannon",
	"Spit Squall": "bloom",
	"Spit Up": "torrent",
	"Spiteful Dance": "whirl",
	"Spiteful Illusion": "impact",
	"Spiteful Pain": "pulse",
	"Spiteful Sigh": "torrent",
	"Splash": "torrent",
	"Splash About": "torrent",
	"Splash Arch": "torrent",
	"Splash Bomb": "torrent",
	"Splash Burn": "flame",
	"Splash Cannon": "torrent",
	"Splash Dance": "torrent",
	"Splash Jump": "torrent",
	"Splash Loop": "torrent",
	"Splash Maker": "torrent",
	"Splashing Dodge": "torrent",
	"Splashing Panic": "torrent",
	"Splashing Turn": "torrent",
	"Splashy Splash": "torrent",
	"Splashy Toss": "quake",
	"Splatter": "torrent",
	"Splatter Coating": "impact",
	"Splattering Poison": "veil",
	"Splattering Sludge": "acid",
	"Splintered Shards-GX": "quake",
	"Split Ball": "aura",
	"Split Blast": "boom",
	"Split Bomb": "boom",
	"Split Kick": "kick",
	"Split Spiral Punch": "fist",
	"Splitting Arrow": "arrow",
	"Splitting Beam": "beam",
	"Splitting Spite": "veil",
	"Splup": "impact",
	"Spoil the Fun": "veil",
	"Spontaneous Explosion": "boom",
	"Spook": "pulse",
	"Spooky Balloon": "pulse",
	"Spooky Sand": "sand",
	"Spooky Shot": "cannon",
	"Sporadic Sponging": "bloom",
	"Spore": "powder",
	"Spore Ball": "powder",
	"Spore Evolution": "powder",
	"Spray Fluid": "bloom",
	"Spread Filaments": "bloom",
	"Spread Poison": "veil",
	"Spreading Fire": "flame",
	"Spreading Flames": "flame",
	"Spreading Light": "sparkle",
	"Spreading Spite": "drain",
	"Sprial Drain": "drain",
	"Spring Back": "torrent",
	"Spring Out": "torrent",
	"Spring Tides": "torrent",
	"Springy": "pulse",
	"Sprinkle Water": "torrent",
	"Sprinting Flare": "flame",
	"Sprout": "bloom",
	"Sprouting": "bloom",
	"Spurt Fire": "flame",
	"Sputter": "flame",
	"Spy": "impact",
	"Squared Attack": "shard",
	"Squaredance": "impact",
	"Squeeze": "shard",
	"Squirt": "torrent",
	"Squishy Healing": "drain",
	"Stab": "slash",
	"Stab Deeply": "slash",
	"Stadium Burn": "flame",
	"Stadium Drain": "drain",
	"Stadium Play": "torrent",
	"Stadium Power": "impact",
	"Stadium Wave": "torrent",
	"Staggering Steps": "daze",
	"Stakeout Headbutt": "impact",
	"Stalk": "bloom",
	"Stalking Claws-GX": "slash",
	"Stall": "impact",
	"Stamp": "veil",
	"Stampede": "veil",
	"Standing By": "torrent",
	"Star Back": "swift",
	"Star Blaze": "swift",
	"Star Boomerang": "swift",
	"Star Chronos": "swift",
	"Star Cipher": "swift",
	"Star Drop": "swift",
	"Star Force": "swift",
	"Star Freeze": "swift",
	"Star Gravity": "swift",
	"Star Protection": "swift",
	"Star Raid": "swift",
	"Star Requiem": "swift",
	"Star Search": "swift",
	"Star Shield-GX": "swift",
	"Star Stream": "swift",
	"Star Winder": "swift",
	"Stardust": "shard",
	"Stare": "bloom",
	"Startling Bark": "sparkle",
	"Startling Trip": "torrent",
	"Starvin'": "pulse",
	"Static Electricity": "bolt",
	"Static Shock": "bolt",
	"Static Slap": "impact",
	"Steady Firebreathing": "flame",
	"Steady Punch": "fist",
	"Stealth Attack": "impact",
	"Stealth Poison": "veil",
	"Stealth Rock": "meteor",
	"Stealthy Shuriken": "torrent",
	"Stealy Claws": "slash",
	"Steam Artillery": "flame",
	"Steam Blast": "boom",
	"Steam Crush": "impact",
	"Steam Twister": "impact",
	"Steamin' Mad Strike": "impact",
	"Steaming Mad": "quake",
	"Steaming Stomp": "impact",
	"Steamroll": "torrent",
	"Steamroller": "pulse",
	"Steel Anchor": "shard",
	"Steel Beak": "shard",
	"Steel Beam": "beam",
	"Steel Bullet": "cannon",
	"Steel Burst": "boom",
	"Steel Coat": "shard",
	"Steel Cut": "slash",
	"Steel Cutter": "slash",
	"Steel Drop": "shard",
	"Steel Feelers": "shard",
	"Steel Fist": "fist",
	"Steel Generator": "shard",
	"Steel Headbutt": "shard",
	"Steel Melt": "shard",
	"Steel Short": "shard",
	"Steel Slash": "slash",
	"Steel Slice": "slash",
	"Steel Swing": "shard",
	"Steel Tackle": "shard",
	"Steel Wave": "torrent",
	"Steel Wing": "shard",
	"Steelworks": "shard",
	"Steep Dive": "torrent",
	"Stellar Cradle": "pulse",
	"Stellar Reign": "pulse",
	"Stick and Absorb": "drain",
	"Stick 'n' Draw": "shard",
	"Stick On": "impact",
	"Sticky Hands": "bloom",
	"Sticky Jail": "veil",
	"Sticky Liquid": "torrent",
	"Sticky Nectar": "bloom",
	"Sticky Shot": "cannon",
	"Sticky Smokescreen": "ink",
	"Sticky String": "bloom",
	"Sticky Web": "web",
	"Stiffen": "bloom",
	"Stifling Fluff": "impact",
	"Sting": "sting",
	"Sting Missile": "sting",
	"Sting Turn": "sting",
	"Stinger-GX": "pulse",
	"Stinky Nectar": "pulse",
	"Stinky Scent": "powder",
	"Stir the Brain": "pulse",
	"Stock Up on Feathers": "bloom",
	"Stockpile": "torrent",
	"Stoke": "flame",
	"Stomp": "impact",
	"Stomp Off": "impact",
	"Stomping Wood": "bloom",
	"Stompy Jammer": "pulse",
	"Stompy Stomp": "impact",
	"Stone Age-GX": "meteor",
	"Stone Barrage": "barrage",
	"Stone Crush": "meteor",
	"Stone Edge": "meteor",
	"Stone Generator": "meteor",
	"Stone Gift": "meteor",
	"Stone Throw": "meteor",
	"Stony Kick": "kick",
	"Stored Power": "aura",
	"Storm Barrier": "shield",
	"Storm Blade": "slash",
	"Storm Bolt": "bolt",
	"Storm Slash": "slash",
	"Storm Throw": "quake",
	"Storm Up": "whirl",
	"Stormy Prison": "torrent",
	"Stormy Seas": "torrent",
	"Strafe": "veil",
	"Strafe-GX": "pulse",
	"Straight Claw": "slash",
	"Strange Bell": "pulse",
	"Strange Dance": "whirl",
	"Strange Hacking": "daze",
	"Strange Poison": "veil",
	"Strange Powder": "powder",
	"Strange Rasping": "bloom",
	"Strange Reaction": "bloom",
	"Strange Scale": "torrent",
	"Strange Scent": "powder",
	"Strange Sludge": "acid",
	"Strange Spin": "whirl",
	"Strange Wave": "torrent",
	"Strangle": "flame",
	"Stray Cat Dash": "impact",
	"Stream Pump": "stream",
	"Strength": "quake",
	"Strength in Numbers": "bloom",
	"Strength Sap": "sparkle",
	"Stress Poison": "veil",
	"Stressful Eye": "daze",
	"Stretch Claws": "slash",
	"Stretch Kick": "kick",
	"Stretch Tail": "tail",
	"Stretch Tongue": "impact",
	"Stretch Vine": "bloom",
	"Strike and Fade": "impact",
	"Strike and Run": "impact",
	"Strike Back": "impact",
	"Strike Down": "impact",
	"Strike It Rich": "impact",
	"Strike of Enlightenment": "impact",
	"Strike of the Champion": "impact",
	"Strike the Sleeper": "sleep",
	"Strike Wound": "impact",
	"Striking Kick": "kick",
	"String Bind": "wrap",
	"String Bomb": "boom",
	"String Haul": "bloom",
	"String Pull": "bloom",
	"String Shot": "web",
	"String Truss": "bloom",
	"Strip Bare": "veil",
	"Strobe Shock": "bolt",
	"Strong-Arm Lariat": "impact",
	"Strong-Armed Destroyer": "torrent",
	"Strong Bash": "impact",
	"Strong Bite": "bite",
	"Strong Bond": "roar",
	"Strong Breeze": "impact",
	"Strong Current": "bolt",
	"Strong Flare": "flame",
	"Strong Gust": "whirl",
	"Strong Slash": "slash",
	"Strong Tail": "tail",
	"Strong Volt": "bolt",
	"Strong-Willed": "quake",
	"Strong Winds": "impact",
	"Strongarm Impact": "impact",
	"Struggle Bug": "bloom",
	"Stuck-In Tackle": "impact",
	"Stumbling Draw": "torrent",
	"Stumbling Press": "impact",
	"Stun Gas": "powder",
	"Stun Needle": "sting",
	"Stun Poison": "veil",
	"Stun Spore": "powder",
	"Stun Wave": "torrent",
	"Stunning Likeness": "impact",
	"Stunning Uppercut": "fist",
	"Sublimation-GX": "sparkle",
	"Submarine Blow": "impact",
	"Submerge Silently": "torrent",
	"Submission": "quake",
	"Submission Hold": "quake",
	"Subspace Swell": "torrent",
	"Successive Slapping": "bolt",
	"Sucker Punch": "fist",
	"Sucker Punch and Turn": "fist",
	"Suction": "flame",
	"Suction Heal": "drain",
	"Suction Shock": "bolt",
	"Suctioning Vines": "bloom",
	"Sudden Charge": "impact",
	"Sudden Delete": "torrent",
	"Sudden Drilling": "impact",
	"Sudden Eater": "bite",
	"Sudden Flash": "sparkle",
	"Sudden Grip": "torrent",
	"Sudden Growth": "torrent",
	"Sudden Scorching": "flame",
	"Sudden Shout": "impact",
	"Sudden Sting": "sting",
	"Sudden Swipe": "impact",
	"Suffocating Gas": "powder",
	"Sugary Sprinkles": "drain",
	"Suggestion": "pulse",
	"Summon": "pulse",
	"Summon Lightning": "bolt",
	"Summon Storm": "whirl",
	"Summoning Aroma": "powder",
	"Summoning Draw": "pulse",
	"Summoning Gate": "pulse",
	"Summoning Jutsu": "torrent",
	"Summoning Sign": "pulse",
	"Sun-Drenched Tackle": "impact",
	"Sun Flash": "sparkle",
	"Sun's Eclipse-GX": "shard",
	"Sun Soak": "torrent",
	"Sunbathe": "drain",
	"Sunburn": "flame",
	"Sunny Assist": "flame",
	"Sunny Scorching": "flame",
	"Sunny Wind": "whirl",
	"Sunshine": "flame",
	"Sunsteel Strike": "impact",
	"Super Absorption": "drain",
	"Super Deep Dive": "torrent",
	"Super Eggsplosion": "bloom",
	"Super Electromagnetic Tackle": "bolt",
	"Super Explosion": "boom",
	"Super Fang": "bite",
	"Super Fast": "torrent",
	"Super Growth": "bloom",
	"Super Hypno Wave": "torrent",
	"Super Hypnoblast": "boom",
	"Super Icy Wind": "frost",
	"Super Intense Poison": "veil",
	"Super Metronome": "impact",
	"Super Poison Breath": "veil",
	"Super Psy": "pulse",
	"Super Psy Bolt": "bolt",
	"Super Psywave": "pulse",
	"Super Regeneration": "drain",
	"Super Removal": "torrent",
	"Super Sand Attack": "sand",
	"Super Sandstorm": "sand",
	"Super Singe": "flame",
	"Super Slap Push": "impact",
	"Super Slash": "slash",
	"Super Slice": "slash",
	"Super Speed": "impact",
	"Super Spicy Breath": "breath",
	"Super Splash": "torrent",
	"Super Thunder Wave": "torrent",
	"Super Tidal Wave": "torrent",
	"Super Vibration": "roar",
	"Super Zap Cannon": "bolt",
	"Superalloy Hands": "bolt",
	"Superb Scissors": "slash",
	"Superb Shield": "shield",
	"Superbeam": "beam",
	"Supernatural": "veil",
	"Supernatural Dance": "whirl",
	"Supernatural Feather": "wing",
	"Supernatural Flames": "flame",
	"Supernatural Power": "veil",
	"Supernatural Shapeshifter": "flame",
	"Superpower": "quake",
	"Superpowered Horns": "drill",
	"Superpowered Hug": "impact",
	"Superpowered Throw": "quake",
	"Supersonic": "sonic",
	"Supersonic Claws": "slash",
	"Supersonic Flight": "sonic",
	"Supersonic Jab": "sonic",
	"Superstrong Slash": "slash",
	"Supplemental Swallow-Up": "torrent",
	"Supportive Singing": "drain",
	"Suppression": "drain",
	"Supreme Blast": "boom",
	"Supreme Puff-GX": "sparkle",
	"Surefire Spin": "flame",
	"Surf": "wave",
	"Surf Back": "wave",
	"Surf Together": "wave",
	"Surge": "impact",
	"Surging Flames": "flame",
	"Surprise": "impact",
	"Surprise Attack": "bloom",
	"Surprise Fist": "fist",
	"Surprise Pump": "torrent",
	"Surprise Punch": "fist",
	"Surprise Short": "bolt",
	"Surprise Slash": "slash",
	"Surprise Strike": "impact",
	"Surprise Thunder": "bolt",
	"Surprising Hand": "torrent",
	"Surprising Pattern": "bloom",
	"Surround": "pulse",
	"Survival Strategy": "roar",
	"Suspicious Beam β": "beam",
	"Suspicious Gas": "powder",
	"Suspicious Soundwave": "torrent",
	"Swaddle Guard": "shield",
	"Swagger": "veil",
	"Swallow": "impact",
	"Swallow Dive": "torrent",
	"Swallow Up": "bloom",
	"Swarm": "veil",
	"Swarm the Wound": "torrent",
	"Swarming Bites": "bite",
	"Swarming Rage": "rage",
	"Swarming Sting": "sting",
	"Swaying Dance": "whirl",
	"Sweep Away": "torrent",
	"Sweep the Leg": "quake",
	"Sweeping Billow": "roar",
	"Sweeping Cure": "drain",
	"Sweeping Tackle": "impact",
	"Sweet Circle": "pulse",
	"Sweet Impact": "impact",
	"Sweet Kiss": "kiss",
	"Sweet Nectar": "drain",
	"Sweet Palm": "impact",
	"Sweet Panic": "sparkle",
	"Sweet Saliva": "bloom",
	"Sweet Scent": "powder",
	"Sweet Spike": "sting",
	"Sweet Splash": "torrent",
	"Sweet Temptation": "torrent",
	"Sweets Overload": "pulse",
	"Sweets Relay": "pulse",
	"Swelling Light": "sparkle",
	"Swelling Power": "quake",
	"Swelling Pulse": "pulse",
	"Swelling Scent": "powder",
	"Swelling Wish": "drain",
	"Swift": "swift",
	"Swift Blow": "swift",
	"Swift Bolt Strike": "swift",
	"Swift Dive": "swift",
	"Swift Flight": "swift",
	"Swift Lunge": "swift",
	"Swift Run-GX": "swift",
	"Swift Sting": "swift",
	"Swift Swing": "swift",
	"Swift Turn": "swift",
	"Swim": "torrent",
	"Swim Freely": "torrent",
	"Swim Together": "torrent",
	"Swing and Skedaddle": "impact",
	"Swing Around": "impact",
	"Swinging Chain": "bloom",
	"Swinging Smash": "quake",
	"Swinging Sphene": "roar",
	"Swipe": "veil",
	"Swirling Disaster": "veil",
	"Swirling Flow": "bolt",
	"Swirling Inferno": "flame",
	"Swirling Petals": "sparkle",
	"Swirling Ripple": "bloom",
	"Swirling Slice": "slash",
	"Swirling Tail": "tail",
	"Swirling Waves": "torrent",
	"Swirly Rush": "impact",
	"Switch Cannon": "cannon",
	"Switcheroo": "impact",
	"Switching Bolt": "bolt",
	"Swoop Across": "impact",
	"Sword of Dawn": "slash",
	"Sword Star": "slash",
	"Swords Dance": "slash",
	"Symbiont-GX": "pulse",
	"Sympathetic Slap": "impact",
	"Symphony Whip": "slash",
	"Synchro Attack": "pulse",
	"Synchro Buster": "quake",
	"Synchro Dance": "whirl",
	"Synchro Gain": "torrent",
	"Synchro Hammer": "fist",
	"Synchro Kinesis": "pulse",
	"Synchro Loud": "roar",
	"Synchro Punch": "fist",
	"Synchro Removal": "impact",
	"Synchro Shot": "cannon",
	"Synchro Star": "swift",
	"Synchro Woofer": "roar",
	"Synchrodraw": "pulse",
	"Synchronize": "pulse",
	"Synchronized Feathers": "impact",
	"Synchronized Search": "pulse",
	"Synchronoise": "torrent",
	"Syncroblast": "boom",
	"Synthesis": "drain",
	"Syrup Catcher": "roar",
	"Syrup Storm": "whirl",
	"Tackle": "impact",
	"Tactful Tangling": "bloom",
	"Tag Bolt-GX": "bolt",
	"Tag Cheer": "quake",
	"Tag Draw": "bolt",
	"Tag Impact": "impact",
	"Tag Play —": "bolt",
	"Tag Purge": "pulse",
	"Tag Team Boost": "bolt",
	"Tag Team Spark": "bolt",
	"Tail Bite": "bite",
	"Tail Blade": "slash",
	"Tail Break-GX": "tail",
	"Tail Charge": "tail",
	"Tail Code": "tail",
	"Tail Crush": "tail",
	"Tail Fan": "tail",
	"Tail-Fishing": "tail",
	"Tail Generator": "tail",
	"Tail Influence": "tail",
	"Tail Jab": "tail",
	"Tail Lure": "tail",
	"Tail on Fire": "flame",
	"Tail Punch": "fist",
	"Tail Rap": "tail",
	"Tail Revenge": "tail",
	"Tail Shake": "tail",
	"Tail Shock": "bolt",
	"Tail Slap": "tail",
	"Tail Smack": "tail",
	"Tail Smash": "quake",
	"Tail Snap": "tail",
	"Tail Spank": "tail",
	"Tail Sting": "sting",
	"Tail Strike": "tail",
	"Tail Swap": "tail",
	"Tail Swing": "tail",
	"Tail Trickery": "tail",
	"Tail Wag": "tail",
	"Tail Whap": "tail",
	"Tail Whip": "tail",
	"Tail Wrap": "wrap",
	"Tailspin Away": "impact",
	"Tailspin Piledriver": "shard",
	"Tailwind": "whirl",
	"Tailwind Draw": "whirl",
	"Tainted Horn": "drill",
	"Take Away": "pulse",
	"Take Back": "pulse",
	"Take Down": "impact",
	"Take It Easy": "drain",
	"Take Out": "quake",
	"Talon Hunt": "impact",
	"Tandem Shock": "bolt",
	"Tangle Drag": "bloom",
	"Tantailizing": "pulse",
	"Tantrum": "rage",
	"Tantrum Blast": "rage",
	"Tapu Cure-GX": "drain",
	"Tapu Storm-GX": "whirl",
	"Tapu Thunder-GX": "bolt",
	"Tapu Wilderness-GX": "bloom",
	"Tar Cannon": "cannon",
	"Target Attack": "drain",
	"Target Beam": "beam",
	"Target Scorch": "flame",
	"Target Slash": "slash",
	"Target Together": "impact",
	"Targeted Bolt": "bolt",
	"Targeted Dive": "torrent",
	"Targeted Skewer": "drain",
	"Targeted Spark": "bolt",
	"Taunt": "veil",
	"Tea Server": "bloom",
	"Team Assembly": "torrent",
	"Team Attack": "quake",
	"Team Hunt": "veil",
	"Team Play": "quake",
	"Teampact": "impact",
	"Tearing Gust": "whirl",
	"Teary Attack": "quake",
	"Teary Eyes": "daze",
	"Teatime": "pulse",
	"Techno Blast": "boom",
	"Techno Turbo": "bolt",
	"Teeter Punch": "fist",
	"Teetering Steps": "impact",
	"Telebeam": "beam",
	"Telekinesis": "pulse",
	"Telekinesis of Nobility": "pulse",
	"Teleport": "pulse",
	"Teleport Blast": "boom",
	"Teleportation Attack": "pulse",
	"Teleportation Burst": "boom",
	"Tempest Dive": "torrent",
	"Tempest-GX": "roar",
	"Temporal Backflow": "shard",
	"Temporal Leaves": "bloom",
	"Temporal Rupture": "shard",
	"Tempt": "impact",
	"Tempting Eyes": "daze",
	"Tempting Trap": "wrap",
	"Ten-Card Return-GX": "bloom",
	"Tenacious Defense": "bloom",
	"Tenacious Hammer": "fist",
	"Tenacious Tail": "tail",
	"Tender Tentacles": "wrap",
	"Tender Vengeance": "impact",
	"Tentacle Buster": "wrap",
	"Tentacle Grip": "wrap",
	"Tentacle Lock": "wrap",
	"Tentacle Strike": "wrap",
	"Tentacle Wrap": "wrap",
	"Tentacular Panic": "torrent",
	"Tentacular Return": "torrent",
	"Tentavolve": "torrent",
	"Teraspark": "bolt",
	"Terminal Period": "drain",
	"Terminating Tail": "tail",
	"Terrific Thumping": "shard",
	"Terrify": "pulse",
	"Territorial Strike": "impact",
	"Terror Strike": "impact",
	"Terrorize": "impact",
	"Texture Magic": "impact",
	"The Hula-la": "daze",
	"The Third Eye": "daze",
	"The Wages of Fluff": "sparkle",
	"Thermal Blast": "boom",
	"Thermal Gust": "whirl",
	"Thick Liquid": "torrent",
	"Thick Mucus": "roar",
	"Thick Poison": "veil",
	"Thief": "veil",
	"Thieving Swipe": "veil",
	"Third Eye": "daze",
	"Thorn Pod Throw": "quake",
	"Thorny Eruption": "flame",
	"Thorough Crunch": "bite",
	"Thrash": "rage",
	"Thrash Metal": "rage",
	"Thrash Tackle": "rage",
	"Threaten": "shard",
	"Threaten and Drop": "torrent",
	"Threatening Pattern": "bloom",
	"Three Kick Combo": "kick",
	"Three Mirrors": "bolt",
	"Three-Step Strike": "impact",
	"Three Strikes": "torrent",
	"Thrilling Times-GX": "torrent",
	"Throw Off": "quake",
	"Thrust": "quake",
	"Thudding Press": "impact",
	"Thump-Thump Boom": "boom",
	"Thumpalanche": "quake",
	"Thumping Fall": "shard",
	"Thumping Snore": "sleep",
	"Thunder": "bolt",
	"Thunder Attack": "bolt",
	"Thunder Blast": "bolt",
	"Thunder Claws": "slash",
	"Thunder Climb": "bolt",
	"Thunder Fall": "bolt",
	"Thunder Fang": "bolt",
	"Thunder Flare": "flame",
	"Thunder Force": "bolt",
	"Thunder Gift": "bolt",
	"Thunder Jolt": "bolt",
	"Thunder Jolt Beam": "beam",
	"Thunder Lance": "bolt",
	"Thunder Nail": "bolt",
	"Thunder Needle": "bolt",
	"Thunder Punch": "bolt",
	"Thunder Raid": "bolt",
	"Thunder Reflection": "bolt",
	"Thunder Rod": "bolt",
	"Thunder Shock": "bolt",
	"Thunder Shot": "bolt",
	"Thunder Slash": "slash",
	"Thunder Snipe": "bolt",
	"Thunder Spear": "bolt",
	"Thunder Tempest": "bolt",
	"Thunder Throw": "bolt",
	"Thunder Wave": "torrent",
	"Thunderbolt": "bolt",
	"Thunderbolt Spear": "bolt",
	"Thunderburst Storm": "bolt",
	"Thunderclap Shot": "bolt",
	"Thunderclaw": "bolt",
	"Thundering Hurricane": "bolt",
	"Thundering Hurricane-GX": "bolt",
	"Thundering Volcano": "bolt",
	"Thunderous Assault": "bolt",
	"Thunderous Blow": "bolt",
	"Thunderous Bolt": "bolt",
	"Thunderous Claw": "slash",
	"Thunderous Edge": "bolt",
	"Thunderous Fist": "fist",
	"Thunderous Gale": "bolt",
	"Thunderous Kick": "kick",
	"Thunderous Noise": "bolt",
	"Thunderous Rain-GX": "bolt",
	"Thunderous Roar": "sonic",
	"Thunderous Snore": "bolt",
	"Thunderous Tornado": "bolt",
	"Thunderpunch": "bolt",
	"Thundershock": "bolt",
	"Thunderspark": "bolt",
	"Thundersquall": "bolt",
	"Thunderstorm": "bolt",
	"Thunderstrike Tail": "bolt",
	"Thundertackle": "bolt",
	"Ticking Curse": "veil",
	"Ticking Knock Out": "pulse",
	"Ticking Terror": "veil",
	"Tickle": "impact",
	"Tickling Vines": "bloom",
	"Tidal Blast": "boom",
	"Tidal Storm": "whirl",
	"Tidal Wave": "torrent",
	"Tie Up": "quake",
	"Tiger Swing": "impact",
	"Tight Jaw": "bite",
	"Tighten Up": "veil",
	"Timber Cleave": "quake",
	"Time Bellow": "shard",
	"Time Call": "bloom",
	"Time Circle": "bloom",
	"Time Control": "torrent",
	"Time Distortion": "bloom",
	"Time Freeze": "frost",
	"Time Hollow": "pulse",
	"Time Manipulation": "roar",
	"Time Mash": "shard",
	"Time Out Kick": "kick",
	"Time Rewind": "shard",
	"Time Shift": "shard",
	"Time-Space Traveling": "shard",
	"Time Spiral": "whirl",
	"Time Trap": "wrap",
	"Time Wager": "shard",
	"Timeless-GX": "roar",
	"Timid Tackle": "impact",
	"Tingle": "torrent",
	"Tingly Return-GX": "bolt",
	"Tiny Bolt": "bolt",
	"Tiny Charge": "zap",
	"Tiny Punch": "fist",
	"Tiptoe Step": "pulse",
	"TLC": "drain",
	"Toasty Toss": "quake",
	"Toge Dash": "impact",
	"Toge Spark": "bolt",
	"Tomb Hunt-GX": "pulse",
	"Tone-Deaf": "daze",
	"Tongue Pull": "impact",
	"Tongue Reel": "bolt",
	"Tongue Slap": "impact",
	"Tongue Smack": "impact",
	"Tongue Spring": "pulse",
	"Tongue Stretch": "impact",
	"Tongue-Tied": "impact",
	"Tongue Whip": "slash",
	"Tongue Wrap": "wrap",
	"Tonguenado": "impact",
	"Tonnage": "quake",
	"Tons of Treading": "bloom",
	"Tool Breaker": "impact",
	"Tool Buster": "impact",
	"Tool Drop": "shard",
	"Top Burner": "flame",
	"Top Chop": "chop",
	"Top Down": "quake",
	"Top Drop": "quake",
	"Topaz Bolt": "bolt",
	"Torcherto": "flame",
	"Torment": "veil",
	"Tormenting Poison": "veil",
	"Tornado Kick": "kick",
	"Tornado Rush": "whirl",
	"Tornado Shot": "cannon",
	"Torpedo Dive": "torrent",
	"Torrent Blade": "slash",
	"Torrential Cannon": "cannon",
	"Torrential Pump": "torrent",
	"Torrential Slash": "slash",
	"Torrential Vortex": "torrent",
	"Torrid Torrent": "flame",
	"Toss": "quake",
	"Toss and Turn": "quake",
	"Toss-and-Turn Press": "quake",
	"Toss Aside": "quake",
	"Total Command": "torrent",
	"Total Shelter-GX": "pulse",
	"Touchdown": "bloom",
	"Tough Hammer": "fist",
	"Tough Swing": "impact",
	"Touring": "impact",
	"Tower-Go-Round-GX": "note",
	"Towering Splash-GX": "torrent",
	"Toxfire Fang": "flame",
	"Toxic": "veil",
	"Toxic Claws": "slash",
	"Toxic Cloud": "veil",
	"Toxic Drill": "drill",
	"Toxic Dust": "veil",
	"Toxic Fang": "bite",
	"Toxic Grip": "veil",
	"Toxic Ripper": "veil",
	"Toxic Saliva": "veil",
	"Toxic Secretion": "veil",
	"Toxic Sleep": "sleep",
	"Toxic Spikes": "veil",
	"Toxic Spore": "powder",
	"Toxic Sting": "sting",
	"Toxic Strike": "veil",
	"Toxic Teeth": "veil",
	"Toxic Throw": "quake",
	"Toxic Vibration": "veil",
	"Toxic Whip": "veil",
	"Toy Box-GX": "sparkle",
	"Trace": "impact",
	"Tracking Shot": "cannon",
	"Tractorbeam": "beam",
	"Trading Places": "pulse",
	"Training": "quake",
	"Trample": "veil",
	"Trans Tail": "tail",
	"Transback": "torrent",
	"Transfer Break": "pulse",
	"Transfer Charge": "impact",
	"Transfer Junk": "impact",
	"Transfer Pain": "drain",
	"Trap Bolt": "bolt",
	"Trapping Bite": "bite",
	"Trapping Thread": "web",
	"Trash Bolt": "bolt",
	"Trash Burst": "boom",
	"Trash Charge": "impact",
	"Trash Cloak Tackle": "impact",
	"Trash Crash": "impact",
	"Trash Cyclone": "whirl",
	"Trash Slash": "slash",
	"Trash Stench": "veil",
	"Trash Tentacle": "wrap",
	"Trashalanche": "pulse",
	"Traverse Time": "bloom",
	"Tread On": "bloom",
	"Treasure Rush": "impact",
	"Tree Climb": "bloom",
	"Tree Slam": "impact",
	"Trembler": "bolt",
	"Trembling Ground": "quake",
	"Tremor": "quake",
	"Tremulous Fist": "fist",
	"Tri Attack": "tri",
	"Tri Bullet": "cannon",
	"Tri Edge": "slash",
	"Tri Hazard-GX": "bolt",
	"Tri Kinesis": "pulse",
	"Tri Power": "pulse",
	"Tri Recharge": "pulse",
	"Trials and Trip-ulations": "quake",
	"Trick": "sparkle",
	"Trick Cape": "bloom",
	"Trick Gas": "powder",
	"Trick Play": "pulse",
	"Trick Portal": "flame",
	"Trick Room": "pulse",
	"Trick Sticker": "bolt",
	"Trick Tail": "tail",
	"Trick Wind": "whirl",
	"Trickle": "torrent",
	"Trickster-GX": "veil",
	"Tricky Ribbon": "pulse",
	"Tricky Slap": "impact",
	"Tricky Steps": "pulse",
	"Tricolor Pump": "torrent",
	"Trifrost": "roar",
	"Trigger Avalanche": "fall",
	"Triggered Poison": "veil",
	"Trimming Mower": "bloom",
	"Trinity Burn": "flame",
	"Trinity Charge": "impact",
	"Trinity Nova": "impact",
	"Trinity Star": "swift",
	"Trio-Cheehoo": "shard",
	"Trip Over": "bloom",
	"Triple Axel": "barrage",
	"Triple Bombardment": "barrage",
	"Triple Bone": "barrage",
	"Triple Breach": "barrage",
	"Triple Cannon": "barrage",
	"Triple Charge": "barrage",
	"Triple Cutter": "slash",
	"Triple Draw": "barrage",
	"Triple Energy": "barrage",
	"Triple Gnawing": "barrage",
	"Triple Headbutt": "barrage",
	"Triple Heads": "barrage",
	"Triple Kick": "kick",
	"Triple Laser": "barrage",
	"Triple Needle": "barrage",
	"Triple Nose": "barrage",
	"Triple Pick": "barrage",
	"Triple Poison": "barrage",
	"Triple Slap": "barrage",
	"Triple Smash": "barrage",
	"Triple Spin": "barrage",
	"Triple Stab": "slash",
	"Triple Strike": "barrage",
	"Triple Whip": "barrage",
	"Triplet Headbutt": "impact",
	"Tripping Headbutt": "impact",
	"Tripping Shot": "cannon",
	"Tripping Turn": "daze",
	"Tromp": "quake",
	"Trop Kick": "kick",
	"Tropic Breeze": "bloom",
	"Tropical Frenzy": "roar",
	"Tropical Hammer": "fist",
	"Tropical Head": "impact",
	"Tropical Hour-GX": "bloom",
	"Tropical Shake": "bloom",
	"Tropical Swing": "impact",
	"Try Bouncing": "impact",
	"Try to Imitate": "quake",
	"Tsunami": "torrent",
	"Tuck Tail": "tail",
	"Tumble Down": "quake",
	"Tumble Over": "impact",
	"Tumbling Attack": "bolt",
	"Tumbling Tackle": "impact",
	"Tuning": "roar",
	"Tunnel Strike": "impact",
	"Tunneling": "quake",
	"Turbo Arm": "shard",
	"Turbo Assault": "quake",
	"Turbo Bolt": "bolt",
	"Turbo Drive": "impact",
	"Turbo Edge": "slash",
	"Turbo Energize": "flame",
	"Turbo Flame": "flame",
	"Turbo Flare": "flame",
	"Turbo Shark": "torrent",
	"Turbo Storm": "whirl",
	"Turbo Strike": "impact",
	"Turbulent Wings": "wing",
	"Turf Maker": "quake",
	"Turf Raid": "veil",
	"Turmoil Strike": "impact",
	"Turn a Profit": "impact",
	"Turn Back Time": "shard",
	"Turn the Tables": "quake",
	"Turnaround Standby": "shard",
	"Turning Point": "pulse",
	"Tusk Toss": "quake",
	"Twiddle": "sleep",
	"Twilight-GX": "sparkle",
	"Twilight Inspiration": "torrent",
	"Twilight Poison": "veil",
	"Twin-blade": "slash",
	"Twin Bursts": "flame",
	"Twin Cannons": "torrent",
	"Twin Grapple": "sparkle",
	"Twin Play": "bloom",
	"Twin Shotels": "pulse",
	"Twineedle": "bloom",
	"Twinkle": "sleep",
	"Twinkle Gathering": "impact",
	"Twinkling Hope": "pulse",
	"Twinkly Call": "pulse",
	"Twirling Sign": "torrent",
	"Twister": "impact",
	"Twister Kick": "kick",
	"Twister Lutz": "bloom",
	"Twister Shuriken": "torrent",
	"Twister Spewing": "wing",
	"Twister Throw": "quake",
	"Twisting Strike": "impact",
	"Two Bump Bolt": "bolt",
	"Two Four-ocious": "pulse",
	"Two-Headed Crushing": "bloom",
	"Two-Hit KO": "impact",
	"Type Match": "impact",
	"Type Switch": "impact",
	"Tyrannical Crush": "impact",
	"Tyrannical Fang": "bite",
	"Tyrannical Hole": "veil",
	"Tyrannical Tail": "tail",
	"U-turn": "bloom",
	"Ultimate Arrow": "arrow",
	"Ultimate Blade": "slash",
	"Ultimate Force": "impact",
	"Ultimate Ray": "beam",
	"Ultra Energy Source": "impact",
	"Ultra Evolution": "roar",
	"Ultra Powder": "powder",
	"Ultra Pump": "torrent",
	"Ultra-Toxic Fang": "bite",
	"Ultra Uppercut-GX": "fist",
	"Unamplified Soundwave": "pulse",
	"Unarmed": "pulse",
	"Under Pressure": "bolt",
	"Undermine": "shard",
	"Undersea Tunnel": "torrent",
	"Underwater Dive": "torrent",
	"Underworld Stroll": "pulse",
	"Undulate": "torrent",
	"Undulating Slice": "slash",
	"Unfair-GX": "veil",
	"Unhinged Hammer": "fist",
	"Unhinged Scissors": "slash",
	"Unified Beatdown": "impact",
	"Union Gain": "bolt",
	"United Thunder": "bolt",
	"United Wings": "wing",
	"Unleash Lightning": "bolt",
	"Unlock": "shard",
	"Unrelenting Onslaught": "quake",
	"Unseen Claw": "slash",
	"Unstoppable Roll": "gyro",
	"Untamed Punch": "fist",
	"Unwavering Blade": "slash",
	"Unyielding Rock": "meteor",
	"Upper Hand": "pulse",
	"Upper Shock": "bolt",
	"Upper Spark": "bolt",
	"Uproar": "sonic",
	"Upside-Down Draw": "bloom",
	"Upstream": "impact",
	"Upstream Spirits": "torrent",
	"Upthrow": "quake",
	"Upthrusting Horns": "drill",
	"Upward Kick": "kick",
	"Upward Lick": "lick",
	"V-Beatdown": "impact",
	"V-blast": "boom",
	"V Bullet": "cannon",
	"V-create": "flame",
	"V-Flame": "flame",
	"V-Force": "flame",
	"Vacuum Bolt": "bolt",
	"Vacuum Sand": "sand",
	"Vacuum Up": "quake",
	"Vacuum Wave": "aura",
	"Valiant Evolution": "torrent",
	"Valiant Talons": "impact",
	"Vanguard Punch": "fist",
	"Vanish": "pulse",
	"Vanishing Strike": "impact",
	"Vapor Kick": "kick",
	"Vaporize": "flame",
	"Vee Brave": "impact",
	"Vee-Search": "impact",
	"Veil of Darkness": "veil",
	"Vengeance": "impact",
	"Vengeance Fletching": "veil",
	"Vengeful Anchor": "pulse",
	"Vengeful Cannon": "cannon",
	"Vengeful Crush": "impact",
	"Vengeful Cut": "slash",
	"Vengeful Fang": "bite",
	"Vengeful Flame": "flame",
	"Vengeful Kick": "kick",
	"Vengeful Shock": "bolt",
	"Vengeful Spikes": "pulse",
	"Vengeful Stomp": "impact",
	"Vengeful Wish": "drain",
	"Venom Fever": "torrent",
	"Venom Powder": "powder",
	"Venom Shot": "cannon",
	"Venom Slap": "impact",
	"Venom Tail": "tail",
	"Venomous Fang": "bite",
	"Venomous Hit": "impact",
	"Venomous Horn": "drill",
	"Venomous Impact": "impact",
	"Venomous Slash": "slash",
	"Venoshock": "acid",
	"Venting Anger": "torrent",
	"Verdant Dance": "whirl",
	"Verdant Storm": "whirl",
	"Verdict-GX": "quake",
	"Vermilion-GX": "flame",
	"Version Update": "impact",
	"Very Vulnerable": "quake",
	"Vibration": "torrent",
	"Vice Grip": "shard",
	"Vicious Claw": "slash",
	"Victory Ball": "aura",
	"Victory Dive": "torrent",
	"Victory Flame": "flame",
	"Victory Sign": "flame",
	"Victory Symbol": "pulse",
	"Vigorous Dash": "impact",
	"Vigorous Kick": "kick",
	"Vigorous Tackle": "impact",
	"Vile Smell": "bloom",
	"Vilify": "veil",
	"Vine Bind": "bloom",
	"Vine Extract": "bloom",
	"Vine Invite": "bloom",
	"Vine Slap": "bloom",
	"Vine Tease": "bloom",
	"Vine Whip": "bloom",
	"Violent Rage": "rage",
	"Virtuous Flame": "flame",
	"Vise Bite": "bite",
	"Vise Grip": "torrent",
	"Vise Wave": "torrent",
	"Vital Drain": "drain",
	"Vital Pinchers": "torrent",
	"Vital Powder": "powder",
	"Vital Throw": "quake",
	"Vitality Song": "note",
	"Vivid Charge": "impact",
	"Vivid Powder": "powder",
	"Void Gale": "whirl",
	"Void Return": "impact",
	"Void Tentacles": "wrap",
	"Volcanic Ash": "flame",
	"Volcanic Crash": "impact",
	"Volcanic Flame": "flame",
	"Volcanic Heat": "flame",
	"Volcanic Kaboom": "flame",
	"Volcanic Meteor": "meteor",
	"Volcano Stomp": "impact",
	"Volley Kick": "kick",
	"Volt Bolt": "bolt",
	"Volt Crush": "bolt",
	"Volt Cyclone": "bolt",
	"Volt Knuckle": "fist",
	"Volt Strike": "bolt",
	"Volt Switch": "bolt",
	"Volt Tackle": "bolt",
	"Volt Wave": "torrent",
	"Voltage Burst": "boom",
	"Voltage Claw": "slash",
	"Voltage Dive": "torrent",
	"Voltage Rush": "impact",
	"Voltage Shoot": "bolt",
	"Voltage Storm": "whirl",
	"Voltaic Bullet": "cannon",
	"Voltaic Chain": "bolt",
	"Voltaic Fist": "fist",
	"Voltail-GX": "bolt",
	"Vortex Chop": "chop",
	"Vortex of Darkness": "veil",
	"Vortex of Pain": "pulse",
	"Vulcan Beat": "impact",
	"Vulture Claw": "slash",
	"Wail": "impact",
	"Wake-up Beam": "beam",
	"Wake-up Punch": "fist",
	"Wake-Up Slap": "impact",
	"Walk-Off Homer": "torrent",
	"Wander About": "bloom",
	"War Cry": "roar",
	"Warble": "impact",
	"Warm Up": "flame",
	"Warning": "pulse",
	"Warp Hole": "pulse",
	"Warp Sounds": "pulse",
	"Wash Arrow": "arrow",
	"Wash Away": "drain",
	"Wash Over": "torrent",
	"Wash the Slate Clean": "torrent",
	"Watch and Learn": "quake",
	"Watcheck": "impact",
	"Water Arrow": "arrow",
	"Water Ball": "torrent",
	"Water Bullet": "torrent",
	"Water Cannon": "torrent",
	"Water Drip": "torrent",
	"Water Duplicates": "torrent",
	"Water Fling": "torrent",
	"Water Glow": "torrent",
	"Water Gun": "torrent",
	"Water Kagura": "torrent",
	"Water of Evolution": "torrent",
	"Water Plant": "torrent",
	"Water Pulse": "torrent",
	"Water Punch": "torrent",
	"Water Reserve": "torrent",
	"Water Ring": "torrent",
	"Water's Power": "torrent",
	"Water Shot": "torrent",
	"Water Slash": "slash",
	"Water Slide": "torrent",
	"Water Spash": "torrent",
	"Water Splash": "torrent",
	"Water Sport": "torrent",
	"Water Spray": "torrent",
	"Water Vein": "torrent",
	"Waterfall": "wave",
	"Waterfall Blind": "wave",
	"Waterfall Evolution": "wave",
	"Watering": "torrent",
	"Wave Amplification": "torrent",
	"Wave Splash": "torrent",
	"Wave Summoning": "torrent",
	"Wave Swallower": "torrent",
	"Wavelet": "torrent",
	"Weak Kneed": "impact",
	"Weaponized Swords": "slash",
	"Weather Ball": "aura",
	"Weather Force": "impact",
	"Weather Teller": "impact",
	"Welcoming Tail": "tail",
	"Wellspring Dance": "whirl",
	"Wet Claw": "slash",
	"Whale Pump": "torrent",
	"Wham Bam Punch": "fist",
	"Whap Down": "impact",
	"Wheel Pass": "shard",
	"Wheely Draw": "veil",
	"Whimsy Draw": "impact",
	"Whimsy Tackle": "impact",
	"Whiny Voice": "pulse",
	"Whip Expert": "slash",
	"Whip Smash": "quake",
	"Whiplash": "bloom",
	"Whipped Shot": "cannon",
	"Whirling Envy": "whirl",
	"Whirlpool": "torrent",
	"Whirltide": "whirl",
	"Whirlwind": "whirl",
	"Whisk Away": "bloom",
	"Whismy Tackle": "impact",
	"White Blaze": "flame",
	"White Drop": "torrent",
	"White Flames": "flame",
	"White-hot Flame": "flame",
	"White Inferno": "flame",
	"White Noise": "bloom",
	"White Ray": "beam",
	"White Snow": "frost",
	"White Thunder": "bolt",
	"White Wind": "whirl",
	"Whump": "quake",
	"Wicked Impact": "impact",
	"Wicked Jab": "quake",
	"Wicked Tentacles": "wrap",
	"Wicked Thunder": "bolt",
	"Wicked Wind": "whirl",
	"Wide Blast": "boom",
	"Wide Laser": "beam",
	"Wide Solarbeam": "beam",
	"Wide Wing": "wing",
	"Wiggle": "acid",
	"Wild Axe": "slash",
	"Wild Barking": "impact",
	"Wild Blaze": "flame",
	"Wild Charge": "zap",
	"Wild Crash": "impact",
	"Wild Dive": "torrent",
	"Wild Dive-GX": "torrent",
	"Wild Drift": "shard",
	"Wild Edge": "slash",
	"Wild Freeze": "frost",
	"Wild Fury": "barrage",
	"Wild Horn": "drill",
	"Wild Impact": "impact",
	"Wild Kick": "kick",
	"Wild Lances": "shard",
	"Wild Press": "impact",
	"Wild River": "torrent",
	"Wild Scissors": "slash",
	"Wild Shock": "bolt",
	"Wild Spin": "whirl",
	"Wild Splash": "torrent",
	"Wild Spores": "powder",
	"Wild Swing": "impact",
	"Wild Tackle": "impact",
	"Wild Tail": "tail",
	"Wild Waves": "quake",
	"Wild Whip": "slash",
	"Wildfire": "flame",
	"Wildly Writhe": "bloom",
	"Will-o'-the-wisp": "wisp",
	"Will-O-Wisp": "wisp",
	"Willful Busybody": "impact",
	"Willpower": "drain",
	"Wily Bite": "bite",
	"Wind Blast": "boom",
	"Wind of Darkness": "veil",
	"Wind Power Charge": "whirl",
	"Wind Pressure": "whirl",
	"Wind Return": "whirl",
	"Wind Shard": "whirl",
	"Wind Wave": "torrent",
	"Wind Wheel": "whirl",
	"Wind Whisk": "whirl",
	"Windfall": "impact",
	"Windmill": "bloom",
	"Windmill Kick": "kick",
	"Windup Beam": "beam",
	"Windup Cannon": "cannon",
	"Windup Swing": "impact",
	"Windup Thunder": "bolt",
	"Windy Mischief": "drain",
	"Wing Attack": "wing",
	"Wing Dance": "wing",
	"Wing Flick": "wing",
	"Wings of Destruction": "boom",
	"Wings of Disaster": "wing",
	"Wings of the Moone": "wing",
	"Wink Wink": "sparkle",
	"Winter Horn": "drill",
	"Wintry Call": "torrent",
	"Wire Hang": "bloom",
	"Wise Guidance": "pulse",
	"Wise Headbutt": "impact",
	"Wish": "drain",
	"Withdraw": "shell",
	"Wonder Blast": "boom",
	"Wonder Bomb": "boom",
	"Wonder Flare": "flame",
	"Wonder Flash": "sparkle",
	"Wonder Ray": "beam",
	"Wonder Shine": "pulse",
	"Wonder Stage": "sparkle",
	"Wonder Storm": "whirl",
	"Wonder Trick": "pulse",
	"Wondrous Cotton": "bloom",
	"Wondrous Moon": "sparkle",
	"Wondrous Shot": "cannon",
	"Wondrous Waves": "torrent",
	"Wood Blast": "bloom",
	"Wood Drain": "drain",
	"Wood Hammer": "fist",
	"Word of Ruin": "veil",
	"Work": "bloom",
	"Work Rush": "impact",
	"Work Together": "torrent",
	"Work Up": "impact",
	"World Ender": "roar",
	"World Wrecker": "quake",
	"Wormhole": "torrent",
	"Worry Seed": "bloom",
	"Worst Gift": "pulse",
	"Wrack Down": "veil",
	"Wrap": "wrap",
	"Wrap-GX": "wrap",
	"Wrapped in Wind": "whirl",
	"Wrathful Blade": "slash",
	"Wrathful Charge": "impact",
	"Wrathful Hearth": "flame",
	"Wreak Havoc": "shard",
	"Wreck": "quake",
	"Wriggle": "torrent",
	"Wring Out": "wrap",
	"X Ball": "aura",
	"X Blast": "boom",
	"X-Scissor": "slash",
	"Y Cyclone": "whirl",
	"Yank Away": "bolt",
	"Yank Out": "impact",
	"Yawn": "sleep",
	"Yoga Kick": "kick",
	"Yoga Loop": "drain",
	"Yoga Shock": "bolt",
	"Zap Cannon": "bolt",
	"Zap Kick": "kick",
	"Zap Traction": "bolt",
	"Zapper Kick": "kick",
	"Zapping Bullet": "cannon",
	"Zapping Draw": "bolt",
	"Zapping Short": "bolt",
	"Zappy Pom-Poms": "bolt",
	"Zappy Shot": "cannon",
	"Zen Blade": "slash",
	"Zen Force": "pulse",
	"Zen Headbutt": "impact",
	"Zen Shard": "pulse",
	"Zen Shot": "cannon",
	"Zen Spoon": "drain",
	"Zepto Turn": "bolt",
	"Zero Vanish-GX": "roar",
	"Zing Zap": "bolt",
	"Zircon Road": "impact",
	"Zone Shift": "torrent",
	"Zone Smash": "quake",
	"Zzzap": "bolt",
	"Zzzap Touch": "sparkle",
	"Zzzt": "bloom",
};

export function foldAttackName(name: string): string {
	const folded = String(name || '').normalize('NFKD').toLowerCase();
	let words = '';
	let cur = '';
	for (let i = 0; i < folded.length; i++) {
		const code = folded.charCodeAt(i);
		if (code >= 0x300 && code <= 0x36f) continue;
		const ch = folded.charAt(i);
		if ((ch >= 'a' && ch <= 'z') || (ch >= '0' && ch <= '9')) {
			cur += ch;
		} else if (cur) {
			words += (words ? ' ' : '') + cur;
			cur = '';
		}
	}
	if (cur) words += (words ? ' ' : '') + cur;
	return words || String(name || '').trim().toLowerCase();
}

const attackHitByFold: { [name: string]: AttackHitStyle } = {};
for (const name in ATTACK_HIT) {
	attackHitByFold[foldAttackName(name)] = ATTACK_HIT[name];
}

export function lookupAttackHit(name: string): AttackHitStyle | undefined {
	if (!name) return undefined;
	return attackHitByFold[foldAttackName(name)];
}
